/* tslint:disable */
/* eslint-disable */
/**
 * MWS.CatalogService.WebApp | v2-public
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AddClaimsToCollectionRequest {
    'claimIds': Array<string>;
}
export interface AiGenerated {
    'description': boolean;
}
export interface AmpEvent {
    'id': string;
    'name': string;
    'url': string;
    'otherProducts': Array<AmpEventProduct>;
}
export interface AmpEventProduct {
    'id': string;
    'name': string;
    'url': string;
    'imageUrl': string | null;
    'finished': boolean;
    'endDate': Date;
    'currentPrice': string | null;
    'season': string | null;
    'labels': Array<string>;
}
export interface AmpProductDetails {
    'id': string;
    'name': string;
    'url': string;
    'imageUrl': string | null;
    'finished': boolean;
    'endDate': Date;
    'currentPrice': string | null;
    'season': string | null;
    'labels': Array<string>;
    'event': AmpEvent | null;
}
export interface AthleteCategory {
    'id': string;
    'name': string;
    'slug': string;
    'externalReferenceId': string | null;
    'logoUrl': string | null;
    'isFollowedByUser': boolean;
    'teamCategory': TeamCategory | null;
    'nameTranslation': Translation;
}
export interface AthleteCategoryList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AthleteCategory>;
}
export interface AthleteData {
    'name': string;
    'shirtNumber': number | null;
    'position': string | null;
    'countryOfBirth': string | null;
    'dateOfBirth': string | null;
    'teamName': string | null;
    'shirtSize': string | null;
    'placeOfBirth': string | null;
    'nationality': string | null;
}
export interface AthleteFixtureDetails {
    'name': string | null;
    'countryOfBirth': string | null;
    'cityOfBirth': string | null;
    'dateOfBirth': string | null;
    'teamName': string | null;
    'bio': string | null;
    'number': string | null;
    'footballDetails': AthleteFootballDetails | null;
}
export interface AthleteFootballDetails {
    'position': FootballPositionType | null;
    'minutesPlayed': number | null;
    'isCaptain': boolean | null;
    'goals': number | null;
    'assists': number | null;
    'saves': number | null;
    'successfulPasses': number | null;
    'shotsTotal': number | null;
}



export enum AuctionSorting {
    HighToLow = 'high_to_low',
    LowToHigh = 'low_to_high',
    Random = 'random'
}



export enum AuthenticityMethod {
    CertificateNumber = 'certificate_number',
    Fabricks = 'fabricks',
    None = 'none'
}


export interface BasketballDetails {
    'score': string;
}
/**
 * Contains information about the beneficiary of the auction.
 */
export interface BeneficiaryReference {
    'id': string;
    'logoUrl': string;
    'websiteUrl': string;
    'isCharity': boolean;
    'beneficiaryPercentage': number | null;
    'name': string;
    'description': string;
}
/**
 * Contains information about a bid placed.
 */
export interface Bid {
    'bidId': string;
    'productId': string;
    'userCountryIso': string | null;
    'obfuscatedUserId': number;
    'prices': Array<Price> | null;
    'currency': string | null;
    'bidReceivedAt': Date;
    'bidType': BidType;
    'highestBid': boolean | null;
    'highestTiedBid': boolean | null;
}


export interface BidCosts {
    'bid': Price;
    'bidInEuro': Price;
    'buyersPremium': Price | null;
    'buyersPremiumPercentage': number | null;
    'estimatedShippingCost': Price | null;
    'vat': Price | null;
    'vatPercentage': number | null;
    'totalPrice': Price;
    'shippingOfficeName': string;
    'vatNumberCheckStatus': VatNumberCheckStatus;
    'salesTaxType': SalesTaxType;
    'itemVatExplanation': VatExplanation;
    'handlingVatExplanation': VatExplanation;
    'biddingBlocked': boolean;
    'biddingBlockedReason': BiddingBlockedReason | null;
    'shippingOfficeCountryCode': string | null;
    'preAuthorisationResponse': PreAuthorisationForBid | null;
    'landedCosts': LandedCosts | null;
}


/**
 * Contains detailed information about a bid.
 */
export interface BidDetails {
    'product': BidWithProduct | null;
    'bidId': string;
    'productId': string;
    'userCountryIso': string | null;
    'obfuscatedUserId': number;
    'prices': Array<Price> | null;
    'currency': string | null;
    'bidReceivedAt': Date;
    'bidType': BidType;
    'highestBid': boolean | null;
    'highestTiedBid': boolean | null;
}


export interface BidDetailsList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<BidDetails>;
}
export interface BidLimitUpdatedWebsocketEvent {
    'userId': string;
    'bidLimit': number;
}
export interface BidPlacedOnSubscribedProductWebsocketEvent {
    'productListingId': string;
    'bidId': string;
    'updatedProductEndDate': Date;
    'quickBids': Array<{ [key: string]: number; }>;
    'productSlug': string;
    'eventId': string | null;
    'eventSlug': string | null;
    'productPublished': boolean;
    'eventPublished': boolean;
    'platformIds': Array<string>;
    'biddingUserId': string;
}
export interface BidPlacedWebsocket {
    'productSkuId': string;
    'newBid': BidPlacedWebsocketNewBid;
    'quickBids': Array<{ [key: string]: number; }>;
    'updatedProductEndDate': Date;
    'eventId': string | null;
    'eventSlug': string | null;
    'productId': string;
    'productSlug': string;
    'productPublished': boolean;
    'eventPublished': boolean;
    'platformIds': Array<string>;
    'biddingUserId': string;
}
export interface BidPlacedWebsocketNewBid {
    'id': string;
    'skuId': string;
    'userCountryIso': string | null;
    'previousBidId': string | null;
    'obfuscatedUserId': number;
    'amounts': { [key: string]: number; };
    'bidType': string;
    'dateCreated': Date;
}
export interface BidStatus {
    'isWinning': boolean | null;
    'maxBidPrices': Array<Price>;
}
export interface BidSteps {
    'steps': Array<VerificationStep>;
    'bidLimitAfterSteps': Array<Price>;
    'optionalSteps': Array<VerificationStep>;
}

export enum BidType {
    Quickbid = 'quickbid',
    Bid = 'bid',
    AutomaticBid = 'automatic_bid'
}


export interface BidWithProduct {
    'availableQuickBidPrices': Array<Array<Price>> | null;
    'isEventExcludedFromWeb': boolean | null;
    'forceEventName': boolean;
    'participants': Array<EventsParticipant> | null;
    'id': string;
    'slug': string;
    'salesMethod': SalesMethod;
    'eventId': string | null;
    'prices': Array<Price>;
    'startDate': Date;
    'endDate': Date;
    'canonicalName': string;
    'type': string;
    'labels': Array<Label>;
    'media': Array<MediaContent>;
    'imageUrl': string | null;
    'secondaryImageUrl': string | null;
    'image360Url': string | null;
    'finished': boolean;
    'sortingPriority': number;
    'description': string;
    'shortName': string | null;
    'partnerId': string;
    'stock': number;
    'inStock': boolean;
    'customizable': boolean;
    'isWon': boolean | null;
    'hasBid': boolean;
    'highlights': Array<Highlight>;
    'tierType': TierType;
    'productEventName': string | null;
    'canonicalEventName': string | null;
    'fixtureDetails': ProductFixtureDetails | null;
    'name': string;
}


export interface BidderV2 {
    'userId': string;
    'bidLimit': Array<Price>;
    'dateModified': Date;
    'partnersMarketingConsent': Array<string> | null;
    'bidVerified': boolean;
    'bidBlocked': boolean;
    'quickBidTermsAccepted': boolean;
}

export enum BiddingBlockedReason {
    NoShipmentToTurkey = 'no_shipment_to_turkey'
}



export enum BiddingStatus {
    Leading = 'leading',
    Outbid = 'outbid',
    NoBidPlaced = 'no_bid_placed'
}



export enum BidsStatusFilters {
    All = 'all',
    Live = 'live',
    Won = 'won',
    Closed = 'closed'
}



export enum CategoriesSearchType {
    Teams = 'teams',
    Leagues = 'leagues',
    Other = 'other',
    Campaigns = 'campaigns'
}


export interface Category {
    'id': string;
    'canonicalName': string;
    'slug': string;
    'externalReference': ExternalReference | null;
    'logoUrl': string | null;
    'bannerUrl': string | null;
    'defaultEventBannerUrl': string | null;
    'cutoutImageUrl': string | null;
    'mobileCutoutImageUrl': string | null;
    'primaryColor': string | null;
    'secondaryColor': string | null;
    'showUpcomingEvents': boolean;
    'showAsCardView': boolean;
    'showTotalRaised': boolean;
    'priorityScore': number;
    'description': string | null;
    'sendNotifications': boolean;
    'nameTranslation': Translation | null;
    'liveEventCount': number | null;
    'upcomingEventCount': number | null;
    'historicalEventCount': number | null;
    'name': string;
    'relatedCategories': Array<RelatedCategory> | null;
}
export interface CategoryAuction {
    'id': string;
    'slug': string;
    'name': string;
    'endDate': Date;
    'logoUrl': string | null;
    'bannerUrl': string | null;
    'color': string | null;
    'products': Array<EventsOverviewProduct>;
}
export interface CategoryAuctions {
    'auctions': Array<CategoryAuction>;
}
export interface CategoryFilter {
    'id': string;
    'name': string;
}
export interface CategoryList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<Category>;
}
export interface CategoryLive {
    'id': string;
    'name': string;
    'canonicalName': string;
    'slug': string;
    'logoUrl': string | null;
    'primaryColor': string | null;
    'type': CategoryType;
    'liveEvents': Array<LiveEvent>;
    'followed': boolean | null;
    'nameTranslation': Translation | null;
}


export interface CategoryLiveList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<CategoryLive>;
}
export interface CategoryPreference {
    'id': string;
    'name': string;
    'canonicalName': string;
    'slug': string;
    'logoUrl': string | null;
    'bannerUrl': string | null;
    'type': CategoryType;
    'followed': boolean;
    'liveEvents': Array<LiveEvent>;
}


export interface CategoryPreferences {
    'categoryIds': Array<string>;
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<CategoryPreference>;
}
export interface CategoryProduct {
    'id': string;
    'slug': string;
    'salesMethod': SalesMethod;
    'eventId': string | null;
    'prices': Array<Price>;
    'startDate': Date;
    'endDate': Date;
    'name': string;
    'type': string;
    'labels': Array<Label>;
    'media': Array<MediaContent>;
    'imageUrl': string | null;
    'secondaryImageUrl': string | null;
    'finished': boolean;
    'sortingPriority': number;
    'description': string;
    'shortName': string | null;
    'partnerId': string;
    'stock': number;
    'inStock': boolean;
    'customizable': boolean;
    'isWon': boolean | null;
    'hasBid': boolean;
    'productEventName': string | null;
}


export interface CategoryProductList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<CategoryProduct>;
}
export interface CategoryRelations {
    'team': Category | null;
    'country': Category | null;
    'league': Category | null;
    'sport': Category | null;
}

export enum CategoryType {
    Country = 'country',
    League = 'league',
    Team = 'team',
    Sport = 'sport',
    Other = 'other',
    Gender = 'gender',
    Athlete = 'athlete',
    Condition = 'condition',
    Highlight = 'highlight',
    Campaign = 'campaign'
}


export interface CategoryWithFollowersCount {
    'id': string;
    'slug': string;
    'logoUrl': string | null;
    'primaryColor': string | null;
    'followerCount': number;
    'name': string;
}
export interface ChangeCategoryPreferencesRequest {
    'followCategoryIds': Array<string> | null;
    'unfollowCategoryIds': Array<string> | null;
}
export interface ChangeEventPreferencesRequest {
    'followEventIds': Array<string> | null;
    'unfollowEventIds': Array<string> | null;
}
export interface ChangeIndividualPreferenceRequest {
    'follow': boolean;
}
export interface ChangeProductPreferencesRequest {
    'followProductIds': Array<string> | null;
    'unfollowProductIds': Array<string> | null;
}
export interface Claim {
    'claimId': string;
    'userFirstName': string | null;
    'userLastName': string | null;
    'dateCreated': Date;
    'product': ClaimedProduct;
}
export interface ClaimBid {
    'id': string;
    'userCountryIso': string | null;
    'obfuscatedUserId': number;
    'prices': Array<Price> | null;
    'currency': string | null;
    'bidReceivedAt': Date;
    'bidType': BidType;
}


export interface ClaimList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<Claim>;
}
export interface ClaimedProduct {
    'id': string;
    'name': string;
    'description': string;
    'image360Url': string | null;
    'teamColor': string | null;
    'media': Array<MediaContent>;
    'gallery': Array<MediaContent>;
    'labels': Array<Label>;
    'fixtureDetails': FixtureDetails | null;
    'athleteFixtureDetails': AthleteFixtureDetails | null;
    'bids': Array<ClaimBid>;
    'soldAt': Date | null;
    'soldBy': string | null;
    'authenticatedAt': Date | null;
    'authenticatedBy': string | null;
    'authenticatedByLogo': string | null;
    'shirtSize': string | null;
}

export enum ClientChannel {
    App = 'app',
    Web = 'web'
}


export interface Collection {
    'collectionId': string | null;
    'name': string;
    'claims': ClaimList;
}
export interface CollectionSummary {
    'id': string;
    'name': string;
    'claimsCount': number;
}
export interface CollectionSummaryList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<CollectionSummary>;
}

export enum CombineType {
    And = 'and',
    Or = 'or'
}


export interface CreateCollectionRequest {
    'name': string;
}
export interface CreateOffer {
    'threadId': string;
}
export interface CreateProductOrder {
    'orderId': string;
}
export interface CreateProductOrderRequest {
    'currencyCode': string;
}

export enum DateSortAttribute {
    StartDate = 'start_date',
    EndDate = 'end_date'
}



export enum DateSortDirection {
    Ascending = 'ascending',
    Descending = 'descending'
}


export interface DyCookie {
    'name': string;
    'value': string;
    'maxAge': string | null;
}
export interface ErrorFailuresInner {
    'errorCode': string;
    'errorMessage': string;
    'propertyName': string;
}
export interface EstimatedShippingRange {
    'startDate': Date;
    'endDate': Date;
}
/**
 * Contains information about an event including their related categories.
 */
export interface Event {
    'color': string;
    'bannerUrl': string;
    'matchScoredBallImageUrl': string | null;
    'categories': Array<Category>;
    'priorityScore': number;
    'id': string;
    'name': string;
    'canonicalName': string;
    'slug': string;
    'forceEventName': boolean;
    'logoUrl': string | null;
    'startDate': Date;
    'endDate': Date;
    'isFinished': boolean;
    'participants': Array<EventParticipant>;
}
/**
 * Contains detailed information about an event including their related categories and beneficiary.
 */
export interface EventDetails {
    'beneficiary': BeneficiaryReference | null;
    'isEventExcludedFromWeb': boolean;
    'legendId': string | null;
    'color': string;
    'bannerUrl': string;
    'matchScoredBallImageUrl': string | null;
    'categories': Array<Category>;
    'priorityScore': number;
    'id': string;
    'name': string;
    'canonicalName': string;
    'slug': string;
    'forceEventName': boolean;
    'logoUrl': string | null;
    'startDate': Date;
    'endDate': Date;
    'isFinished': boolean;
    'participants': Array<EventParticipant>;
}
export interface EventDurationChangedWebsocketEvent {
    'eventId': string;
    'startDate': Date;
    'oldEndDate': Date;
    'newEndDate': Date;
    'syncSkuDates': boolean;
    'eventPublished': boolean;
    'platformIds': Array<string>;
    'reason': number;
    'eventName': string;
    'featuredTeamName': string;
}
export interface EventFilters {
    'categoryFilters': { [key: string]: Array<CategoryFilter>; };
}
export interface EventList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<Event>;
}
export interface EventParticipant {
    'name': string | null;
    'eventId': string;
    'participantId': string;
    'isFeatured': boolean;
    'isHome': boolean;
}
export interface EventPreference {
    'id': string;
    'name': string;
    'canonicalName': string;
    'slug': string;
    'logoUrl': string;
    'startDate': Date;
    'endDate': Date;
    'isFollowedByUser': boolean;
    'forceEventName': boolean;
    'participants': Array<EventParticipant>;
    'categories': Array<Category>;
}
export interface EventPreferences {
    'eventIds': Array<string>;
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<EventPreference>;
}

export enum EventSortAttribute {
    StartDate = 'start_date',
    EndDate = 'end_date',
    EndDateClosestToNow = 'end_date_closest_to_now'
}


export interface EventsOverview {
    'id': string;
    'slug': string;
    'name': string;
    'sport': string | null;
    'forceEventName': boolean;
    'startDate': Date;
    'endDate': Date;
    'logoUrl': string | null;
    'color': string | null;
    'matchScoredBallImageUrl': string | null;
    'bannerImageUrl': string | null;
    'participants': Array<EventsParticipant>;
    'products': Array<EventsOverviewProduct>;
}
export interface EventsOverviewList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<EventsOverview>;
}
export interface EventsOverviewProduct {
    'id': string;
    'slug': string;
    'eventId': string;
    'price': Price | null;
    'euroPrice': Price | null;
    'startDate': Date;
    'endDate': Date;
    'labels': Array<string>;
    'productImageUrl': string | null;
    'secondaryImageUrl': string | null;
    'image360Url': string | null;
    'isFinished': boolean;
    'hasBid': boolean;
    'highlights': Array<Highlight>;
    'currentHighestBidderObfuscatedId': number | null;
    'tierType': TierType;
    'fixtureDetails': ProductFixtureDetails | null;
    'name': string;
}


export interface EventsParticipant {
    'isFeatured': boolean;
    'isHome': boolean;
    'name': string;
}
export interface ExternalReference {
    'externalId': string | null;
    'type': CategoryType;
}


export interface FavouriteProductListingFilters {
    'categoryFilters': { [key: string]: Array<CategoryFilter>; };
    'biddingStatuses': Array<BiddingStatus>;
}

export enum FilterEventStatus {
    Upcoming = 'upcoming',
    Live = 'live',
    Finished = 'finished'
}


export interface FixtureData {
    'matchName': string;
    'finalScore': string | null;
    'venue': string | null;
    'date': string | null;
    'season': string | null;
    'league': string | null;
    'homeTeamName': string | null;
    'awayTeamName': string | null;
}

export enum FixtureDetailGoalType {
    Goal = 'goal',
    OwnGoal = 'own_goal',
    Penalty = 'penalty'
}


export interface FixtureDetails {
    'fixtureDate': Date | null;
    'venueName': string | null;
    'seasonName': string | null;
    'matchName': string | null;
    'leagueName': string | null;
    'homeTeam': Team | null;
    'awayTeam': Team | null;
    'footballDetails': FootballFixtureDetails | null;
    'basketballDetails': BasketballDetails | null;
    'homeScore': number | null;
    'awayScore': number | null;
    'countryName': string | null;
    'venueCity': string | null;
}
export interface FootballFixtureDetails {
    'score': string;
    'goals': Array<Goal>;
}

export enum FootballPositionType {
    Goalkeeper = 'goalkeeper',
    Defender = 'defender',
    Midfielder = 'midfielder',
    Attacker = 'attacker'
}



export enum FramingType {
    NotFrameable = 'not_frameable',
    Frameable = 'frameable',
    Framed = 'framed'
}


export interface Goal {
    'isHomeTeamGoal': boolean;
    'scorerName': string;
    'minute': number;
    'goalType': FixtureDetailGoalType;
    'extraMinute': number | null;
}


export interface Highlight {
    'id': string;
    'name': string;
    'logoUrl': string | null;
}

export enum ImageOrigin {
    Mockup = 'mockup',
    Photo = 'photo',
    Unknown = 'unknown',
    Filler = 'filler',
    Gallery = 'gallery'
}


export interface Label {
    'id': string;
    'text': string;
    'description': string;
}
export interface LandedCostCharge {
    'type': string;
    'name': string;
    'amount': Price;
}
export interface LandedCosts {
    'total': Price;
    'breakdown': Array<LandedCostCharge>;
    'isEstimate': boolean;
}
export interface LimitedEvent {
    'id': string;
    'name': string;
    'canonicalName': string;
    'slug': string;
    'forceEventName': boolean;
    'logoUrl': string | null;
    'startDate': Date;
    'endDate': Date;
    'isFinished': boolean;
    'participants': Array<EventParticipant>;
}
export interface LimitedEventList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<LimitedEvent>;
}
export interface LiveEvent {
    'id': string;
    'slug': string | null;
    'endDate': Date;
}

export enum LiveStatus {
    Historical = 'historical',
    Live = 'live',
    Upcoming = 'upcoming',
    Started = 'started'
}


export interface MatchScoredBallParticipantDto {
    'name': string | null;
    'id': string;
    'isScorer': boolean;
    'score': string | null;
    'logoUrl': string | null;
}
export interface MatchScoredBallProduct {
    'participants': Array<MatchScoredBallParticipantDto>;
    'productDetails': { [key: string]: string; };
    'id': string;
    'slug': string;
    'salesMethod': SalesMethod;
    'eventId': string | null;
    'prices': Array<Price>;
    'startDate': Date;
    'endDate': Date;
    'canonicalName': string;
    'type': string;
    'labels': Array<Label>;
    'media': Array<MediaContent>;
    'imageUrl': string | null;
    'secondaryImageUrl': string | null;
    'image360Url': string | null;
    'finished': boolean;
    'sortingPriority': number;
    'description': string;
    'shortName': string | null;
    'partnerId': string;
    'stock': number;
    'inStock': boolean;
    'customizable': boolean;
    'isWon': boolean | null;
    'hasBid': boolean;
    'highlights': Array<Highlight>;
    'tierType': TierType;
    'productEventName': string | null;
    'canonicalEventName': string | null;
    'fixtureDetails': ProductFixtureDetails | null;
    'name': string;
}


export interface MatchScoredBallsByCategory {
    'showMatchScoredBalls': boolean;
    'products': Array<MatchScoredBallProduct> | null;
}
export interface MaxBid {
    'id': string;
    'prices': Array<Price> | null;
    'isActive': boolean;
    'dateCreated': Date;
    'currencyCode': string;
}
export interface MaxBidPlaced {
    'maxBid': MaxBid;
    'isOutbid': boolean;
    'isEndDateExtended': boolean;
    'productEndDate': Date;
    'bidType': BidType;
    'isUsersFirstMaxBid': boolean;
}


export interface MediaContent {
    'type': MediaType | null;
    'url': string | null;
    'metadata': Metadata | null;
}



export enum MediaType {
    Video = 'video',
    Image = 'image'
}


export interface MenuHierarchyTree {
    'id': string;
    'name': string | null;
    'platformId': string;
    'parentId': string | null;
    'category': Category | null;
    'priorityScore': number;
    'children': Array<MenuHierarchyTree> | null;
    'liveEvents': Array<LiveEvent> | null;
}
export interface Metadata {
    'origin': ImageOrigin;
    'applyPadding': boolean;
}


export interface ModelError {
    'code': string;
    'message': string;
    'failures': Array<ErrorFailuresInner> | null;
}
export interface Offer {
    'offerId': string;
    'price': { [key: string]: number; };
    'timestamp': Date;
    'status': OfferStatus;
    'orderId': string | null;
    'purchaseOrderId': string | null;
    'messages': Array<OfferMessage>;
}


export interface OfferCosts {
    'offerPrice': Price;
    'buyersPremium': Price;
    'buyersPremiumPercentage': number;
    'estimatedShippingCost': Price;
    'totalPrice': Price;
    'shippingOfficeName': string;
    'shippingOfficeCountryCode': string | null;
    'salesTaxType': SalesTaxType;
}


export interface OfferList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<Offer>;
}
export interface OfferMessage {
    'message': OfferMessageType;
    'from': OfferMessageSender;
    'timestamp': Date;
}



export enum OfferMessageSender {
    Buyer = 'buyer',
    Seller = 'seller',
    System = 'system'
}



export enum OfferMessageType {
    OfferSent = 'offer_sent',
    OfferAccepted = 'offer_accepted',
    BuyerPaymentNeeded = 'buyer_payment_needed',
    OfferDeclined = 'offer_declined',
    OfferExpired = 'offer_expired',
    OfferCancelled = 'offer_cancelled',
    BuyerOrderPaid = 'buyer_order_paid',
    SellerShipmentSent = 'seller_shipment_sent',
    ResaleItemReceivedAtHub = 'resale_item_received_at_hub',
    QualityCheckPassed = 'quality_check_passed'
}


export interface OfferPayoutBreakdown {
    'offerPrices': Array<Price>;
    'sellerFees': Array<Price>;
    'sellerFeePercentage': number;
    'estimatedShippingCosts': Array<Price>;
    'netPayouts': Array<Price>;
    'shippingOfficeName': string;
    'shippingOfficeCountryCode': string | null;
    'sellerAddress': SellerShippingAddress | null;
}
export interface OfferProductDetails {
    'listingId': string;
    'name': string;
    'eventName': string;
    'imageUrl': string;
    'price': { [key: string]: number; };
}

export enum OfferStatus {
    Open = 'open',
    Accepted = 'accepted',
    Declined = 'declined',
    Cancelled = 'cancelled',
    Expired = 'expired',
    Paid = 'paid'
}


export interface OfferThreadDetail {
    'isBuyer': boolean;
    'productDetails': OfferProductDetails;
    'offers': OfferList;
}
export interface OfferThreadListItem {
    'threadId': string;
    'isBuyer': boolean;
    'productDetails': OfferProductDetails;
    'lastOffer': Offer;
}
export interface OfferThreadListItemList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<OfferThreadListItem>;
}
/**
 * Contains information about the partner of the auction.
 */
export interface PartnerReference {
    'id': string;
    'name': string | null;
    'isMwsPartner': boolean | null;
}
export interface PlaceMaxBidRequest {
    'currencyCode': string;
    'amount': number;
    'partnerMarketingConsent': boolean;
    'customerCountryCode': string | null;
    'paymentTokenId': string | null;
    'bidType': BidType | null;
    'estimatedCountryCode': string | null;
}


export interface PreAuthorisationForBid {
    'isRequired': boolean;
    'threshold': Price;
    'reservedAmount': Price | null;
    'isIncrease': boolean;
    'preAuthorisationTierId': string | null;
}
export interface Price {
    'currency': string;
    'price': number;
}
export interface Product {
    'id': string;
    'slug': string;
    'salesMethod': SalesMethod;
    'eventId': string | null;
    'prices': Array<Price>;
    'startDate': Date;
    'endDate': Date;
    'canonicalName': string;
    'type': string;
    'labels': Array<Label>;
    'media': Array<MediaContent>;
    'imageUrl': string | null;
    'secondaryImageUrl': string | null;
    'image360Url': string | null;
    'finished': boolean;
    'sortingPriority': number;
    'description': string;
    'shortName': string | null;
    'partnerId': string;
    'stock': number;
    'inStock': boolean;
    'customizable': boolean;
    'isWon': boolean | null;
    'hasBid': boolean;
    'highlights': Array<Highlight>;
    'tierType': TierType;
    'productEventName': string | null;
    'canonicalEventName': string | null;
    'fixtureDetails': ProductFixtureDetails | null;
    'name': string;
}


export interface ProductCostEstimate {
    'basePriceExclVat': number;
    'shippingCosts': number;
    'vatMultiplier': number;
    'vatAmount': number;
    'totalPrice': number;
    'shippingOfficeName': string;
    'shippingOfficeCountryCode': string;
}
export interface ProductDetails {
    'availableQuickBidPrices': Array<Array<Price>> | null;
    'gallery': Array<MediaContent>;
    'eventLogoUrl': string;
    'eventName': string | null;
    'commercialDescription': string;
    'functionalDescription': string | null;
    'details': { [key: string]: string; };
    'beneficiary': BeneficiaryReference | null;
    'partner': PartnerReference;
    'framingType': FramingType;
    'shippingType': ShippingType;
    'shippingOfficeId': string;
    'shippingDescription': string | null;
    'categories': Array<Category>;
    'authenticityMethod': AuthenticityMethod;
    'sweepstakeId': string | null;
    'showBeneficiaryPercentage': boolean;
    'beneficiaryPercentage': number;
    'isEventExcludedFromWeb': boolean;
    'estimatedShippingRange': EstimatedShippingRange | null;
    'aiGenerated': AiGenerated;
    'athleteData': AthleteData | null;
    'fixtureData': FixtureData | null;
    'fixtureDate': Date | null;
    'specialTierInformation': SpecialTier | null;
    'event': ProductEvent | null;
    'id': string;
    'slug': string;
    'salesMethod': SalesMethod;
    'eventId': string | null;
    'prices': Array<Price>;
    'startDate': Date;
    'endDate': Date;
    'canonicalName': string;
    'type': string;
    'labels': Array<Label>;
    'media': Array<MediaContent>;
    'imageUrl': string | null;
    'secondaryImageUrl': string | null;
    'image360Url': string | null;
    'finished': boolean;
    'sortingPriority': number;
    'description': string;
    'shortName': string | null;
    'partnerId': string;
    'stock': number;
    'inStock': boolean;
    'customizable': boolean;
    'isWon': boolean | null;
    'hasBid': boolean;
    'highlights': Array<Highlight>;
    'tierType': TierType;
    'productEventName': string | null;
    'canonicalEventName': string | null;
    'fixtureDetails': ProductFixtureDetails | null;
    'name': string;
}


/**
 * The fields of a product\'s event that the product page shows.
 */
export interface ProductEvent {
    'id': string;
    'name': string;
    'canonicalName': string;
    'slug': string;
    'forceEventName': boolean;
    'color': string;
    'logoUrl': string | null;
    'bannerUrl': string;
    'startDate': Date;
    'endDate': Date;
    'isFinished': boolean;
    'participants': Array<EventParticipant>;
    'categories': Array<ProductEventCategory>;
    'legendId': string | null;
}
export interface ProductEventCategory {
    'id': string;
    'name': string;
    'canonicalName': string;
    'externalReference': ExternalReference | null;
}
export interface ProductFilters {
    'minimumPrice': { [key: string]: number; } | null;
    'maximumPrice': { [key: string]: number; } | null;
    'categoryFilters': { [key: string]: Array<CategoryFilter>; };
}
export interface ProductFixtureDetails {
    'name': string | null;
    'season': string | null;
    'league': string | null;
}
export interface ProductImageUpdatedWebsocketEvent {
    'productId': string;
    'productListingId': string | null;
    'eventId': string | null;
}
export interface ProductList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<Product>;
}
export interface ProductListItem {
    'currentHighestBidderObfuscatedId': number | null;
    'id': string;
    'slug': string;
    'salesMethod': SalesMethod;
    'eventId': string | null;
    'prices': Array<Price>;
    'startDate': Date;
    'endDate': Date;
    'canonicalName': string;
    'type': string;
    'labels': Array<Label>;
    'media': Array<MediaContent>;
    'imageUrl': string | null;
    'secondaryImageUrl': string | null;
    'image360Url': string | null;
    'finished': boolean;
    'sortingPriority': number;
    'description': string;
    'shortName': string | null;
    'partnerId': string;
    'stock': number;
    'inStock': boolean;
    'customizable': boolean;
    'isWon': boolean | null;
    'hasBid': boolean;
    'highlights': Array<Highlight>;
    'tierType': TierType;
    'productEventName': string | null;
    'canonicalEventName': string | null;
    'fixtureDetails': ProductFixtureDetails | null;
    'name': string;
}


export interface ProductListItemList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<ProductListItem>;
}
export interface ProductListingFavourites {
    'listingId': string;
    'productName': string;
    'eventName': string | null;
    'productImageUrl': string;
    'prices': Array<Price> | null;
    'biddingStatus': BiddingStatus | null;
    'salesMethod': SalesMethod;
    'startDate': Date;
    'endDate': Date;
    'userMaxBidPrices': Array<Price> | null;
    'participants': Array<EventsParticipant> | null;
    'nextMinimumBidPrices': Array<Price> | null;
    'minimumBidIncrementPrices': Array<Price> | null;
    'estimatedTotalCost': Price | null;
}


export interface ProductListingFavouritesList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<ProductListingFavourites>;
}

export enum ProductListingFavouritesSortingField {
    ClosingTime = 'closing_time',
    Price = 'price'
}


export interface ProductPreference {
    'id': string;
    'name': string;
    'slug': string;
    'prices': Array<Price>;
    'endDate': Date;
    'labels': Array<Label>;
    'media': Array<MediaContent>;
    'finished': boolean;
    'followed': boolean;
    'shortName': string | null;
    'startDate': Date;
    'salesMethod': SalesMethod;
    'inStock': boolean;
    'hasBid': boolean;
    'highlights': Array<Highlight>;
    'currentHighestBidderObfuscatedId': number | null;
    'tierType': TierType;
    'fixtureDetails': ProductFixtureDetails | null;
}


export interface ProductPreferences {
    'productIds': Array<string>;
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<ProductPreference>;
}
export interface ProductRecommendation {
    'slotId': string;
    'product': ProductListItem;
}
export interface ProductRecommendations {
    'decisionId': string | null;
    'variationId': number | null;
    'items': Array<ProductRecommendation>;
    'dyCookies': Array<DyCookie>;
}
export interface ProductSkuDurationChangedWebsocketEvent {
    'productSkuId': string;
    'eventId': string | null;
    'startDate': Date;
    'endDate': Date;
    'productPublished': boolean;
    'eventPublished': boolean;
    'platformIds': Array<string>;
    'reason': string;
}
export interface ProductSkuDurationExtendedWebsocketEvent {
    'productSkuId': string;
    'eventId': string | null;
    'startDate': Date;
    'endDate': Date;
    'productPublished': boolean;
    'eventPublished': boolean;
    'platformIds': Array<string>;
}
export interface ProductSoldWebsocketEvent {
    'skuId': string;
    'id': string;
    'eventName': string;
    'platformId': string;
    'productSlug': string;
    'productImageUrl': string | null;
    'productDisplayName': string;
}

export enum ProductSorting {
    Featured = 'featured',
    ClosingTimeFirstToLast = 'closing_time_first_to_last',
    ClosingTimeLastToFirst = 'closing_time_last_to_first',
    PriceLowToHigh = 'price_low_to_high',
    PriceHighToLow = 'price_high_to_low'
}



export enum ProductStatus {
    Live = 'live',
    Finished = 'finished'
}


export interface RecentBid {
    'id': string;
    'prices': { [key: string]: number; };
    'bidderIsoCode': string | null;
    'productName': string;
    'eventName': string;
    'productImageUrl': string | null;
    'clubLogoUrl': string | null;
    'clubPrimaryColor': string | null;
    'productListingId': string;
    'productSlug': string;
    'endDate': Date;
    'bidReceivedAt': Date;
}

export enum RecommendationPageType {
    Homepage = 'homepage',
    Category = 'category',
    Product = 'product',
    Cart = 'cart',
    Other = 'other'
}


export interface Recommendations {
    'recommendations': Array<SelectorRecommendations>;
    'dyCookies': Array<DyCookie>;
}
export interface RegisterGiveawayRequest {
    'metadata': string;
    'email': string;
    'categorySlug': string | null;
    'partnerMarketingOptIn': boolean | null;
    'name': string | null;
    'surname': string | null;
}
export interface RelatedCategory {
    'id': string;
    'name': string;
    'slug': string;
    'externalReference': ExternalReference | null;
    'logoUrl': string | null;
}
export interface ResellEligibility {
    'isEligible': boolean;
    'minimumPrices': Array<Price> | null;
    'defaultPrices': Array<Price> | null;
    'lastSoldPrices': Array<Price> | null;
    'existingOfferThreadId': string | null;
    'latestOfferStatus': OfferStatus | null;
}



export enum SalesMethod {
    Sweepstakes = 'sweepstakes',
    Bidding = 'bidding',
    FixedPrice = 'fixed_price',
    Resale = 'resale',
    AddOn = 'add_on'
}



export enum SalesTaxType {
    Unknown = 'unknown',
    NoSalesTax = 'no_sales_tax',
    Vat = 'vat',
    UsSalesTax = 'us_sales_tax',
    BrazilSalesTax = 'brazil_sales_tax'
}


export interface Search {
    'hasResults': boolean;
    'liveProducts': ProductList;
    'pastProducts': ProductList;
    'liveEvents': LimitedEventList;
    'pastEvents': LimitedEventList;
    'teamCategories': CategoryList;
    'leagueCategories': CategoryList;
    'countryCategories': CategoryList;
    'otherCategories': CategoryList;
    'products': ProductList;
    'events': LimitedEventList;
    'categories': CategoryList;
}

export enum SearchTypeFilter {
    Events = 'events',
    Products = 'products',
    Categories = 'categories'
}


export interface SelectorRecommendations {
    'selector': string;
    'decisionId': string | null;
    'variationId': number | null;
    'items': Array<ProductRecommendation>;
    'isControlGroup': boolean;
}
export interface SellerShippingAddress {
    'id': string | null;
    'name': string | null;
    'addressLine1': string | null;
    'addressLine2': string | null;
    'city': string | null;
    'state': string | null;
    'zipCode': string | null;
    'countryCode': string | null;
}
export interface SetMinimumResalePriceRequest {
    'amount': number;
    'currencyCode': string;
}

export enum ShippingType {
    PaidShipping = 'paid_shipping',
    FreeShipping = 'free_shipping',
    NoShipping = 'no_shipping',
    FreeDomesticShipping = 'free_domestic_shipping'
}


/**
 * adapted from https://nuxtseo.com/sitemap/api/schema
 */
export interface Sitemap {
    'loc': string | null;
    'lastMod': string | null;
    'i18NTransform': boolean;
}

export enum SortDirection {
    Ascending = 'ascending',
    Descending = 'descending'
}



export enum Sorting {
    Ascending = 'ascending',
    Descending = 'descending'
}


export interface SpecialTier {
    'title': string | null;
    'description': string | null;
}
export interface StoryBlokCategory {
    'name': string;
    'value': string;
}
export interface StoryBlokProductType {
    'name': string;
    'value': string;
}
export interface Team {
    'name': string | null;
    'logo': string | null;
    'isFeatured': boolean;
}
export interface TeamCategory {
    'name': string;
    'slug': string;
    'logoUrl': string | null;
    'primaryColor': string | null;
}

export enum TierType {
    Normal = 'normal',
    Gold = 'gold'
}


export interface Translation {
    'value': string | null;
    'isAiGenerated': boolean;
}
export interface UpdateCollectionNameRequest {
    'name': string;
}
export interface UpdateQuickBidTermsRequest {
    'quickBidTermsAccepted': boolean;
}
export interface UserWasOutbidWebsocket {
    'productListingId': string;
    'productSlug': string;
    'newBid': BidPlacedWebsocketNewBid;
    'quickBids': Array<{ [key: string]: number; }>;
    'eventId': string | null;
    'eventSlug': string | null;
    'updatedProductEndDate': Date;
    'productName': string | null;
    'productImageUrl': string | null;
    'hasActiveMaxBid': boolean;
}

export enum VatExemptionReason {
    NotExempted = 'not_exempted',
    IsVatReversed = 'is_vat_reversed',
    IsExport = 'is_export',
    IsVatExempt = 'is_vat_exempt',
    UsSalesTaxApplies = 'us_sales_tax_applies'
}


export interface VatExplanation {
    'hasVat': boolean;
    'reason': VatExemptionReason;
}



export enum VatNumberCheckStatus {
    NoVatNumberSet = 'no_vat_number_set',
    NotChecked = 'not_checked',
    CheckedNotValid = 'checked_not_valid',
    CheckedAndValid = 'checked_and_valid',
    NonEuNumber = 'non_eu_number'
}



export enum VerificationStep {
    Email = 'email',
    Phone = 'phone',
    Address = 'address',
    Payment = 'payment',
    Identification = 'identification'
}



/**
 * BidsApi - axios parameter creator
 */
export const BidsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [productId] 
         * @param {number} [bid] 
         * @param {string} [currency] 
         * @param {string} [destinationCountryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BidCostsGet: async (xPlatformKey: string, productId?: string, bid?: number, currency?: string, destinationCountryCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2BidCostsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/bid/costs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productId !== undefined) {
                localVarQueryParameter['product_id'] = productId;
            }

            if (bid !== undefined) {
                localVarQueryParameter['bid'] = bid;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (destinationCountryCode !== undefined) {
                localVarQueryParameter['destination_country_code'] = destinationCountryCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {number | null} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BidRecentBidsGet: async (xPlatformKey: string, pageSize?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2BidRecentBidsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/bid/recent-bids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [requestedBidAmount] 
         * @param {string} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BidStepsGet: async (requestedBidAmount?: number, currency?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/bid/steps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (requestedBidAmount !== undefined) {
                localVarQueryParameter['requested_bid_amount'] = requestedBidAmount;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BidsApi - functional programming interface
 */
export const BidsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BidsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [productId] 
         * @param {number} [bid] 
         * @param {string} [currency] 
         * @param {string} [destinationCountryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2BidCostsGet(xPlatformKey: string, productId?: string, bid?: number, currency?: string, destinationCountryCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BidCosts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2BidCostsGet(xPlatformKey, productId, bid, currency, destinationCountryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BidsApi.v2BidCostsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {number | null} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2BidRecentBidsGet(xPlatformKey: string, pageSize?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RecentBid>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2BidRecentBidsGet(xPlatformKey, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BidsApi.v2BidRecentBidsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [requestedBidAmount] 
         * @param {string} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2BidStepsGet(requestedBidAmount?: number, currency?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BidSteps>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2BidStepsGet(requestedBidAmount, currency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BidsApi.v2BidStepsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BidsApi - factory interface
 */
export const BidsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BidsApiFp(configuration)
    return {
        /**
         * 
         * @param {BidsApiV2BidCostsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BidCostsGet(requestParameters: BidsApiV2BidCostsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BidCosts> {
            return localVarFp.v2BidCostsGet(requestParameters.xPlatformKey, requestParameters.productId, requestParameters.bid, requestParameters.currency, requestParameters.destinationCountryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BidsApiV2BidRecentBidsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BidRecentBidsGet(requestParameters: BidsApiV2BidRecentBidsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RecentBid>> {
            return localVarFp.v2BidRecentBidsGet(requestParameters.xPlatformKey, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BidsApiV2BidStepsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BidStepsGet(requestParameters: BidsApiV2BidStepsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BidSteps> {
            return localVarFp.v2BidStepsGet(requestParameters.requestedBidAmount, requestParameters.currency, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2BidCostsGet operation in BidsApi.
 */
export interface BidsApiV2BidCostsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly productId?: string

    readonly bid?: number

    readonly currency?: string

    readonly destinationCountryCode?: string
}

/**
 * Request parameters for v2BidRecentBidsGet operation in BidsApi.
 */
export interface BidsApiV2BidRecentBidsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly pageSize?: number | null
}

/**
 * Request parameters for v2BidStepsGet operation in BidsApi.
 */
export interface BidsApiV2BidStepsGetRequest {
    readonly requestedBidAmount?: number

    readonly currency?: string
}

/**
 * BidsApi - object-oriented interface
 */
export class BidsApi extends BaseAPI {
    /**
     * 
     * @param {BidsApiV2BidCostsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2BidCostsGet(requestParameters: BidsApiV2BidCostsGetRequest, options?: RawAxiosRequestConfig) {
        return BidsApiFp(this.configuration).v2BidCostsGet(requestParameters.xPlatformKey, requestParameters.productId, requestParameters.bid, requestParameters.currency, requestParameters.destinationCountryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BidsApiV2BidRecentBidsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2BidRecentBidsGet(requestParameters: BidsApiV2BidRecentBidsGetRequest, options?: RawAxiosRequestConfig) {
        return BidsApiFp(this.configuration).v2BidRecentBidsGet(requestParameters.xPlatformKey, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BidsApiV2BidStepsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2BidStepsGet(requestParameters: BidsApiV2BidStepsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return BidsApiFp(this.configuration).v2BidStepsGet(requestParameters.requestedBidAmount, requestParameters.currency, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CategoriesApi - axios parameter creator
 */
export const CategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get athlete categories by team category slugs. This endpoint finds team categories by their slugs, then uses their ExternalReferenceId to query the Sports service for associated athlete IDs, and returns the corresponding athlete categories.
         * @param {string} [teamCategorySlugs] Comma-separated list of team category slugs
         * @param {string} [searchTerm] Optional search term to filter athlete categories
         * @param {boolean} [followedOnly] 
         * @param {number} [offSet] The number of items to skip
         * @param {number} [pageSize] The maximum size of any individual subset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesAthletesGet: async (teamCategorySlugs?: string, searchTerm?: string, followedOnly?: boolean, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/categories/athletes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (teamCategorySlugs !== undefined) {
                localVarQueryParameter['team_category_slugs'] = teamCategorySlugs;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (followedOnly !== undefined) {
                localVarQueryParameter['followed_only'] = followedOnly;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['off_set'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a category by id
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesCategoryIdGet: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('v2CategoriesCategoryIdGet', 'categoryId', categoryId)
            const localVarPath = `/v2/categories/{categoryId}`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [relatedCategorySlug] 
         * @param {FilterEventStatus} [eventStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesEventsGet: async (relatedCategorySlug?: string, eventStatus?: FilterEventStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/categories/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (relatedCategorySlug !== undefined) {
                localVarQueryParameter['related_category_slug'] = relatedCategorySlug;
            }

            if (eventStatus !== undefined) {
                localVarQueryParameter['event_status'] = eventStatus;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all categories
         * @param {string} [searchTerm] 
         * @param {CategoryType} [type] 
         * @param {string} [categoryIds] 
         * @param {string} [slugs] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesGet: async (searchTerm?: string, type?: CategoryType, categoryIds?: string, slugs?: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (categoryIds !== undefined) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }

            if (slugs !== undefined) {
                localVarQueryParameter['slugs'] = slugs;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the categories with live events if types is empty it will use team, other category types by default the ordering of the types are important, if a event has more than 1 of the category types provided, it will be shown under most important category type, and the importance of the types are in the order you give
         * @param {string} xPlatformKey Select the platform.
         * @param {Array<CategoryType>} [types] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesLiveEventsGet: async (xPlatformKey: string, types?: Array<CategoryType>, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2CategoriesLiveEventsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/categories/live-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (types) {
                localVarQueryParameter['types'] = types;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the most followed categories by their slugs. Returns categories with their follower counts, sorted by most followed.
         * @param {string} [categorySlugs] Comma-separated list of category slugs
         * @param {Date} [startAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesMostFollowedGet: async (categorySlugs?: string, startAfter?: Date, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/categories/most-followed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categorySlugs !== undefined) {
                localVarQueryParameter['category_slugs'] = categorySlugs;
            }

            if (startAfter !== undefined) {
                localVarQueryParameter['start_after'] = (startAfter as any instanceof Date) ?
                    (startAfter as any).toISOString() :
                    startAfter;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a category by slug
         * @param {string} slug The category slug
         * @param {boolean} [includeEventCounts] Include live/upcoming/historical event counts for the platform identified by the X-Platform-Key header
         * @param {string} [xPlatformKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugGet: async (slug: string, includeEventCounts?: boolean, xPlatformKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('v2CategoriesSlugGet', 'slug', slug)
            const localVarPath = `/v2/categories/{slug}`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeEventCounts !== undefined) {
                localVarQueryParameter['include_event_counts'] = includeEventCounts;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deliberately not edge-cached, unlike every sibling on this controller: each answer is specific to one Dynamic Yield user. The no-store directive says so out loud, because a cache rule written for the category endpoints around it would otherwise be free to treat this as heuristically cacheable and hand one shopper\'s row to the next.
         * @summary Get live listings recommended for this category page, in the order Dynamic Yield ranked them. Each item carries the slot id to report back when a shopper clicks it.
         * @param {string} slug The category whose page is being viewed.
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [numRecommendations] How many recommendations to return at most, from 1 to 20; a count outside that range is brought into it. Fewer come back when Dynamic Yield ranked fewer, or when what it ranked is no longer something a shopper can buy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugRecommendationsGet: async (slug: string, xPlatformKey: string, numRecommendations?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('v2CategoriesSlugRecommendationsGet', 'slug', slug)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2CategoriesSlugRecommendationsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/categories/{slug}/recommendations`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (numRecommendations !== undefined) {
                localVarQueryParameter['num_recommendations'] = numRecommendations;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all related categories by slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugRelatedGet: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('v2CategoriesSlugRelatedGet', 'slug', slug)
            const localVarPath = `/v2/categories/{slug}/related`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a category relation based on auto generated MenuHierarchies
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugRelationsGet: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('v2CategoriesSlugRelationsGet', 'slug', slug)
            const localVarPath = `/v2/categories/{slug}/relations`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoriesApi - functional programming interface
 */
export const CategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get athlete categories by team category slugs. This endpoint finds team categories by their slugs, then uses their ExternalReferenceId to query the Sports service for associated athlete IDs, and returns the corresponding athlete categories.
         * @param {string} [teamCategorySlugs] Comma-separated list of team category slugs
         * @param {string} [searchTerm] Optional search term to filter athlete categories
         * @param {boolean} [followedOnly] 
         * @param {number} [offSet] The number of items to skip
         * @param {number} [pageSize] The maximum size of any individual subset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CategoriesAthletesGet(teamCategorySlugs?: string, searchTerm?: string, followedOnly?: boolean, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AthleteCategoryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CategoriesAthletesGet(teamCategorySlugs, searchTerm, followedOnly, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.v2CategoriesAthletesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a category by id
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CategoriesCategoryIdGet(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Category>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CategoriesCategoryIdGet(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.v2CategoriesCategoryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [relatedCategorySlug] 
         * @param {FilterEventStatus} [eventStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CategoriesEventsGet(relatedCategorySlug?: string, eventStatus?: FilterEventStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Category>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CategoriesEventsGet(relatedCategorySlug, eventStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.v2CategoriesEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all categories
         * @param {string} [searchTerm] 
         * @param {CategoryType} [type] 
         * @param {string} [categoryIds] 
         * @param {string} [slugs] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CategoriesGet(searchTerm?: string, type?: CategoryType, categoryIds?: string, slugs?: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CategoriesGet(searchTerm, type, categoryIds, slugs, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.v2CategoriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the categories with live events if types is empty it will use team, other category types by default the ordering of the types are important, if a event has more than 1 of the category types provided, it will be shown under most important category type, and the importance of the types are in the order you give
         * @param {string} xPlatformKey Select the platform.
         * @param {Array<CategoryType>} [types] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CategoriesLiveEventsGet(xPlatformKey: string, types?: Array<CategoryType>, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryLiveList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CategoriesLiveEventsGet(xPlatformKey, types, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.v2CategoriesLiveEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the most followed categories by their slugs. Returns categories with their follower counts, sorted by most followed.
         * @param {string} [categorySlugs] Comma-separated list of category slugs
         * @param {Date} [startAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CategoriesMostFollowedGet(categorySlugs?: string, startAfter?: Date, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryWithFollowersCount>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CategoriesMostFollowedGet(categorySlugs, startAfter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.v2CategoriesMostFollowedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a category by slug
         * @param {string} slug The category slug
         * @param {boolean} [includeEventCounts] Include live/upcoming/historical event counts for the platform identified by the X-Platform-Key header
         * @param {string} [xPlatformKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CategoriesSlugGet(slug: string, includeEventCounts?: boolean, xPlatformKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Category>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CategoriesSlugGet(slug, includeEventCounts, xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.v2CategoriesSlugGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deliberately not edge-cached, unlike every sibling on this controller: each answer is specific to one Dynamic Yield user. The no-store directive says so out loud, because a cache rule written for the category endpoints around it would otherwise be free to treat this as heuristically cacheable and hand one shopper\'s row to the next.
         * @summary Get live listings recommended for this category page, in the order Dynamic Yield ranked them. Each item carries the slot id to report back when a shopper clicks it.
         * @param {string} slug The category whose page is being viewed.
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [numRecommendations] How many recommendations to return at most, from 1 to 20; a count outside that range is brought into it. Fewer come back when Dynamic Yield ranked fewer, or when what it ranked is no longer something a shopper can buy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CategoriesSlugRecommendationsGet(slug: string, xPlatformKey: string, numRecommendations?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductRecommendations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CategoriesSlugRecommendationsGet(slug, xPlatformKey, numRecommendations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.v2CategoriesSlugRecommendationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all related categories by slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CategoriesSlugRelatedGet(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Category>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CategoriesSlugRelatedGet(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.v2CategoriesSlugRelatedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a category relation based on auto generated MenuHierarchies
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CategoriesSlugRelationsGet(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryRelations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CategoriesSlugRelationsGet(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.v2CategoriesSlugRelationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategoriesApi - factory interface
 */
export const CategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get athlete categories by team category slugs. This endpoint finds team categories by their slugs, then uses their ExternalReferenceId to query the Sports service for associated athlete IDs, and returns the corresponding athlete categories.
         * @param {CategoriesApiV2CategoriesAthletesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesAthletesGet(requestParameters: CategoriesApiV2CategoriesAthletesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AthleteCategoryList> {
            return localVarFp.v2CategoriesAthletesGet(requestParameters.teamCategorySlugs, requestParameters.searchTerm, requestParameters.followedOnly, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a category by id
         * @param {CategoriesApiV2CategoriesCategoryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesCategoryIdGet(requestParameters: CategoriesApiV2CategoriesCategoryIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Category> {
            return localVarFp.v2CategoriesCategoryIdGet(requestParameters.categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CategoriesApiV2CategoriesEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesEventsGet(requestParameters: CategoriesApiV2CategoriesEventsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<Category>> {
            return localVarFp.v2CategoriesEventsGet(requestParameters.relatedCategorySlug, requestParameters.eventStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all categories
         * @param {CategoriesApiV2CategoriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesGet(requestParameters: CategoriesApiV2CategoriesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CategoryList> {
            return localVarFp.v2CategoriesGet(requestParameters.searchTerm, requestParameters.type, requestParameters.categoryIds, requestParameters.slugs, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the categories with live events if types is empty it will use team, other category types by default the ordering of the types are important, if a event has more than 1 of the category types provided, it will be shown under most important category type, and the importance of the types are in the order you give
         * @param {CategoriesApiV2CategoriesLiveEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesLiveEventsGet(requestParameters: CategoriesApiV2CategoriesLiveEventsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryLiveList> {
            return localVarFp.v2CategoriesLiveEventsGet(requestParameters.xPlatformKey, requestParameters.types, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the most followed categories by their slugs. Returns categories with their follower counts, sorted by most followed.
         * @param {CategoriesApiV2CategoriesMostFollowedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesMostFollowedGet(requestParameters: CategoriesApiV2CategoriesMostFollowedGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryWithFollowersCount>> {
            return localVarFp.v2CategoriesMostFollowedGet(requestParameters.categorySlugs, requestParameters.startAfter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a category by slug
         * @param {CategoriesApiV2CategoriesSlugGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugGet(requestParameters: CategoriesApiV2CategoriesSlugGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Category> {
            return localVarFp.v2CategoriesSlugGet(requestParameters.slug, requestParameters.includeEventCounts, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Deliberately not edge-cached, unlike every sibling on this controller: each answer is specific to one Dynamic Yield user. The no-store directive says so out loud, because a cache rule written for the category endpoints around it would otherwise be free to treat this as heuristically cacheable and hand one shopper\'s row to the next.
         * @summary Get live listings recommended for this category page, in the order Dynamic Yield ranked them. Each item carries the slot id to report back when a shopper clicks it.
         * @param {CategoriesApiV2CategoriesSlugRecommendationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugRecommendationsGet(requestParameters: CategoriesApiV2CategoriesSlugRecommendationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductRecommendations> {
            return localVarFp.v2CategoriesSlugRecommendationsGet(requestParameters.slug, requestParameters.xPlatformKey, requestParameters.numRecommendations, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all related categories by slug
         * @param {CategoriesApiV2CategoriesSlugRelatedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugRelatedGet(requestParameters: CategoriesApiV2CategoriesSlugRelatedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Category>> {
            return localVarFp.v2CategoriesSlugRelatedGet(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a category relation based on auto generated MenuHierarchies
         * @param {CategoriesApiV2CategoriesSlugRelationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugRelationsGet(requestParameters: CategoriesApiV2CategoriesSlugRelationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryRelations> {
            return localVarFp.v2CategoriesSlugRelationsGet(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2CategoriesAthletesGet operation in CategoriesApi.
 */
export interface CategoriesApiV2CategoriesAthletesGetRequest {
    /**
     * Comma-separated list of team category slugs
     */
    readonly teamCategorySlugs?: string

    /**
     * Optional search term to filter athlete categories
     */
    readonly searchTerm?: string

    readonly followedOnly?: boolean

    /**
     * The number of items to skip
     */
    readonly offSet?: number

    /**
     * The maximum size of any individual subset
     */
    readonly pageSize?: number
}

/**
 * Request parameters for v2CategoriesCategoryIdGet operation in CategoriesApi.
 */
export interface CategoriesApiV2CategoriesCategoryIdGetRequest {
    readonly categoryId: string
}

/**
 * Request parameters for v2CategoriesEventsGet operation in CategoriesApi.
 */
export interface CategoriesApiV2CategoriesEventsGetRequest {
    readonly relatedCategorySlug?: string

    readonly eventStatus?: FilterEventStatus
}

/**
 * Request parameters for v2CategoriesGet operation in CategoriesApi.
 */
export interface CategoriesApiV2CategoriesGetRequest {
    readonly searchTerm?: string

    readonly type?: CategoryType

    readonly categoryIds?: string

    readonly slugs?: string

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for v2CategoriesLiveEventsGet operation in CategoriesApi.
 */
export interface CategoriesApiV2CategoriesLiveEventsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly types?: Array<CategoryType>

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for v2CategoriesMostFollowedGet operation in CategoriesApi.
 */
export interface CategoriesApiV2CategoriesMostFollowedGetRequest {
    /**
     * Comma-separated list of category slugs
     */
    readonly categorySlugs?: string

    readonly startAfter?: Date
}

/**
 * Request parameters for v2CategoriesSlugGet operation in CategoriesApi.
 */
export interface CategoriesApiV2CategoriesSlugGetRequest {
    /**
     * The category slug
     */
    readonly slug: string

    /**
     * Include live/upcoming/historical event counts for the platform identified by the X-Platform-Key header
     */
    readonly includeEventCounts?: boolean

    readonly xPlatformKey?: string
}

/**
 * Request parameters for v2CategoriesSlugRecommendationsGet operation in CategoriesApi.
 */
export interface CategoriesApiV2CategoriesSlugRecommendationsGetRequest {
    /**
     * The category whose page is being viewed.
     */
    readonly slug: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * How many recommendations to return at most, from 1 to 20; a count outside that range is brought into it. Fewer come back when Dynamic Yield ranked fewer, or when what it ranked is no longer something a shopper can buy.
     */
    readonly numRecommendations?: number
}

/**
 * Request parameters for v2CategoriesSlugRelatedGet operation in CategoriesApi.
 */
export interface CategoriesApiV2CategoriesSlugRelatedGetRequest {
    readonly slug: string
}

/**
 * Request parameters for v2CategoriesSlugRelationsGet operation in CategoriesApi.
 */
export interface CategoriesApiV2CategoriesSlugRelationsGetRequest {
    readonly slug: string
}

/**
 * CategoriesApi - object-oriented interface
 */
export class CategoriesApi extends BaseAPI {
    /**
     * 
     * @summary Get athlete categories by team category slugs. This endpoint finds team categories by their slugs, then uses their ExternalReferenceId to query the Sports service for associated athlete IDs, and returns the corresponding athlete categories.
     * @param {CategoriesApiV2CategoriesAthletesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CategoriesAthletesGet(requestParameters: CategoriesApiV2CategoriesAthletesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).v2CategoriesAthletesGet(requestParameters.teamCategorySlugs, requestParameters.searchTerm, requestParameters.followedOnly, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a category by id
     * @param {CategoriesApiV2CategoriesCategoryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CategoriesCategoryIdGet(requestParameters: CategoriesApiV2CategoriesCategoryIdGetRequest, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).v2CategoriesCategoryIdGet(requestParameters.categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CategoriesApiV2CategoriesEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CategoriesEventsGet(requestParameters: CategoriesApiV2CategoriesEventsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).v2CategoriesEventsGet(requestParameters.relatedCategorySlug, requestParameters.eventStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all categories
     * @param {CategoriesApiV2CategoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CategoriesGet(requestParameters: CategoriesApiV2CategoriesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).v2CategoriesGet(requestParameters.searchTerm, requestParameters.type, requestParameters.categoryIds, requestParameters.slugs, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the categories with live events if types is empty it will use team, other category types by default the ordering of the types are important, if a event has more than 1 of the category types provided, it will be shown under most important category type, and the importance of the types are in the order you give
     * @param {CategoriesApiV2CategoriesLiveEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CategoriesLiveEventsGet(requestParameters: CategoriesApiV2CategoriesLiveEventsGetRequest, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).v2CategoriesLiveEventsGet(requestParameters.xPlatformKey, requestParameters.types, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the most followed categories by their slugs. Returns categories with their follower counts, sorted by most followed.
     * @param {CategoriesApiV2CategoriesMostFollowedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CategoriesMostFollowedGet(requestParameters: CategoriesApiV2CategoriesMostFollowedGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).v2CategoriesMostFollowedGet(requestParameters.categorySlugs, requestParameters.startAfter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a category by slug
     * @param {CategoriesApiV2CategoriesSlugGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CategoriesSlugGet(requestParameters: CategoriesApiV2CategoriesSlugGetRequest, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).v2CategoriesSlugGet(requestParameters.slug, requestParameters.includeEventCounts, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deliberately not edge-cached, unlike every sibling on this controller: each answer is specific to one Dynamic Yield user. The no-store directive says so out loud, because a cache rule written for the category endpoints around it would otherwise be free to treat this as heuristically cacheable and hand one shopper\'s row to the next.
     * @summary Get live listings recommended for this category page, in the order Dynamic Yield ranked them. Each item carries the slot id to report back when a shopper clicks it.
     * @param {CategoriesApiV2CategoriesSlugRecommendationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CategoriesSlugRecommendationsGet(requestParameters: CategoriesApiV2CategoriesSlugRecommendationsGetRequest, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).v2CategoriesSlugRecommendationsGet(requestParameters.slug, requestParameters.xPlatformKey, requestParameters.numRecommendations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all related categories by slug
     * @param {CategoriesApiV2CategoriesSlugRelatedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CategoriesSlugRelatedGet(requestParameters: CategoriesApiV2CategoriesSlugRelatedGetRequest, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).v2CategoriesSlugRelatedGet(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a category relation based on auto generated MenuHierarchies
     * @param {CategoriesApiV2CategoriesSlugRelationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CategoriesSlugRelationsGet(requestParameters: CategoriesApiV2CategoriesSlugRelationsGetRequest, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).v2CategoriesSlugRelationsGet(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CategoryAuctionsApi - axios parameter creator
 */
export const CategoryAuctionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} categoryId 
         * @param {AuctionSorting} [sorting] 
         * @param {boolean} [launchedToday] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesCategoryIdAuctionsGet: async (categoryId: string, sorting?: AuctionSorting, launchedToday?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('v2CategoriesCategoryIdAuctionsGet', 'categoryId', categoryId)
            const localVarPath = `/v2/categories/{categoryId}/auctions`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sorting !== undefined) {
                localVarQueryParameter['sorting'] = sorting;
            }

            if (launchedToday !== undefined) {
                localVarQueryParameter['launched_today'] = launchedToday;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoryAuctionsApi - functional programming interface
 */
export const CategoryAuctionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoryAuctionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} categoryId 
         * @param {AuctionSorting} [sorting] 
         * @param {boolean} [launchedToday] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CategoriesCategoryIdAuctionsGet(categoryId: string, sorting?: AuctionSorting, launchedToday?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryAuctions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CategoriesCategoryIdAuctionsGet(categoryId, sorting, launchedToday, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryAuctionsApi.v2CategoriesCategoryIdAuctionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategoryAuctionsApi - factory interface
 */
export const CategoryAuctionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoryAuctionsApiFp(configuration)
    return {
        /**
         * 
         * @param {CategoryAuctionsApiV2CategoriesCategoryIdAuctionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesCategoryIdAuctionsGet(requestParameters: CategoryAuctionsApiV2CategoriesCategoryIdAuctionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryAuctions> {
            return localVarFp.v2CategoriesCategoryIdAuctionsGet(requestParameters.categoryId, requestParameters.sorting, requestParameters.launchedToday, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2CategoriesCategoryIdAuctionsGet operation in CategoryAuctionsApi.
 */
export interface CategoryAuctionsApiV2CategoriesCategoryIdAuctionsGetRequest {
    readonly categoryId: string

    readonly sorting?: AuctionSorting

    readonly launchedToday?: boolean
}

/**
 * CategoryAuctionsApi - object-oriented interface
 */
export class CategoryAuctionsApi extends BaseAPI {
    /**
     * 
     * @param {CategoryAuctionsApiV2CategoriesCategoryIdAuctionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CategoriesCategoryIdAuctionsGet(requestParameters: CategoryAuctionsApiV2CategoriesCategoryIdAuctionsGetRequest, options?: RawAxiosRequestConfig) {
        return CategoryAuctionsApiFp(this.configuration).v2CategoriesCategoryIdAuctionsGet(requestParameters.categoryId, requestParameters.sorting, requestParameters.launchedToday, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CategoryProductsApi - axios parameter creator
 */
export const CategoryProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get products for a category
         * @param {string} slug 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [filterOnSlugs] 
         * @param {boolean} [highlighted] 
         * @param {Date} [endDateMin] 
         * @param {Date} [endDateMax] 
         * @param {Date} [startDateMin] 
         * @param {Date} [startDateMax] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugProductsGet: async (slug: string, xPlatformKey: string, filterOnSlugs?: string, highlighted?: boolean, endDateMin?: Date, endDateMax?: Date, startDateMin?: Date, startDateMax?: Date, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('v2CategoriesSlugProductsGet', 'slug', slug)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2CategoriesSlugProductsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/categories/{slug}/products`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterOnSlugs !== undefined) {
                localVarQueryParameter['filter_on_slugs'] = filterOnSlugs;
            }

            if (highlighted !== undefined) {
                localVarQueryParameter['highlighted'] = highlighted;
            }

            if (endDateMin !== undefined) {
                localVarQueryParameter['end_date.min'] = (endDateMin as any instanceof Date) ?
                    (endDateMin as any).toISOString() :
                    endDateMin;
            }

            if (endDateMax !== undefined) {
                localVarQueryParameter['end_date.max'] = (endDateMax as any instanceof Date) ?
                    (endDateMax as any).toISOString() :
                    endDateMax;
            }

            if (startDateMin !== undefined) {
                localVarQueryParameter['start_date.min'] = (startDateMin as any instanceof Date) ?
                    (startDateMin as any).toISOString() :
                    startDateMin;
            }

            if (startDateMax !== undefined) {
                localVarQueryParameter['start_date.max'] = (startDateMax as any instanceof Date) ?
                    (startDateMax as any).toISOString() :
                    startDateMax;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoryProductsApi - functional programming interface
 */
export const CategoryProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoryProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get products for a category
         * @param {string} slug 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [filterOnSlugs] 
         * @param {boolean} [highlighted] 
         * @param {Date} [endDateMin] 
         * @param {Date} [endDateMax] 
         * @param {Date} [startDateMin] 
         * @param {Date} [startDateMax] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CategoriesSlugProductsGet(slug: string, xPlatformKey: string, filterOnSlugs?: string, highlighted?: boolean, endDateMin?: Date, endDateMax?: Date, startDateMin?: Date, startDateMax?: Date, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryProductList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CategoriesSlugProductsGet(slug, xPlatformKey, filterOnSlugs, highlighted, endDateMin, endDateMax, startDateMin, startDateMax, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryProductsApi.v2CategoriesSlugProductsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategoryProductsApi - factory interface
 */
export const CategoryProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoryProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get products for a category
         * @param {CategoryProductsApiV2CategoriesSlugProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugProductsGet(requestParameters: CategoryProductsApiV2CategoriesSlugProductsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryProductList> {
            return localVarFp.v2CategoriesSlugProductsGet(requestParameters.slug, requestParameters.xPlatformKey, requestParameters.filterOnSlugs, requestParameters.highlighted, requestParameters.endDateMin, requestParameters.endDateMax, requestParameters.startDateMin, requestParameters.startDateMax, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2CategoriesSlugProductsGet operation in CategoryProductsApi.
 */
export interface CategoryProductsApiV2CategoriesSlugProductsGetRequest {
    readonly slug: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly filterOnSlugs?: string

    readonly highlighted?: boolean

    readonly endDateMin?: Date

    readonly endDateMax?: Date

    readonly startDateMin?: Date

    readonly startDateMax?: Date

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * CategoryProductsApi - object-oriented interface
 */
export class CategoryProductsApi extends BaseAPI {
    /**
     * 
     * @summary Get products for a category
     * @param {CategoryProductsApiV2CategoriesSlugProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CategoriesSlugProductsGet(requestParameters: CategoryProductsApiV2CategoriesSlugProductsGetRequest, options?: RawAxiosRequestConfig) {
        return CategoryProductsApiFp(this.configuration).v2CategoriesSlugProductsGet(requestParameters.slug, requestParameters.xPlatformKey, requestParameters.filterOnSlugs, requestParameters.highlighted, requestParameters.endDateMin, requestParameters.endDateMax, requestParameters.startDateMin, requestParameters.startDateMax, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClaimsApi - axios parameter creator
 */
export const ClaimsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ClaimsClaimIdGet: async (claimId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('v2ClaimsClaimIdGet', 'claimId', claimId)
            const localVarPath = `/v2/claims/{claimId}`
                .replace('{claimId}', encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get claims for a user
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ClaimsGet: async (offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimsApi - functional programming interface
 */
export const ClaimsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClaimsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ClaimsClaimIdGet(claimId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Claim>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ClaimsClaimIdGet(claimId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsApi.v2ClaimsClaimIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get claims for a user
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ClaimsGet(offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ClaimsGet(offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsApi.v2ClaimsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClaimsApi - factory interface
 */
export const ClaimsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClaimsApiFp(configuration)
    return {
        /**
         * 
         * @param {ClaimsApiV2ClaimsClaimIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ClaimsClaimIdGet(requestParameters: ClaimsApiV2ClaimsClaimIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Claim> {
            return localVarFp.v2ClaimsClaimIdGet(requestParameters.claimId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get claims for a user
         * @param {ClaimsApiV2ClaimsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ClaimsGet(requestParameters: ClaimsApiV2ClaimsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClaimList> {
            return localVarFp.v2ClaimsGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2ClaimsClaimIdGet operation in ClaimsApi.
 */
export interface ClaimsApiV2ClaimsClaimIdGetRequest {
    readonly claimId: string
}

/**
 * Request parameters for v2ClaimsGet operation in ClaimsApi.
 */
export interface ClaimsApiV2ClaimsGetRequest {
    readonly offset?: number

    readonly pageSize?: number
}

/**
 * ClaimsApi - object-oriented interface
 */
export class ClaimsApi extends BaseAPI {
    /**
     * 
     * @param {ClaimsApiV2ClaimsClaimIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ClaimsClaimIdGet(requestParameters: ClaimsApiV2ClaimsClaimIdGetRequest, options?: RawAxiosRequestConfig) {
        return ClaimsApiFp(this.configuration).v2ClaimsClaimIdGet(requestParameters.claimId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get claims for a user
     * @param {ClaimsApiV2ClaimsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ClaimsGet(requestParameters: ClaimsApiV2ClaimsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ClaimsApiFp(this.configuration).v2ClaimsGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CollectionsApi - axios parameter creator
 */
export const CollectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Remove a single claim from a collection owned by the authenticated user.
         * @param {string} collectionId 
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsCollectionIdClaimsClaimIdDelete: async (collectionId: string, claimId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectionId' is not null or undefined
            assertParamExists('v2CollectionsCollectionIdClaimsClaimIdDelete', 'collectionId', collectionId)
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('v2CollectionsCollectionIdClaimsClaimIdDelete', 'claimId', claimId)
            const localVarPath = `/v2/collections/{collectionId}/claims/{claimId}`
                .replace('{collectionId}', encodeURIComponent(String(collectionId)))
                .replace('{claimId}', encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk add claims to a collection owned by the authenticated user. Claims already in the collection are left as-is; claim ids not owned by the user are ignored.
         * @param {string} collectionId 
         * @param {AddClaimsToCollectionRequest} addClaimsToCollectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsCollectionIdClaimsPost: async (collectionId: string, addClaimsToCollectionRequest: AddClaimsToCollectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectionId' is not null or undefined
            assertParamExists('v2CollectionsCollectionIdClaimsPost', 'collectionId', collectionId)
            // verify required parameter 'addClaimsToCollectionRequest' is not null or undefined
            assertParamExists('v2CollectionsCollectionIdClaimsPost', 'addClaimsToCollectionRequest', addClaimsToCollectionRequest)
            const localVarPath = `/v2/collections/{collectionId}/claims`
                .replace('{collectionId}', encodeURIComponent(String(collectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = addClaimsToCollectionRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a collection for the authenticated user. The default collection cannot be deleted.
         * @param {string} collectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsCollectionIdDelete: async (collectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectionId' is not null or undefined
            assertParamExists('v2CollectionsCollectionIdDelete', 'collectionId', collectionId)
            const localVarPath = `/v2/collections/{collectionId}`
                .replace('{collectionId}', encodeURIComponent(String(collectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rename a collection owned by the authenticated user.
         * @param {string} collectionId 
         * @param {UpdateCollectionNameRequest} updateCollectionNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsCollectionIdNamePatch: async (collectionId: string, updateCollectionNameRequest: UpdateCollectionNameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectionId' is not null or undefined
            assertParamExists('v2CollectionsCollectionIdNamePatch', 'collectionId', collectionId)
            // verify required parameter 'updateCollectionNameRequest' is not null or undefined
            assertParamExists('v2CollectionsCollectionIdNamePatch', 'updateCollectionNameRequest', updateCollectionNameRequest)
            const localVarPath = `/v2/collections/{collectionId}/name`
                .replace('{collectionId}', encodeURIComponent(String(collectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = updateCollectionNameRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the default collection for the authenticated user
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsDefaultGet: async (offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/collections/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the collections for the authenticated user, paginated.
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsGet: async (offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new collection for the authenticated user
         * @param {CreateCollectionRequest} createCollectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsPost: async (createCollectionRequest: CreateCollectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCollectionRequest' is not null or undefined
            assertParamExists('v2CollectionsPost', 'createCollectionRequest', createCollectionRequest)
            const localVarPath = `/v2/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = createCollectionRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CollectionsApi - functional programming interface
 */
export const CollectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CollectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Remove a single claim from a collection owned by the authenticated user.
         * @param {string} collectionId 
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CollectionsCollectionIdClaimsClaimIdDelete(collectionId: string, claimId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CollectionsCollectionIdClaimsClaimIdDelete(collectionId, claimId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.v2CollectionsCollectionIdClaimsClaimIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk add claims to a collection owned by the authenticated user. Claims already in the collection are left as-is; claim ids not owned by the user are ignored.
         * @param {string} collectionId 
         * @param {AddClaimsToCollectionRequest} addClaimsToCollectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CollectionsCollectionIdClaimsPost(collectionId: string, addClaimsToCollectionRequest: AddClaimsToCollectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CollectionsCollectionIdClaimsPost(collectionId, addClaimsToCollectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.v2CollectionsCollectionIdClaimsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a collection for the authenticated user. The default collection cannot be deleted.
         * @param {string} collectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CollectionsCollectionIdDelete(collectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CollectionsCollectionIdDelete(collectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.v2CollectionsCollectionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rename a collection owned by the authenticated user.
         * @param {string} collectionId 
         * @param {UpdateCollectionNameRequest} updateCollectionNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CollectionsCollectionIdNamePatch(collectionId: string, updateCollectionNameRequest: UpdateCollectionNameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CollectionsCollectionIdNamePatch(collectionId, updateCollectionNameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.v2CollectionsCollectionIdNamePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the default collection for the authenticated user
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CollectionsDefaultGet(offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Collection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CollectionsDefaultGet(offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.v2CollectionsDefaultGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the collections for the authenticated user, paginated.
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CollectionsGet(offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionSummaryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CollectionsGet(offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.v2CollectionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new collection for the authenticated user
         * @param {CreateCollectionRequest} createCollectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CollectionsPost(createCollectionRequest: CreateCollectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CollectionsPost(createCollectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.v2CollectionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CollectionsApi - factory interface
 */
export const CollectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CollectionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Remove a single claim from a collection owned by the authenticated user.
         * @param {CollectionsApiV2CollectionsCollectionIdClaimsClaimIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsCollectionIdClaimsClaimIdDelete(requestParameters: CollectionsApiV2CollectionsCollectionIdClaimsClaimIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2CollectionsCollectionIdClaimsClaimIdDelete(requestParameters.collectionId, requestParameters.claimId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk add claims to a collection owned by the authenticated user. Claims already in the collection are left as-is; claim ids not owned by the user are ignored.
         * @param {CollectionsApiV2CollectionsCollectionIdClaimsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsCollectionIdClaimsPost(requestParameters: CollectionsApiV2CollectionsCollectionIdClaimsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2CollectionsCollectionIdClaimsPost(requestParameters.collectionId, requestParameters.addClaimsToCollectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a collection for the authenticated user. The default collection cannot be deleted.
         * @param {CollectionsApiV2CollectionsCollectionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsCollectionIdDelete(requestParameters: CollectionsApiV2CollectionsCollectionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2CollectionsCollectionIdDelete(requestParameters.collectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rename a collection owned by the authenticated user.
         * @param {CollectionsApiV2CollectionsCollectionIdNamePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsCollectionIdNamePatch(requestParameters: CollectionsApiV2CollectionsCollectionIdNamePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2CollectionsCollectionIdNamePatch(requestParameters.collectionId, requestParameters.updateCollectionNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the default collection for the authenticated user
         * @param {CollectionsApiV2CollectionsDefaultGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsDefaultGet(requestParameters: CollectionsApiV2CollectionsDefaultGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Collection> {
            return localVarFp.v2CollectionsDefaultGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the collections for the authenticated user, paginated.
         * @param {CollectionsApiV2CollectionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsGet(requestParameters: CollectionsApiV2CollectionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CollectionSummaryList> {
            return localVarFp.v2CollectionsGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new collection for the authenticated user
         * @param {CollectionsApiV2CollectionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CollectionsPost(requestParameters: CollectionsApiV2CollectionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.v2CollectionsPost(requestParameters.createCollectionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2CollectionsCollectionIdClaimsClaimIdDelete operation in CollectionsApi.
 */
export interface CollectionsApiV2CollectionsCollectionIdClaimsClaimIdDeleteRequest {
    readonly collectionId: string

    readonly claimId: string
}

/**
 * Request parameters for v2CollectionsCollectionIdClaimsPost operation in CollectionsApi.
 */
export interface CollectionsApiV2CollectionsCollectionIdClaimsPostRequest {
    readonly collectionId: string

    readonly addClaimsToCollectionRequest: AddClaimsToCollectionRequest
}

/**
 * Request parameters for v2CollectionsCollectionIdDelete operation in CollectionsApi.
 */
export interface CollectionsApiV2CollectionsCollectionIdDeleteRequest {
    readonly collectionId: string
}

/**
 * Request parameters for v2CollectionsCollectionIdNamePatch operation in CollectionsApi.
 */
export interface CollectionsApiV2CollectionsCollectionIdNamePatchRequest {
    readonly collectionId: string

    readonly updateCollectionNameRequest: UpdateCollectionNameRequest
}

/**
 * Request parameters for v2CollectionsDefaultGet operation in CollectionsApi.
 */
export interface CollectionsApiV2CollectionsDefaultGetRequest {
    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for v2CollectionsGet operation in CollectionsApi.
 */
export interface CollectionsApiV2CollectionsGetRequest {
    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for v2CollectionsPost operation in CollectionsApi.
 */
export interface CollectionsApiV2CollectionsPostRequest {
    readonly createCollectionRequest: CreateCollectionRequest
}

/**
 * CollectionsApi - object-oriented interface
 */
export class CollectionsApi extends BaseAPI {
    /**
     * 
     * @summary Remove a single claim from a collection owned by the authenticated user.
     * @param {CollectionsApiV2CollectionsCollectionIdClaimsClaimIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CollectionsCollectionIdClaimsClaimIdDelete(requestParameters: CollectionsApiV2CollectionsCollectionIdClaimsClaimIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).v2CollectionsCollectionIdClaimsClaimIdDelete(requestParameters.collectionId, requestParameters.claimId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk add claims to a collection owned by the authenticated user. Claims already in the collection are left as-is; claim ids not owned by the user are ignored.
     * @param {CollectionsApiV2CollectionsCollectionIdClaimsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CollectionsCollectionIdClaimsPost(requestParameters: CollectionsApiV2CollectionsCollectionIdClaimsPostRequest, options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).v2CollectionsCollectionIdClaimsPost(requestParameters.collectionId, requestParameters.addClaimsToCollectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a collection for the authenticated user. The default collection cannot be deleted.
     * @param {CollectionsApiV2CollectionsCollectionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CollectionsCollectionIdDelete(requestParameters: CollectionsApiV2CollectionsCollectionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).v2CollectionsCollectionIdDelete(requestParameters.collectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rename a collection owned by the authenticated user.
     * @param {CollectionsApiV2CollectionsCollectionIdNamePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CollectionsCollectionIdNamePatch(requestParameters: CollectionsApiV2CollectionsCollectionIdNamePatchRequest, options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).v2CollectionsCollectionIdNamePatch(requestParameters.collectionId, requestParameters.updateCollectionNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the default collection for the authenticated user
     * @param {CollectionsApiV2CollectionsDefaultGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CollectionsDefaultGet(requestParameters: CollectionsApiV2CollectionsDefaultGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).v2CollectionsDefaultGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the collections for the authenticated user, paginated.
     * @param {CollectionsApiV2CollectionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CollectionsGet(requestParameters: CollectionsApiV2CollectionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).v2CollectionsGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new collection for the authenticated user
     * @param {CollectionsApiV2CollectionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2CollectionsPost(requestParameters: CollectionsApiV2CollectionsPostRequest, options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).v2CollectionsPost(requestParameters.createCollectionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContentApi - axios parameter creator
 */
export const ContentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Storyblok endpoint that returns the Category names and slugs
         * @param {CategoryType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2StoryblokContentCategoriesGet: async (type?: CategoryType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/storyblok/content/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Storyblok endpoint that returns the Category slugs and logoUrls
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2StoryblokContentCategoriesLogosGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/storyblok/content/categories/logos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Storyblok endpoint that returns the names and ids of active product types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2StoryblokContentProductTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/storyblok/content/product-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentApi - functional programming interface
 */
export const ContentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Storyblok endpoint that returns the Category names and slugs
         * @param {CategoryType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2StoryblokContentCategoriesGet(type?: CategoryType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StoryBlokCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2StoryblokContentCategoriesGet(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.v2StoryblokContentCategoriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Storyblok endpoint that returns the Category slugs and logoUrls
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2StoryblokContentCategoriesLogosGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StoryBlokCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2StoryblokContentCategoriesLogosGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.v2StoryblokContentCategoriesLogosGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Storyblok endpoint that returns the names and ids of active product types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2StoryblokContentProductTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StoryBlokProductType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2StoryblokContentProductTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.v2StoryblokContentProductTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContentApi - factory interface
 */
export const ContentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContentApiFp(configuration)
    return {
        /**
         * 
         * @summary Storyblok endpoint that returns the Category names and slugs
         * @param {ContentApiV2StoryblokContentCategoriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2StoryblokContentCategoriesGet(requestParameters: ContentApiV2StoryblokContentCategoriesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<StoryBlokCategory>> {
            return localVarFp.v2StoryblokContentCategoriesGet(requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Storyblok endpoint that returns the Category slugs and logoUrls
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2StoryblokContentCategoriesLogosGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<StoryBlokCategory>> {
            return localVarFp.v2StoryblokContentCategoriesLogosGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Storyblok endpoint that returns the names and ids of active product types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2StoryblokContentProductTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<StoryBlokProductType>> {
            return localVarFp.v2StoryblokContentProductTypesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2StoryblokContentCategoriesGet operation in ContentApi.
 */
export interface ContentApiV2StoryblokContentCategoriesGetRequest {
    readonly type?: CategoryType
}

/**
 * ContentApi - object-oriented interface
 */
export class ContentApi extends BaseAPI {
    /**
     * 
     * @summary Storyblok endpoint that returns the Category names and slugs
     * @param {ContentApiV2StoryblokContentCategoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2StoryblokContentCategoriesGet(requestParameters: ContentApiV2StoryblokContentCategoriesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).v2StoryblokContentCategoriesGet(requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Storyblok endpoint that returns the Category slugs and logoUrls
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2StoryblokContentCategoriesLogosGet(options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).v2StoryblokContentCategoriesLogosGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Storyblok endpoint that returns the names and ids of active product types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2StoryblokContentProductTypesGet(options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).v2StoryblokContentProductTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventsApi - axios parameter creator
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all events.
         * @param {string} xPlatformKey Select the platform.
         * @param {Date} [endDateMin] 
         * @param {Date} [endDateMax] 
         * @param {Date} [startDateMin] 
         * @param {Date} [startDateMax] 
         * @param {EventSortAttribute} [sort] Used to indicate the field to sort on
         * @param {SortDirection} [sortBy] Used to indicate the sort direction
         * @param {string} [categoryIdsString] Used to filter by one or more category ids
         * @param {boolean} [highlighted] When true will return all the highlighted events, when false will return only non-highlighted events
         * @param {boolean} [homePageVisibility] [Deprecated] When true exclude events with ExcludeFromHomePage set to true.
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsGet: async (xPlatformKey: string, endDateMin?: Date, endDateMax?: Date, startDateMin?: Date, startDateMax?: Date, sort?: EventSortAttribute, sortBy?: SortDirection, categoryIdsString?: string, highlighted?: boolean, homePageVisibility?: boolean, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2EventsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (endDateMin !== undefined) {
                localVarQueryParameter['end_date.min'] = (endDateMin as any instanceof Date) ?
                    (endDateMin as any).toISOString() :
                    endDateMin;
            }

            if (endDateMax !== undefined) {
                localVarQueryParameter['end_date.max'] = (endDateMax as any instanceof Date) ?
                    (endDateMax as any).toISOString() :
                    endDateMax;
            }

            if (startDateMin !== undefined) {
                localVarQueryParameter['start_date.min'] = (startDateMin as any instanceof Date) ?
                    (startDateMin as any).toISOString() :
                    startDateMin;
            }

            if (startDateMax !== undefined) {
                localVarQueryParameter['start_date.max'] = (startDateMax as any instanceof Date) ?
                    (startDateMax as any).toISOString() :
                    startDateMax;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (categoryIdsString !== undefined) {
                localVarQueryParameter['category_ids_string'] = categoryIdsString;
            }

            if (highlighted !== undefined) {
                localVarQueryParameter['highlighted'] = highlighted;
            }

            if (homePageVisibility !== undefined) {
                localVarQueryParameter['home_page_visibility'] = homePageVisibility;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific event.
         * @param {string} id The identifier uniquely referring to this event. This can be its id or slug.
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsIdGet: async (id: string, xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('v2EventsIdGet', 'id', id)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2EventsIdGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/events/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all events.
         * @param {string} xPlatformKey Select the platform.
         * @param {Date} [endDateMin] 
         * @param {Date} [endDateMax] 
         * @param {Date} [startDateMin] 
         * @param {Date} [startDateMax] 
         * @param {EventSortAttribute} [sort] Used to indicate the field to sort on
         * @param {SortDirection} [sortBy] Used to indicate the sort direction
         * @param {string} [categoryIdsString] Used to filter by one or more category ids
         * @param {boolean} [highlighted] When true will return all the highlighted events, when false will return only non-highlighted events
         * @param {boolean} [homePageVisibility] [Deprecated] When true exclude events with ExcludeFromHomePage set to true.
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2EventsGet(xPlatformKey: string, endDateMin?: Date, endDateMax?: Date, startDateMin?: Date, startDateMax?: Date, sort?: EventSortAttribute, sortBy?: SortDirection, categoryIdsString?: string, highlighted?: boolean, homePageVisibility?: boolean, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2EventsGet(xPlatformKey, endDateMin, endDateMax, startDateMin, startDateMax, sort, sortBy, categoryIdsString, highlighted, homePageVisibility, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.v2EventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a specific event.
         * @param {string} id The identifier uniquely referring to this event. This can be its id or slug.
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2EventsIdGet(id: string, xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2EventsIdGet(id, xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.v2EventsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventsApi - factory interface
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * 
         * @summary List all events.
         * @param {EventsApiV2EventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsGet(requestParameters: EventsApiV2EventsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventList> {
            return localVarFp.v2EventsGet(requestParameters.xPlatformKey, requestParameters.endDateMin, requestParameters.endDateMax, requestParameters.startDateMin, requestParameters.startDateMax, requestParameters.sort, requestParameters.sortBy, requestParameters.categoryIdsString, requestParameters.highlighted, requestParameters.homePageVisibility, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific event.
         * @param {EventsApiV2EventsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsIdGet(requestParameters: EventsApiV2EventsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventDetails> {
            return localVarFp.v2EventsIdGet(requestParameters.id, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2EventsGet operation in EventsApi.
 */
export interface EventsApiV2EventsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly endDateMin?: Date

    readonly endDateMax?: Date

    readonly startDateMin?: Date

    readonly startDateMax?: Date

    /**
     * Used to indicate the field to sort on
     */
    readonly sort?: EventSortAttribute

    /**
     * Used to indicate the sort direction
     */
    readonly sortBy?: SortDirection

    /**
     * Used to filter by one or more category ids
     */
    readonly categoryIdsString?: string

    /**
     * When true will return all the highlighted events, when false will return only non-highlighted events
     */
    readonly highlighted?: boolean

    /**
     * [Deprecated] When true exclude events with ExcludeFromHomePage set to true.
     */
    readonly homePageVisibility?: boolean

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for v2EventsIdGet operation in EventsApi.
 */
export interface EventsApiV2EventsIdGetRequest {
    /**
     * The identifier uniquely referring to this event. This can be its id or slug.
     */
    readonly id: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * EventsApi - object-oriented interface
 */
export class EventsApi extends BaseAPI {
    /**
     * 
     * @summary List all events.
     * @param {EventsApiV2EventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2EventsGet(requestParameters: EventsApiV2EventsGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).v2EventsGet(requestParameters.xPlatformKey, requestParameters.endDateMin, requestParameters.endDateMax, requestParameters.startDateMin, requestParameters.startDateMax, requestParameters.sort, requestParameters.sortBy, requestParameters.categoryIdsString, requestParameters.highlighted, requestParameters.homePageVisibility, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific event.
     * @param {EventsApiV2EventsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2EventsIdGet(requestParameters: EventsApiV2EventsIdGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).v2EventsIdGet(requestParameters.id, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventsOverviewApi - axios parameter creator
 */
export const EventsOverviewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {DateSortAttribute} [sortBy] 
         * @param {DateSortDirection} [sortDirection] 
         * @param {LiveStatus} [liveStatus] 
         * @param {string} [parentCategoryId] 
         * @param {string} [parentCategorySlug] 
         * @param {string} [currency] 
         * @param {boolean} [onHomepage] 
         * @param {boolean} [onNowLive] 
         * @param {boolean} [inPlay] 
         * @param {boolean} [endingSoon] 
         * @param {Array<string>} [categoryIds] 
         * @param {string} [eventId] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {number} [maxNumberOfProducts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsOverviewGet: async (xPlatformKey: string, sortBy?: DateSortAttribute, sortDirection?: DateSortDirection, liveStatus?: LiveStatus, parentCategoryId?: string, parentCategorySlug?: string, currency?: string, onHomepage?: boolean, onNowLive?: boolean, inPlay?: boolean, endingSoon?: boolean, categoryIds?: Array<string>, eventId?: string, pageSize?: number, offset?: number, maxNumberOfProducts?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2EventsOverviewGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/events-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (liveStatus !== undefined) {
                localVarQueryParameter['live_status'] = liveStatus;
            }

            if (parentCategoryId !== undefined) {
                localVarQueryParameter['parent_category_id'] = parentCategoryId;
            }

            if (parentCategorySlug !== undefined) {
                localVarQueryParameter['parent_category_slug'] = parentCategorySlug;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (onHomepage !== undefined) {
                localVarQueryParameter['on_homepage'] = onHomepage;
            }

            if (onNowLive !== undefined) {
                localVarQueryParameter['on_now_live'] = onNowLive;
            }

            if (inPlay !== undefined) {
                localVarQueryParameter['in_play'] = inPlay;
            }

            if (endingSoon !== undefined) {
                localVarQueryParameter['ending_soon'] = endingSoon;
            }

            if (categoryIds) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }

            if (eventId !== undefined) {
                localVarQueryParameter['event_id'] = eventId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (maxNumberOfProducts !== undefined) {
                localVarQueryParameter['max_number_of_products'] = maxNumberOfProducts;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsOverviewApi - functional programming interface
 */
export const EventsOverviewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsOverviewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {DateSortAttribute} [sortBy] 
         * @param {DateSortDirection} [sortDirection] 
         * @param {LiveStatus} [liveStatus] 
         * @param {string} [parentCategoryId] 
         * @param {string} [parentCategorySlug] 
         * @param {string} [currency] 
         * @param {boolean} [onHomepage] 
         * @param {boolean} [onNowLive] 
         * @param {boolean} [inPlay] 
         * @param {boolean} [endingSoon] 
         * @param {Array<string>} [categoryIds] 
         * @param {string} [eventId] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {number} [maxNumberOfProducts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2EventsOverviewGet(xPlatformKey: string, sortBy?: DateSortAttribute, sortDirection?: DateSortDirection, liveStatus?: LiveStatus, parentCategoryId?: string, parentCategorySlug?: string, currency?: string, onHomepage?: boolean, onNowLive?: boolean, inPlay?: boolean, endingSoon?: boolean, categoryIds?: Array<string>, eventId?: string, pageSize?: number, offset?: number, maxNumberOfProducts?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventsOverviewList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2EventsOverviewGet(xPlatformKey, sortBy, sortDirection, liveStatus, parentCategoryId, parentCategorySlug, currency, onHomepage, onNowLive, inPlay, endingSoon, categoryIds, eventId, pageSize, offset, maxNumberOfProducts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsOverviewApi.v2EventsOverviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventsOverviewApi - factory interface
 */
export const EventsOverviewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsOverviewApiFp(configuration)
    return {
        /**
         * 
         * @param {EventsOverviewApiV2EventsOverviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsOverviewGet(requestParameters: EventsOverviewApiV2EventsOverviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventsOverviewList> {
            return localVarFp.v2EventsOverviewGet(requestParameters.xPlatformKey, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.liveStatus, requestParameters.parentCategoryId, requestParameters.parentCategorySlug, requestParameters.currency, requestParameters.onHomepage, requestParameters.onNowLive, requestParameters.inPlay, requestParameters.endingSoon, requestParameters.categoryIds, requestParameters.eventId, requestParameters.pageSize, requestParameters.offset, requestParameters.maxNumberOfProducts, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2EventsOverviewGet operation in EventsOverviewApi.
 */
export interface EventsOverviewApiV2EventsOverviewGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly sortBy?: DateSortAttribute

    readonly sortDirection?: DateSortDirection

    readonly liveStatus?: LiveStatus

    readonly parentCategoryId?: string

    readonly parentCategorySlug?: string

    readonly currency?: string

    readonly onHomepage?: boolean

    readonly onNowLive?: boolean

    readonly inPlay?: boolean

    readonly endingSoon?: boolean

    readonly categoryIds?: Array<string>

    readonly eventId?: string

    readonly pageSize?: number

    readonly offset?: number

    readonly maxNumberOfProducts?: number
}

/**
 * EventsOverviewApi - object-oriented interface
 */
export class EventsOverviewApi extends BaseAPI {
    /**
     * 
     * @param {EventsOverviewApiV2EventsOverviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2EventsOverviewGet(requestParameters: EventsOverviewApiV2EventsOverviewGetRequest, options?: RawAxiosRequestConfig) {
        return EventsOverviewApiFp(this.configuration).v2EventsOverviewGet(requestParameters.xPlatformKey, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.liveStatus, requestParameters.parentCategoryId, requestParameters.parentCategorySlug, requestParameters.currency, requestParameters.onHomepage, requestParameters.onNowLive, requestParameters.inPlay, requestParameters.endingSoon, requestParameters.categoryIds, requestParameters.eventId, requestParameters.pageSize, requestParameters.offset, requestParameters.maxNumberOfProducts, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FilterApi - axios parameter creator
 */
export const FilterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the filters for events
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterEventsGet: async (xPlatformKey: string, searchTerm?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2FilterEventsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/filter/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterProductListingsFavouritesGet: async (xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2FilterProductListingsFavouritesGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/filter/product-listings/favourites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the filters for products
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId] 
         * @param {string} [searchTerm] 
         * @param {string} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterProductsGet: async (xPlatformKey: string, eventId?: string, searchTerm?: string, categoryId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2FilterProductsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/filter/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventId !== undefined) {
                localVarQueryParameter['event_id'] = eventId;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['category_id'] = categoryId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilterApi - functional programming interface
 */
export const FilterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the filters for events
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2FilterEventsGet(xPlatformKey: string, searchTerm?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventFilters>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2FilterEventsGet(xPlatformKey, searchTerm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterApi.v2FilterEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2FilterProductListingsFavouritesGet(xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavouriteProductListingFilters>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2FilterProductListingsFavouritesGet(xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterApi.v2FilterProductListingsFavouritesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the filters for products
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId] 
         * @param {string} [searchTerm] 
         * @param {string} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2FilterProductsGet(xPlatformKey: string, eventId?: string, searchTerm?: string, categoryId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductFilters>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2FilterProductsGet(xPlatformKey, eventId, searchTerm, categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterApi.v2FilterProductsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FilterApi - factory interface
 */
export const FilterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilterApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the filters for events
         * @param {FilterApiV2FilterEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterEventsGet(requestParameters: FilterApiV2FilterEventsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventFilters> {
            return localVarFp.v2FilterEventsGet(requestParameters.xPlatformKey, requestParameters.searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilterApiV2FilterProductListingsFavouritesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterProductListingsFavouritesGet(requestParameters: FilterApiV2FilterProductListingsFavouritesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FavouriteProductListingFilters> {
            return localVarFp.v2FilterProductListingsFavouritesGet(requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the filters for products
         * @param {FilterApiV2FilterProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterProductsGet(requestParameters: FilterApiV2FilterProductsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductFilters> {
            return localVarFp.v2FilterProductsGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.searchTerm, requestParameters.categoryId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2FilterEventsGet operation in FilterApi.
 */
export interface FilterApiV2FilterEventsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly searchTerm?: string
}

/**
 * Request parameters for v2FilterProductListingsFavouritesGet operation in FilterApi.
 */
export interface FilterApiV2FilterProductListingsFavouritesGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for v2FilterProductsGet operation in FilterApi.
 */
export interface FilterApiV2FilterProductsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly eventId?: string

    readonly searchTerm?: string

    readonly categoryId?: string
}

/**
 * FilterApi - object-oriented interface
 */
export class FilterApi extends BaseAPI {
    /**
     * 
     * @summary Get the filters for events
     * @param {FilterApiV2FilterEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2FilterEventsGet(requestParameters: FilterApiV2FilterEventsGetRequest, options?: RawAxiosRequestConfig) {
        return FilterApiFp(this.configuration).v2FilterEventsGet(requestParameters.xPlatformKey, requestParameters.searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilterApiV2FilterProductListingsFavouritesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2FilterProductListingsFavouritesGet(requestParameters: FilterApiV2FilterProductListingsFavouritesGetRequest, options?: RawAxiosRequestConfig) {
        return FilterApiFp(this.configuration).v2FilterProductListingsFavouritesGet(requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the filters for products
     * @param {FilterApiV2FilterProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2FilterProductsGet(requestParameters: FilterApiV2FilterProductsGetRequest, options?: RawAxiosRequestConfig) {
        return FilterApiFp(this.configuration).v2FilterProductsGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.searchTerm, requestParameters.categoryId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GiveawayApi - axios parameter creator
 */
export const GiveawayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Registers the user to the giveaway if not registered
         * @param {string} slug 
         * @param {RegisterGiveawayRequest} registerGiveawayRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GiveawaysSlugPost: async (slug: string, registerGiveawayRequest: RegisterGiveawayRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('v2GiveawaysSlugPost', 'slug', slug)
            // verify required parameter 'registerGiveawayRequest' is not null or undefined
            assertParamExists('v2GiveawaysSlugPost', 'registerGiveawayRequest', registerGiveawayRequest)
            const localVarPath = `/v2/giveaways/{slug}`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = registerGiveawayRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GiveawayApi - functional programming interface
 */
export const GiveawayApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GiveawayApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Registers the user to the giveaway if not registered
         * @param {string} slug 
         * @param {RegisterGiveawayRequest} registerGiveawayRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2GiveawaysSlugPost(slug: string, registerGiveawayRequest: RegisterGiveawayRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2GiveawaysSlugPost(slug, registerGiveawayRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GiveawayApi.v2GiveawaysSlugPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GiveawayApi - factory interface
 */
export const GiveawayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GiveawayApiFp(configuration)
    return {
        /**
         * 
         * @summary Registers the user to the giveaway if not registered
         * @param {GiveawayApiV2GiveawaysSlugPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GiveawaysSlugPost(requestParameters: GiveawayApiV2GiveawaysSlugPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2GiveawaysSlugPost(requestParameters.slug, requestParameters.registerGiveawayRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2GiveawaysSlugPost operation in GiveawayApi.
 */
export interface GiveawayApiV2GiveawaysSlugPostRequest {
    readonly slug: string

    readonly registerGiveawayRequest: RegisterGiveawayRequest
}

/**
 * GiveawayApi - object-oriented interface
 */
export class GiveawayApi extends BaseAPI {
    /**
     * 
     * @summary Registers the user to the giveaway if not registered
     * @param {GiveawayApiV2GiveawaysSlugPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2GiveawaysSlugPost(requestParameters: GiveawayApiV2GiveawaysSlugPostRequest, options?: RawAxiosRequestConfig) {
        return GiveawayApiFp(this.configuration).v2GiveawaysSlugPost(requestParameters.slug, requestParameters.registerGiveawayRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeApi - axios parameter creator
 */
export const MeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [User] Get the bidder associated with the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidderGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/me/bidder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Bids for the currently authenticated user
         * @param {string} xPlatformKey Select the platform.
         * @param {BidsStatusFilters} [publicBidsStatusFilters] 
         * @param {boolean} [highestBid] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [createdAtEq] 
         * @param {Date} [createdAtNot] 
         * @param {Date} [createdAtGt] 
         * @param {Date} [createdAtLt] 
         * @param {Date} [createdAtGte] 
         * @param {Date} [createdAtLte] 
         * @param {boolean} [createdAtIsNull] 
         * @param {boolean} [createdAtIsNotNull] 
         * @param {CombineType} [createdAtCombineWith] 
         * @param {Date} [productEndDateMin] 
         * @param {Date} [productEndDateMax] 
         * @param {Date} [productEndDateEq] 
         * @param {Date} [productEndDateNot] 
         * @param {Date} [productEndDateGt] 
         * @param {Date} [productEndDateLt] 
         * @param {Date} [productEndDateGte] 
         * @param {Date} [productEndDateLte] 
         * @param {boolean} [productEndDateIsNull] 
         * @param {boolean} [productEndDateIsNotNull] 
         * @param {CombineType} [productEndDateCombineWith] 
         * @param {CombineType} [productCombineWith] 
         * @param {number} [perPage] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {Sorting} [sortBy] 
         * @param {string} [sort] 
         * @param {CombineType} [combineWith] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidsGet: async (xPlatformKey: string, publicBidsStatusFilters?: BidsStatusFilters, highestBid?: boolean, createdAtMin?: Date, createdAtMax?: Date, createdAtEq?: Date, createdAtNot?: Date, createdAtGt?: Date, createdAtLt?: Date, createdAtGte?: Date, createdAtLte?: Date, createdAtIsNull?: boolean, createdAtIsNotNull?: boolean, createdAtCombineWith?: CombineType, productEndDateMin?: Date, productEndDateMax?: Date, productEndDateEq?: Date, productEndDateNot?: Date, productEndDateGt?: Date, productEndDateLt?: Date, productEndDateGte?: Date, productEndDateLte?: Date, productEndDateIsNull?: boolean, productEndDateIsNotNull?: boolean, productEndDateCombineWith?: CombineType, productCombineWith?: CombineType, perPage?: number, page?: number, pageSize?: number, offset?: number, sortBy?: Sorting, sort?: string, combineWith?: CombineType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MeBidsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/me/bids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (publicBidsStatusFilters !== undefined) {
                localVarQueryParameter['public_bids_status_filters'] = publicBidsStatusFilters;
            }

            if (highestBid !== undefined) {
                localVarQueryParameter['highest_bid'] = highestBid;
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['created_at.min'] = (createdAtMin as any instanceof Date) ?
                    (createdAtMin as any).toISOString() :
                    createdAtMin;
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['created_at.max'] = (createdAtMax as any instanceof Date) ?
                    (createdAtMax as any).toISOString() :
                    createdAtMax;
            }

            if (createdAtEq !== undefined) {
                localVarQueryParameter['created_at.eq'] = (createdAtEq as any instanceof Date) ?
                    (createdAtEq as any).toISOString() :
                    createdAtEq;
            }

            if (createdAtNot !== undefined) {
                localVarQueryParameter['created_at.not'] = (createdAtNot as any instanceof Date) ?
                    (createdAtNot as any).toISOString() :
                    createdAtNot;
            }

            if (createdAtGt !== undefined) {
                localVarQueryParameter['created_at.gt'] = (createdAtGt as any instanceof Date) ?
                    (createdAtGt as any).toISOString() :
                    createdAtGt;
            }

            if (createdAtLt !== undefined) {
                localVarQueryParameter['created_at.lt'] = (createdAtLt as any instanceof Date) ?
                    (createdAtLt as any).toISOString() :
                    createdAtLt;
            }

            if (createdAtGte !== undefined) {
                localVarQueryParameter['created_at.gte'] = (createdAtGte as any instanceof Date) ?
                    (createdAtGte as any).toISOString() :
                    createdAtGte;
            }

            if (createdAtLte !== undefined) {
                localVarQueryParameter['created_at.lte'] = (createdAtLte as any instanceof Date) ?
                    (createdAtLte as any).toISOString() :
                    createdAtLte;
            }

            if (createdAtIsNull !== undefined) {
                localVarQueryParameter['created_at.is_null'] = createdAtIsNull;
            }

            if (createdAtIsNotNull !== undefined) {
                localVarQueryParameter['created_at.is_not_null'] = createdAtIsNotNull;
            }

            if (createdAtCombineWith !== undefined) {
                localVarQueryParameter['created_at.combine_with'] = createdAtCombineWith;
            }

            if (productEndDateMin !== undefined) {
                localVarQueryParameter['product.end_date.min'] = (productEndDateMin as any instanceof Date) ?
                    (productEndDateMin as any).toISOString() :
                    productEndDateMin;
            }

            if (productEndDateMax !== undefined) {
                localVarQueryParameter['product.end_date.max'] = (productEndDateMax as any instanceof Date) ?
                    (productEndDateMax as any).toISOString() :
                    productEndDateMax;
            }

            if (productEndDateEq !== undefined) {
                localVarQueryParameter['product.end_date.eq'] = (productEndDateEq as any instanceof Date) ?
                    (productEndDateEq as any).toISOString() :
                    productEndDateEq;
            }

            if (productEndDateNot !== undefined) {
                localVarQueryParameter['product.end_date.not'] = (productEndDateNot as any instanceof Date) ?
                    (productEndDateNot as any).toISOString() :
                    productEndDateNot;
            }

            if (productEndDateGt !== undefined) {
                localVarQueryParameter['product.end_date.gt'] = (productEndDateGt as any instanceof Date) ?
                    (productEndDateGt as any).toISOString() :
                    productEndDateGt;
            }

            if (productEndDateLt !== undefined) {
                localVarQueryParameter['product.end_date.lt'] = (productEndDateLt as any instanceof Date) ?
                    (productEndDateLt as any).toISOString() :
                    productEndDateLt;
            }

            if (productEndDateGte !== undefined) {
                localVarQueryParameter['product.end_date.gte'] = (productEndDateGte as any instanceof Date) ?
                    (productEndDateGte as any).toISOString() :
                    productEndDateGte;
            }

            if (productEndDateLte !== undefined) {
                localVarQueryParameter['product.end_date.lte'] = (productEndDateLte as any instanceof Date) ?
                    (productEndDateLte as any).toISOString() :
                    productEndDateLte;
            }

            if (productEndDateIsNull !== undefined) {
                localVarQueryParameter['product.end_date.is_null'] = productEndDateIsNull;
            }

            if (productEndDateIsNotNull !== undefined) {
                localVarQueryParameter['product.end_date.is_not_null'] = productEndDateIsNotNull;
            }

            if (productEndDateCombineWith !== undefined) {
                localVarQueryParameter['product.end_date.combine_with'] = productEndDateCombineWith;
            }

            if (productCombineWith !== undefined) {
                localVarQueryParameter['product.combine_with'] = productCombineWith;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (combineWith !== undefined) {
                localVarQueryParameter['combine_with'] = combineWith;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateQuickBidTermsRequest} updateQuickBidTermsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeQuickBidderPatch: async (updateQuickBidTermsRequest: UpdateQuickBidTermsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateQuickBidTermsRequest' is not null or undefined
            assertParamExists('v2MeQuickBidderPatch', 'updateQuickBidTermsRequest', updateQuickBidTermsRequest)
            const localVarPath = `/v2/me/quick-bidder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = updateQuickBidTermsRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeApi - functional programming interface
 */
export const MeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [User] Get the bidder associated with the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MeBidderGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BidderV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MeBidderGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeApi.v2MeBidderGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Bids for the currently authenticated user
         * @param {string} xPlatformKey Select the platform.
         * @param {BidsStatusFilters} [publicBidsStatusFilters] 
         * @param {boolean} [highestBid] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [createdAtEq] 
         * @param {Date} [createdAtNot] 
         * @param {Date} [createdAtGt] 
         * @param {Date} [createdAtLt] 
         * @param {Date} [createdAtGte] 
         * @param {Date} [createdAtLte] 
         * @param {boolean} [createdAtIsNull] 
         * @param {boolean} [createdAtIsNotNull] 
         * @param {CombineType} [createdAtCombineWith] 
         * @param {Date} [productEndDateMin] 
         * @param {Date} [productEndDateMax] 
         * @param {Date} [productEndDateEq] 
         * @param {Date} [productEndDateNot] 
         * @param {Date} [productEndDateGt] 
         * @param {Date} [productEndDateLt] 
         * @param {Date} [productEndDateGte] 
         * @param {Date} [productEndDateLte] 
         * @param {boolean} [productEndDateIsNull] 
         * @param {boolean} [productEndDateIsNotNull] 
         * @param {CombineType} [productEndDateCombineWith] 
         * @param {CombineType} [productCombineWith] 
         * @param {number} [perPage] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {Sorting} [sortBy] 
         * @param {string} [sort] 
         * @param {CombineType} [combineWith] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MeBidsGet(xPlatformKey: string, publicBidsStatusFilters?: BidsStatusFilters, highestBid?: boolean, createdAtMin?: Date, createdAtMax?: Date, createdAtEq?: Date, createdAtNot?: Date, createdAtGt?: Date, createdAtLt?: Date, createdAtGte?: Date, createdAtLte?: Date, createdAtIsNull?: boolean, createdAtIsNotNull?: boolean, createdAtCombineWith?: CombineType, productEndDateMin?: Date, productEndDateMax?: Date, productEndDateEq?: Date, productEndDateNot?: Date, productEndDateGt?: Date, productEndDateLt?: Date, productEndDateGte?: Date, productEndDateLte?: Date, productEndDateIsNull?: boolean, productEndDateIsNotNull?: boolean, productEndDateCombineWith?: CombineType, productCombineWith?: CombineType, perPage?: number, page?: number, pageSize?: number, offset?: number, sortBy?: Sorting, sort?: string, combineWith?: CombineType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BidDetailsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MeBidsGet(xPlatformKey, publicBidsStatusFilters, highestBid, createdAtMin, createdAtMax, createdAtEq, createdAtNot, createdAtGt, createdAtLt, createdAtGte, createdAtLte, createdAtIsNull, createdAtIsNotNull, createdAtCombineWith, productEndDateMin, productEndDateMax, productEndDateEq, productEndDateNot, productEndDateGt, productEndDateLt, productEndDateGte, productEndDateLte, productEndDateIsNull, productEndDateIsNotNull, productEndDateCombineWith, productCombineWith, perPage, page, pageSize, offset, sortBy, sort, combineWith, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeApi.v2MeBidsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateQuickBidTermsRequest} updateQuickBidTermsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MeQuickBidderPatch(updateQuickBidTermsRequest: UpdateQuickBidTermsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MeQuickBidderPatch(updateQuickBidTermsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeApi.v2MeQuickBidderPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeApi - factory interface
 */
export const MeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeApiFp(configuration)
    return {
        /**
         * 
         * @summary [User] Get the bidder associated with the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidderGet(options?: RawAxiosRequestConfig): AxiosPromise<BidderV2> {
            return localVarFp.v2MeBidderGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Bids for the currently authenticated user
         * @param {MeApiV2MeBidsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidsGet(requestParameters: MeApiV2MeBidsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BidDetailsList> {
            return localVarFp.v2MeBidsGet(requestParameters.xPlatformKey, requestParameters.publicBidsStatusFilters, requestParameters.highestBid, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdAtEq, requestParameters.createdAtNot, requestParameters.createdAtGt, requestParameters.createdAtLt, requestParameters.createdAtGte, requestParameters.createdAtLte, requestParameters.createdAtIsNull, requestParameters.createdAtIsNotNull, requestParameters.createdAtCombineWith, requestParameters.productEndDateMin, requestParameters.productEndDateMax, requestParameters.productEndDateEq, requestParameters.productEndDateNot, requestParameters.productEndDateGt, requestParameters.productEndDateLt, requestParameters.productEndDateGte, requestParameters.productEndDateLte, requestParameters.productEndDateIsNull, requestParameters.productEndDateIsNotNull, requestParameters.productEndDateCombineWith, requestParameters.productCombineWith, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MeApiV2MeQuickBidderPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeQuickBidderPatch(requestParameters: MeApiV2MeQuickBidderPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2MeQuickBidderPatch(requestParameters.updateQuickBidTermsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2MeBidsGet operation in MeApi.
 */
export interface MeApiV2MeBidsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly publicBidsStatusFilters?: BidsStatusFilters

    readonly highestBid?: boolean

    readonly createdAtMin?: Date

    readonly createdAtMax?: Date

    readonly createdAtEq?: Date

    readonly createdAtNot?: Date

    readonly createdAtGt?: Date

    readonly createdAtLt?: Date

    readonly createdAtGte?: Date

    readonly createdAtLte?: Date

    readonly createdAtIsNull?: boolean

    readonly createdAtIsNotNull?: boolean

    readonly createdAtCombineWith?: CombineType

    readonly productEndDateMin?: Date

    readonly productEndDateMax?: Date

    readonly productEndDateEq?: Date

    readonly productEndDateNot?: Date

    readonly productEndDateGt?: Date

    readonly productEndDateLt?: Date

    readonly productEndDateGte?: Date

    readonly productEndDateLte?: Date

    readonly productEndDateIsNull?: boolean

    readonly productEndDateIsNotNull?: boolean

    readonly productEndDateCombineWith?: CombineType

    readonly productCombineWith?: CombineType

    readonly perPage?: number

    readonly page?: number

    readonly pageSize?: number

    readonly offset?: number

    readonly sortBy?: Sorting

    readonly sort?: string

    readonly combineWith?: CombineType
}

/**
 * Request parameters for v2MeQuickBidderPatch operation in MeApi.
 */
export interface MeApiV2MeQuickBidderPatchRequest {
    readonly updateQuickBidTermsRequest: UpdateQuickBidTermsRequest
}

/**
 * MeApi - object-oriented interface
 */
export class MeApi extends BaseAPI {
    /**
     * 
     * @summary [User] Get the bidder associated with the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MeBidderGet(options?: RawAxiosRequestConfig) {
        return MeApiFp(this.configuration).v2MeBidderGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Bids for the currently authenticated user
     * @param {MeApiV2MeBidsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MeBidsGet(requestParameters: MeApiV2MeBidsGetRequest, options?: RawAxiosRequestConfig) {
        return MeApiFp(this.configuration).v2MeBidsGet(requestParameters.xPlatformKey, requestParameters.publicBidsStatusFilters, requestParameters.highestBid, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdAtEq, requestParameters.createdAtNot, requestParameters.createdAtGt, requestParameters.createdAtLt, requestParameters.createdAtGte, requestParameters.createdAtLte, requestParameters.createdAtIsNull, requestParameters.createdAtIsNotNull, requestParameters.createdAtCombineWith, requestParameters.productEndDateMin, requestParameters.productEndDateMax, requestParameters.productEndDateEq, requestParameters.productEndDateNot, requestParameters.productEndDateGt, requestParameters.productEndDateLt, requestParameters.productEndDateGte, requestParameters.productEndDateLte, requestParameters.productEndDateIsNull, requestParameters.productEndDateIsNotNull, requestParameters.productEndDateCombineWith, requestParameters.productCombineWith, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MeApiV2MeQuickBidderPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MeQuickBidderPatch(requestParameters: MeApiV2MeQuickBidderPatchRequest, options?: RawAxiosRequestConfig) {
        return MeApiFp(this.configuration).v2MeQuickBidderPatch(requestParameters.updateQuickBidTermsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeBidsApi - axios parameter creator
 */
export const MeBidsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return the user\'s bid status (winning + max-bid amounts) for product listings.  Two modes:   - Per-page stitch: pass `product_ids` (max 100) → returns an entry per supplied listing     the user has bid on.   - Session bootstrap: omit `product_ids` → returns every active max-bid the user has on     currently-running listings. Response is capped at 500 entries (no observed user comes     close per DEV-1440).  In both modes, listings on a different platform or that have ended are omitted.
         * @param {Array<string>} [productIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidsStatusGet: async (productIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/me/bids/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productIds) {
                localVarQueryParameter['product_ids'] = productIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeBidsApi - functional programming interface
 */
export const MeBidsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeBidsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return the user\'s bid status (winning + max-bid amounts) for product listings.  Two modes:   - Per-page stitch: pass `product_ids` (max 100) → returns an entry per supplied listing     the user has bid on.   - Session bootstrap: omit `product_ids` → returns every active max-bid the user has on     currently-running listings. Response is capped at 500 entries (no observed user comes     close per DEV-1440).  In both modes, listings on a different platform or that have ended are omitted.
         * @param {Array<string>} [productIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MeBidsStatusGet(productIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: BidStatus; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MeBidsStatusGet(productIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeBidsApi.v2MeBidsStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeBidsApi - factory interface
 */
export const MeBidsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeBidsApiFp(configuration)
    return {
        /**
         * 
         * @summary Return the user\'s bid status (winning + max-bid amounts) for product listings.  Two modes:   - Per-page stitch: pass `product_ids` (max 100) → returns an entry per supplied listing     the user has bid on.   - Session bootstrap: omit `product_ids` → returns every active max-bid the user has on     currently-running listings. Response is capped at 500 entries (no observed user comes     close per DEV-1440).  In both modes, listings on a different platform or that have ended are omitted.
         * @param {MeBidsApiV2MeBidsStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidsStatusGet(requestParameters: MeBidsApiV2MeBidsStatusGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: BidStatus; }> {
            return localVarFp.v2MeBidsStatusGet(requestParameters.productIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2MeBidsStatusGet operation in MeBidsApi.
 */
export interface MeBidsApiV2MeBidsStatusGetRequest {
    readonly productIds?: Array<string>
}

/**
 * MeBidsApi - object-oriented interface
 */
export class MeBidsApi extends BaseAPI {
    /**
     * 
     * @summary Return the user\'s bid status (winning + max-bid amounts) for product listings.  Two modes:   - Per-page stitch: pass `product_ids` (max 100) → returns an entry per supplied listing     the user has bid on.   - Session bootstrap: omit `product_ids` → returns every active max-bid the user has on     currently-running listings. Response is capped at 500 entries (no observed user comes     close per DEV-1440).  In both modes, listings on a different platform or that have ended are omitted.
     * @param {MeBidsApiV2MeBidsStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MeBidsStatusGet(requestParameters: MeBidsApiV2MeBidsStatusGetRequest = {}, options?: RawAxiosRequestConfig) {
        return MeBidsApiFp(this.configuration).v2MeBidsStatusGet(requestParameters.productIds, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MePreferenceCategoriesApi - axios parameter creator
 */
export const MePreferenceCategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change the follow setting for an individual category
         * @param {string} categoryId 
         * @param {ChangeIndividualPreferenceRequest} changeIndividualPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesCategoryIdPut: async (categoryId: string, changeIndividualPreferenceRequest: ChangeIndividualPreferenceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('v2MePreferencesCategoriesCategoryIdPut', 'categoryId', categoryId)
            // verify required parameter 'changeIndividualPreferenceRequest' is not null or undefined
            assertParamExists('v2MePreferencesCategoriesCategoryIdPut', 'changeIndividualPreferenceRequest', changeIndividualPreferenceRequest)
            const localVarPath = `/v2/me/preferences/categories/{categoryId}`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = changeIndividualPreferenceRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the followed categories of a user
         * @param {string} xPlatformKey Select the platform.
         * @param {CategoryType} [type] 
         * @param {string} [search] 
         * @param {boolean} [followed] 
         * @param {number} [perPage] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {Sorting} [sortBy] 
         * @param {string} [sort] 
         * @param {CombineType} [combineWith] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesGet: async (xPlatformKey: string, type?: CategoryType, search?: string, followed?: boolean, perPage?: number, page?: number, pageSize?: number, offset?: number, sortBy?: Sorting, sort?: string, combineWith?: CombineType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MePreferencesCategoriesGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/me/preferences/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (followed !== undefined) {
                localVarQueryParameter['followed'] = followed;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (combineWith !== undefined) {
                localVarQueryParameter['combine_with'] = combineWith;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Follow or unfollow multiple categories
         * @param {ChangeCategoryPreferencesRequest} changeCategoryPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesPatch: async (changeCategoryPreferencesRequest: ChangeCategoryPreferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeCategoryPreferencesRequest' is not null or undefined
            assertParamExists('v2MePreferencesCategoriesPatch', 'changeCategoryPreferencesRequest', changeCategoryPreferencesRequest)
            const localVarPath = `/v2/me/preferences/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = changeCategoryPreferencesRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MePreferenceCategoriesApi - functional programming interface
 */
export const MePreferenceCategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MePreferenceCategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change the follow setting for an individual category
         * @param {string} categoryId 
         * @param {ChangeIndividualPreferenceRequest} changeIndividualPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MePreferencesCategoriesCategoryIdPut(categoryId: string, changeIndividualPreferenceRequest: ChangeIndividualPreferenceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MePreferencesCategoriesCategoryIdPut(categoryId, changeIndividualPreferenceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MePreferenceCategoriesApi.v2MePreferencesCategoriesCategoryIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the followed categories of a user
         * @param {string} xPlatformKey Select the platform.
         * @param {CategoryType} [type] 
         * @param {string} [search] 
         * @param {boolean} [followed] 
         * @param {number} [perPage] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {Sorting} [sortBy] 
         * @param {string} [sort] 
         * @param {CombineType} [combineWith] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MePreferencesCategoriesGet(xPlatformKey: string, type?: CategoryType, search?: string, followed?: boolean, perPage?: number, page?: number, pageSize?: number, offset?: number, sortBy?: Sorting, sort?: string, combineWith?: CombineType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryPreferences>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MePreferencesCategoriesGet(xPlatformKey, type, search, followed, perPage, page, pageSize, offset, sortBy, sort, combineWith, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MePreferenceCategoriesApi.v2MePreferencesCategoriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Follow or unfollow multiple categories
         * @param {ChangeCategoryPreferencesRequest} changeCategoryPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MePreferencesCategoriesPatch(changeCategoryPreferencesRequest: ChangeCategoryPreferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MePreferencesCategoriesPatch(changeCategoryPreferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MePreferenceCategoriesApi.v2MePreferencesCategoriesPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MePreferenceCategoriesApi - factory interface
 */
export const MePreferenceCategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MePreferenceCategoriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Change the follow setting for an individual category
         * @param {MePreferenceCategoriesApiV2MePreferencesCategoriesCategoryIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesCategoryIdPut(requestParameters: MePreferenceCategoriesApiV2MePreferencesCategoriesCategoryIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2MePreferencesCategoriesCategoryIdPut(requestParameters.categoryId, requestParameters.changeIndividualPreferenceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the followed categories of a user
         * @param {MePreferenceCategoriesApiV2MePreferencesCategoriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesGet(requestParameters: MePreferenceCategoriesApiV2MePreferencesCategoriesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryPreferences> {
            return localVarFp.v2MePreferencesCategoriesGet(requestParameters.xPlatformKey, requestParameters.type, requestParameters.search, requestParameters.followed, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Follow or unfollow multiple categories
         * @param {MePreferenceCategoriesApiV2MePreferencesCategoriesPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesPatch(requestParameters: MePreferenceCategoriesApiV2MePreferencesCategoriesPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2MePreferencesCategoriesPatch(requestParameters.changeCategoryPreferencesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2MePreferencesCategoriesCategoryIdPut operation in MePreferenceCategoriesApi.
 */
export interface MePreferenceCategoriesApiV2MePreferencesCategoriesCategoryIdPutRequest {
    readonly categoryId: string

    readonly changeIndividualPreferenceRequest: ChangeIndividualPreferenceRequest
}

/**
 * Request parameters for v2MePreferencesCategoriesGet operation in MePreferenceCategoriesApi.
 */
export interface MePreferenceCategoriesApiV2MePreferencesCategoriesGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly type?: CategoryType

    readonly search?: string

    readonly followed?: boolean

    readonly perPage?: number

    readonly page?: number

    readonly pageSize?: number

    readonly offset?: number

    readonly sortBy?: Sorting

    readonly sort?: string

    readonly combineWith?: CombineType
}

/**
 * Request parameters for v2MePreferencesCategoriesPatch operation in MePreferenceCategoriesApi.
 */
export interface MePreferenceCategoriesApiV2MePreferencesCategoriesPatchRequest {
    readonly changeCategoryPreferencesRequest: ChangeCategoryPreferencesRequest
}

/**
 * MePreferenceCategoriesApi - object-oriented interface
 */
export class MePreferenceCategoriesApi extends BaseAPI {
    /**
     * 
     * @summary Change the follow setting for an individual category
     * @param {MePreferenceCategoriesApiV2MePreferencesCategoriesCategoryIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MePreferencesCategoriesCategoryIdPut(requestParameters: MePreferenceCategoriesApiV2MePreferencesCategoriesCategoryIdPutRequest, options?: RawAxiosRequestConfig) {
        return MePreferenceCategoriesApiFp(this.configuration).v2MePreferencesCategoriesCategoryIdPut(requestParameters.categoryId, requestParameters.changeIndividualPreferenceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the followed categories of a user
     * @param {MePreferenceCategoriesApiV2MePreferencesCategoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MePreferencesCategoriesGet(requestParameters: MePreferenceCategoriesApiV2MePreferencesCategoriesGetRequest, options?: RawAxiosRequestConfig) {
        return MePreferenceCategoriesApiFp(this.configuration).v2MePreferencesCategoriesGet(requestParameters.xPlatformKey, requestParameters.type, requestParameters.search, requestParameters.followed, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Follow or unfollow multiple categories
     * @param {MePreferenceCategoriesApiV2MePreferencesCategoriesPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MePreferencesCategoriesPatch(requestParameters: MePreferenceCategoriesApiV2MePreferencesCategoriesPatchRequest, options?: RawAxiosRequestConfig) {
        return MePreferenceCategoriesApiFp(this.configuration).v2MePreferencesCategoriesPatch(requestParameters.changeCategoryPreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MePreferenceEventsApi - axios parameter creator
 */
export const MePreferenceEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change the follow setting for an individual event
         * @param {string} eventId 
         * @param {ChangeIndividualPreferenceRequest} changeIndividualPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesEventsEventIdPut: async (eventId: string, changeIndividualPreferenceRequest: ChangeIndividualPreferenceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('v2MePreferencesEventsEventIdPut', 'eventId', eventId)
            // verify required parameter 'changeIndividualPreferenceRequest' is not null or undefined
            assertParamExists('v2MePreferencesEventsEventIdPut', 'changeIndividualPreferenceRequest', changeIndividualPreferenceRequest)
            const localVarPath = `/v2/me/preferences/events/{eventId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = changeIndividualPreferenceRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the followed events of a user
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [search] 
         * @param {boolean} [followed] 
         * @param {number} [perPage] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {Sorting} [sortBy] 
         * @param {string} [sort] 
         * @param {CombineType} [combineWith] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesEventsGet: async (xPlatformKey: string, search?: string, followed?: boolean, perPage?: number, page?: number, pageSize?: number, offset?: number, sortBy?: Sorting, sort?: string, combineWith?: CombineType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MePreferencesEventsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/me/preferences/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (followed !== undefined) {
                localVarQueryParameter['followed'] = followed;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (combineWith !== undefined) {
                localVarQueryParameter['combine_with'] = combineWith;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Follow or unfollow multiple events
         * @param {ChangeEventPreferencesRequest} changeEventPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesEventsPatch: async (changeEventPreferencesRequest: ChangeEventPreferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeEventPreferencesRequest' is not null or undefined
            assertParamExists('v2MePreferencesEventsPatch', 'changeEventPreferencesRequest', changeEventPreferencesRequest)
            const localVarPath = `/v2/me/preferences/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = changeEventPreferencesRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MePreferenceEventsApi - functional programming interface
 */
export const MePreferenceEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MePreferenceEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change the follow setting for an individual event
         * @param {string} eventId 
         * @param {ChangeIndividualPreferenceRequest} changeIndividualPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MePreferencesEventsEventIdPut(eventId: string, changeIndividualPreferenceRequest: ChangeIndividualPreferenceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MePreferencesEventsEventIdPut(eventId, changeIndividualPreferenceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MePreferenceEventsApi.v2MePreferencesEventsEventIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the followed events of a user
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [search] 
         * @param {boolean} [followed] 
         * @param {number} [perPage] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {Sorting} [sortBy] 
         * @param {string} [sort] 
         * @param {CombineType} [combineWith] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MePreferencesEventsGet(xPlatformKey: string, search?: string, followed?: boolean, perPage?: number, page?: number, pageSize?: number, offset?: number, sortBy?: Sorting, sort?: string, combineWith?: CombineType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventPreferences>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MePreferencesEventsGet(xPlatformKey, search, followed, perPage, page, pageSize, offset, sortBy, sort, combineWith, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MePreferenceEventsApi.v2MePreferencesEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Follow or unfollow multiple events
         * @param {ChangeEventPreferencesRequest} changeEventPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MePreferencesEventsPatch(changeEventPreferencesRequest: ChangeEventPreferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MePreferencesEventsPatch(changeEventPreferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MePreferenceEventsApi.v2MePreferencesEventsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MePreferenceEventsApi - factory interface
 */
export const MePreferenceEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MePreferenceEventsApiFp(configuration)
    return {
        /**
         * 
         * @summary Change the follow setting for an individual event
         * @param {MePreferenceEventsApiV2MePreferencesEventsEventIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesEventsEventIdPut(requestParameters: MePreferenceEventsApiV2MePreferencesEventsEventIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2MePreferencesEventsEventIdPut(requestParameters.eventId, requestParameters.changeIndividualPreferenceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the followed events of a user
         * @param {MePreferenceEventsApiV2MePreferencesEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesEventsGet(requestParameters: MePreferenceEventsApiV2MePreferencesEventsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventPreferences> {
            return localVarFp.v2MePreferencesEventsGet(requestParameters.xPlatformKey, requestParameters.search, requestParameters.followed, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Follow or unfollow multiple events
         * @param {MePreferenceEventsApiV2MePreferencesEventsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesEventsPatch(requestParameters: MePreferenceEventsApiV2MePreferencesEventsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2MePreferencesEventsPatch(requestParameters.changeEventPreferencesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2MePreferencesEventsEventIdPut operation in MePreferenceEventsApi.
 */
export interface MePreferenceEventsApiV2MePreferencesEventsEventIdPutRequest {
    readonly eventId: string

    readonly changeIndividualPreferenceRequest: ChangeIndividualPreferenceRequest
}

/**
 * Request parameters for v2MePreferencesEventsGet operation in MePreferenceEventsApi.
 */
export interface MePreferenceEventsApiV2MePreferencesEventsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly search?: string

    readonly followed?: boolean

    readonly perPage?: number

    readonly page?: number

    readonly pageSize?: number

    readonly offset?: number

    readonly sortBy?: Sorting

    readonly sort?: string

    readonly combineWith?: CombineType
}

/**
 * Request parameters for v2MePreferencesEventsPatch operation in MePreferenceEventsApi.
 */
export interface MePreferenceEventsApiV2MePreferencesEventsPatchRequest {
    readonly changeEventPreferencesRequest: ChangeEventPreferencesRequest
}

/**
 * MePreferenceEventsApi - object-oriented interface
 */
export class MePreferenceEventsApi extends BaseAPI {
    /**
     * 
     * @summary Change the follow setting for an individual event
     * @param {MePreferenceEventsApiV2MePreferencesEventsEventIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MePreferencesEventsEventIdPut(requestParameters: MePreferenceEventsApiV2MePreferencesEventsEventIdPutRequest, options?: RawAxiosRequestConfig) {
        return MePreferenceEventsApiFp(this.configuration).v2MePreferencesEventsEventIdPut(requestParameters.eventId, requestParameters.changeIndividualPreferenceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the followed events of a user
     * @param {MePreferenceEventsApiV2MePreferencesEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MePreferencesEventsGet(requestParameters: MePreferenceEventsApiV2MePreferencesEventsGetRequest, options?: RawAxiosRequestConfig) {
        return MePreferenceEventsApiFp(this.configuration).v2MePreferencesEventsGet(requestParameters.xPlatformKey, requestParameters.search, requestParameters.followed, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Follow or unfollow multiple events
     * @param {MePreferenceEventsApiV2MePreferencesEventsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MePreferencesEventsPatch(requestParameters: MePreferenceEventsApiV2MePreferencesEventsPatchRequest, options?: RawAxiosRequestConfig) {
        return MePreferenceEventsApiFp(this.configuration).v2MePreferencesEventsPatch(requestParameters.changeEventPreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MePreferenceProductsApi - axios parameter creator
 */
export const MePreferenceProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the followed products of a user
         * @param {string} [search] 
         * @param {boolean} [followed] 
         * @param {number} [perPage] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {Sorting} [sortBy] 
         * @param {string} [sort] 
         * @param {CombineType} [combineWith] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesProductsGet: async (search?: string, followed?: boolean, perPage?: number, page?: number, pageSize?: number, offset?: number, sortBy?: Sorting, sort?: string, combineWith?: CombineType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/me/preferences/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (followed !== undefined) {
                localVarQueryParameter['followed'] = followed;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (combineWith !== undefined) {
                localVarQueryParameter['combine_with'] = combineWith;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Follow or unfollow multiple products
         * @param {ChangeProductPreferencesRequest} changeProductPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesProductsPatch: async (changeProductPreferencesRequest: ChangeProductPreferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeProductPreferencesRequest' is not null or undefined
            assertParamExists('v2MePreferencesProductsPatch', 'changeProductPreferencesRequest', changeProductPreferencesRequest)
            const localVarPath = `/v2/me/preferences/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = changeProductPreferencesRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change the follow setting for an individual product
         * @param {string} productId 
         * @param {ChangeIndividualPreferenceRequest} changeIndividualPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesProductsProductIdPut: async (productId: string, changeIndividualPreferenceRequest: ChangeIndividualPreferenceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2MePreferencesProductsProductIdPut', 'productId', productId)
            // verify required parameter 'changeIndividualPreferenceRequest' is not null or undefined
            assertParamExists('v2MePreferencesProductsProductIdPut', 'changeIndividualPreferenceRequest', changeIndividualPreferenceRequest)
            const localVarPath = `/v2/me/preferences/products/{productId}`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = changeIndividualPreferenceRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Given a list of product listing IDs, return whether the user has followed each product listing
         * @param {Array<string>} [productListingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesProductsStatusGet: async (productListingIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/me/preferences/products/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productListingIds) {
                localVarQueryParameter['product_listing_ids'] = productListingIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MePreferenceProductsApi - functional programming interface
 */
export const MePreferenceProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MePreferenceProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the followed products of a user
         * @param {string} [search] 
         * @param {boolean} [followed] 
         * @param {number} [perPage] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {Sorting} [sortBy] 
         * @param {string} [sort] 
         * @param {CombineType} [combineWith] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MePreferencesProductsGet(search?: string, followed?: boolean, perPage?: number, page?: number, pageSize?: number, offset?: number, sortBy?: Sorting, sort?: string, combineWith?: CombineType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPreferences>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MePreferencesProductsGet(search, followed, perPage, page, pageSize, offset, sortBy, sort, combineWith, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MePreferenceProductsApi.v2MePreferencesProductsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Follow or unfollow multiple products
         * @param {ChangeProductPreferencesRequest} changeProductPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MePreferencesProductsPatch(changeProductPreferencesRequest: ChangeProductPreferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MePreferencesProductsPatch(changeProductPreferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MePreferenceProductsApi.v2MePreferencesProductsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change the follow setting for an individual product
         * @param {string} productId 
         * @param {ChangeIndividualPreferenceRequest} changeIndividualPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MePreferencesProductsProductIdPut(productId: string, changeIndividualPreferenceRequest: ChangeIndividualPreferenceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MePreferencesProductsProductIdPut(productId, changeIndividualPreferenceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MePreferenceProductsApi.v2MePreferencesProductsProductIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Given a list of product listing IDs, return whether the user has followed each product listing
         * @param {Array<string>} [productListingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MePreferencesProductsStatusGet(productListingIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MePreferencesProductsStatusGet(productListingIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MePreferenceProductsApi.v2MePreferencesProductsStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MePreferenceProductsApi - factory interface
 */
export const MePreferenceProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MePreferenceProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the followed products of a user
         * @param {MePreferenceProductsApiV2MePreferencesProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesProductsGet(requestParameters: MePreferenceProductsApiV2MePreferencesProductsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ProductPreferences> {
            return localVarFp.v2MePreferencesProductsGet(requestParameters.search, requestParameters.followed, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Follow or unfollow multiple products
         * @param {MePreferenceProductsApiV2MePreferencesProductsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesProductsPatch(requestParameters: MePreferenceProductsApiV2MePreferencesProductsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2MePreferencesProductsPatch(requestParameters.changeProductPreferencesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change the follow setting for an individual product
         * @param {MePreferenceProductsApiV2MePreferencesProductsProductIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesProductsProductIdPut(requestParameters: MePreferenceProductsApiV2MePreferencesProductsProductIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2MePreferencesProductsProductIdPut(requestParameters.productId, requestParameters.changeIndividualPreferenceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Given a list of product listing IDs, return whether the user has followed each product listing
         * @param {MePreferenceProductsApiV2MePreferencesProductsStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesProductsStatusGet(requestParameters: MePreferenceProductsApiV2MePreferencesProductsStatusGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.v2MePreferencesProductsStatusGet(requestParameters.productListingIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2MePreferencesProductsGet operation in MePreferenceProductsApi.
 */
export interface MePreferenceProductsApiV2MePreferencesProductsGetRequest {
    readonly search?: string

    readonly followed?: boolean

    readonly perPage?: number

    readonly page?: number

    readonly pageSize?: number

    readonly offset?: number

    readonly sortBy?: Sorting

    readonly sort?: string

    readonly combineWith?: CombineType
}

/**
 * Request parameters for v2MePreferencesProductsPatch operation in MePreferenceProductsApi.
 */
export interface MePreferenceProductsApiV2MePreferencesProductsPatchRequest {
    readonly changeProductPreferencesRequest: ChangeProductPreferencesRequest
}

/**
 * Request parameters for v2MePreferencesProductsProductIdPut operation in MePreferenceProductsApi.
 */
export interface MePreferenceProductsApiV2MePreferencesProductsProductIdPutRequest {
    readonly productId: string

    readonly changeIndividualPreferenceRequest: ChangeIndividualPreferenceRequest
}

/**
 * Request parameters for v2MePreferencesProductsStatusGet operation in MePreferenceProductsApi.
 */
export interface MePreferenceProductsApiV2MePreferencesProductsStatusGetRequest {
    readonly productListingIds?: Array<string>
}

/**
 * MePreferenceProductsApi - object-oriented interface
 */
export class MePreferenceProductsApi extends BaseAPI {
    /**
     * 
     * @summary Get the followed products of a user
     * @param {MePreferenceProductsApiV2MePreferencesProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MePreferencesProductsGet(requestParameters: MePreferenceProductsApiV2MePreferencesProductsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return MePreferenceProductsApiFp(this.configuration).v2MePreferencesProductsGet(requestParameters.search, requestParameters.followed, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Follow or unfollow multiple products
     * @param {MePreferenceProductsApiV2MePreferencesProductsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MePreferencesProductsPatch(requestParameters: MePreferenceProductsApiV2MePreferencesProductsPatchRequest, options?: RawAxiosRequestConfig) {
        return MePreferenceProductsApiFp(this.configuration).v2MePreferencesProductsPatch(requestParameters.changeProductPreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change the follow setting for an individual product
     * @param {MePreferenceProductsApiV2MePreferencesProductsProductIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MePreferencesProductsProductIdPut(requestParameters: MePreferenceProductsApiV2MePreferencesProductsProductIdPutRequest, options?: RawAxiosRequestConfig) {
        return MePreferenceProductsApiFp(this.configuration).v2MePreferencesProductsProductIdPut(requestParameters.productId, requestParameters.changeIndividualPreferenceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Given a list of product listing IDs, return whether the user has followed each product listing
     * @param {MePreferenceProductsApiV2MePreferencesProductsStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MePreferencesProductsStatusGet(requestParameters: MePreferenceProductsApiV2MePreferencesProductsStatusGetRequest = {}, options?: RawAxiosRequestConfig) {
        return MePreferenceProductsApiFp(this.configuration).v2MePreferencesProductsStatusGet(requestParameters.productListingIds, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeProductListingSuggestionsApi - axios parameter creator
 */
export const MeProductListingSuggestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventCategorySlug] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeProductListingsSuggestionsGet: async (xPlatformKey: string, eventCategorySlug?: string, pageSize?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MeProductListingsSuggestionsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/me/product-listings/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventCategorySlug !== undefined) {
                localVarQueryParameter['event_category_slug'] = eventCategorySlug;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeProductListingSuggestionsApi - functional programming interface
 */
export const MeProductListingSuggestionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeProductListingSuggestionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventCategorySlug] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MeProductListingsSuggestionsGet(xPlatformKey: string, eventCategorySlug?: string, pageSize?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductListItemList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MeProductListingsSuggestionsGet(xPlatformKey, eventCategorySlug, pageSize, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeProductListingSuggestionsApi.v2MeProductListingsSuggestionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeProductListingSuggestionsApi - factory interface
 */
export const MeProductListingSuggestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeProductListingSuggestionsApiFp(configuration)
    return {
        /**
         * 
         * @param {MeProductListingSuggestionsApiV2MeProductListingsSuggestionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeProductListingsSuggestionsGet(requestParameters: MeProductListingSuggestionsApiV2MeProductListingsSuggestionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductListItemList> {
            return localVarFp.v2MeProductListingsSuggestionsGet(requestParameters.xPlatformKey, requestParameters.eventCategorySlug, requestParameters.pageSize, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2MeProductListingsSuggestionsGet operation in MeProductListingSuggestionsApi.
 */
export interface MeProductListingSuggestionsApiV2MeProductListingsSuggestionsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly eventCategorySlug?: string

    readonly pageSize?: number

    readonly offset?: number
}

/**
 * MeProductListingSuggestionsApi - object-oriented interface
 */
export class MeProductListingSuggestionsApi extends BaseAPI {
    /**
     * 
     * @param {MeProductListingSuggestionsApiV2MeProductListingsSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MeProductListingsSuggestionsGet(requestParameters: MeProductListingSuggestionsApiV2MeProductListingsSuggestionsGetRequest, options?: RawAxiosRequestConfig) {
        return MeProductListingSuggestionsApiFp(this.configuration).v2MeProductListingsSuggestionsGet(requestParameters.xPlatformKey, requestParameters.eventCategorySlug, requestParameters.pageSize, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MenuHierarchiesApi - axios parameter creator
 */
export const MenuHierarchiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all menu hierarchy trees
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [menuHierarchyIds] 
         * @param {boolean} [includeLiveEvents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MenuHierarchiesGet: async (xPlatformKey: string, menuHierarchyIds?: string, includeLiveEvents?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MenuHierarchiesGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/menu-hierarchies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (menuHierarchyIds !== undefined) {
                localVarQueryParameter['menu_hierarchy_ids'] = menuHierarchyIds;
            }

            if (includeLiveEvents !== undefined) {
                localVarQueryParameter['include_live_events'] = includeLiveEvents;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MenuHierarchiesApi - functional programming interface
 */
export const MenuHierarchiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MenuHierarchiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all menu hierarchy trees
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [menuHierarchyIds] 
         * @param {boolean} [includeLiveEvents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2MenuHierarchiesGet(xPlatformKey: string, menuHierarchyIds?: string, includeLiveEvents?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MenuHierarchyTree>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2MenuHierarchiesGet(xPlatformKey, menuHierarchyIds, includeLiveEvents, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MenuHierarchiesApi.v2MenuHierarchiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MenuHierarchiesApi - factory interface
 */
export const MenuHierarchiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MenuHierarchiesApiFp(configuration)
    return {
        /**
         * 
         * @summary List all menu hierarchy trees
         * @param {MenuHierarchiesApiV2MenuHierarchiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MenuHierarchiesGet(requestParameters: MenuHierarchiesApiV2MenuHierarchiesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MenuHierarchyTree>> {
            return localVarFp.v2MenuHierarchiesGet(requestParameters.xPlatformKey, requestParameters.menuHierarchyIds, requestParameters.includeLiveEvents, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2MenuHierarchiesGet operation in MenuHierarchiesApi.
 */
export interface MenuHierarchiesApiV2MenuHierarchiesGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly menuHierarchyIds?: string

    readonly includeLiveEvents?: boolean
}

/**
 * MenuHierarchiesApi - object-oriented interface
 */
export class MenuHierarchiesApi extends BaseAPI {
    /**
     * 
     * @summary List all menu hierarchy trees
     * @param {MenuHierarchiesApiV2MenuHierarchiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2MenuHierarchiesGet(requestParameters: MenuHierarchiesApiV2MenuHierarchiesGetRequest, options?: RawAxiosRequestConfig) {
        return MenuHierarchiesApiFp(this.configuration).v2MenuHierarchiesGet(requestParameters.xPlatformKey, requestParameters.menuHierarchyIds, requestParameters.includeLiveEvents, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OfferThreadsApi - axios parameter creator
 */
export const OfferThreadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersThreadsGet: async (offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/offers/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} threadId 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersThreadsThreadIdGet: async (threadId: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('v2OffersThreadsThreadIdGet', 'threadId', threadId)
            const localVarPath = `/v2/offers/threads/{threadId}`
                .replace('{threadId}', encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} threadId 
         * @param {string} xPlatformKey Select the platform.
         * @param {SetMinimumResalePriceRequest} setMinimumResalePriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersThreadsThreadIdMinimumResalePricePatch: async (threadId: string, xPlatformKey: string, setMinimumResalePriceRequest: SetMinimumResalePriceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('v2OffersThreadsThreadIdMinimumResalePricePatch', 'threadId', threadId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OffersThreadsThreadIdMinimumResalePricePatch', 'xPlatformKey', xPlatformKey)
            // verify required parameter 'setMinimumResalePriceRequest' is not null or undefined
            assertParamExists('v2OffersThreadsThreadIdMinimumResalePricePatch', 'setMinimumResalePriceRequest', setMinimumResalePriceRequest)
            const localVarPath = `/v2/offers/threads/{threadId}/minimum-resale-price`
                .replace('{threadId}', encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = setMinimumResalePriceRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} threadId 
         * @param {string} xPlatformKey Select the platform.
         * @param {boolean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersThreadsThreadIdOptInPatch: async (threadId: string, xPlatformKey: string, body: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('v2OffersThreadsThreadIdOptInPatch', 'threadId', threadId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OffersThreadsThreadIdOptInPatch', 'xPlatformKey', xPlatformKey)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('v2OffersThreadsThreadIdOptInPatch', 'body', body)
            const localVarPath = `/v2/offers/threads/{threadId}/opt-in`
                .replace('{threadId}', encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = body

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OfferThreadsApi - functional programming interface
 */
export const OfferThreadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OfferThreadsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2OffersThreadsGet(offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferThreadListItemList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2OffersThreadsGet(offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfferThreadsApi.v2OffersThreadsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} threadId 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2OffersThreadsThreadIdGet(threadId: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferThreadDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2OffersThreadsThreadIdGet(threadId, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfferThreadsApi.v2OffersThreadsThreadIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} threadId 
         * @param {string} xPlatformKey Select the platform.
         * @param {SetMinimumResalePriceRequest} setMinimumResalePriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2OffersThreadsThreadIdMinimumResalePricePatch(threadId: string, xPlatformKey: string, setMinimumResalePriceRequest: SetMinimumResalePriceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2OffersThreadsThreadIdMinimumResalePricePatch(threadId, xPlatformKey, setMinimumResalePriceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfferThreadsApi.v2OffersThreadsThreadIdMinimumResalePricePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} threadId 
         * @param {string} xPlatformKey Select the platform.
         * @param {boolean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2OffersThreadsThreadIdOptInPatch(threadId: string, xPlatformKey: string, body: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2OffersThreadsThreadIdOptInPatch(threadId, xPlatformKey, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfferThreadsApi.v2OffersThreadsThreadIdOptInPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OfferThreadsApi - factory interface
 */
export const OfferThreadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OfferThreadsApiFp(configuration)
    return {
        /**
         * 
         * @param {OfferThreadsApiV2OffersThreadsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersThreadsGet(requestParameters: OfferThreadsApiV2OffersThreadsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OfferThreadListItemList> {
            return localVarFp.v2OffersThreadsGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OfferThreadsApiV2OffersThreadsThreadIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersThreadsThreadIdGet(requestParameters: OfferThreadsApiV2OffersThreadsThreadIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OfferThreadDetail> {
            return localVarFp.v2OffersThreadsThreadIdGet(requestParameters.threadId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OfferThreadsApiV2OffersThreadsThreadIdMinimumResalePricePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersThreadsThreadIdMinimumResalePricePatch(requestParameters: OfferThreadsApiV2OffersThreadsThreadIdMinimumResalePricePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2OffersThreadsThreadIdMinimumResalePricePatch(requestParameters.threadId, requestParameters.xPlatformKey, requestParameters.setMinimumResalePriceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OfferThreadsApiV2OffersThreadsThreadIdOptInPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersThreadsThreadIdOptInPatch(requestParameters: OfferThreadsApiV2OffersThreadsThreadIdOptInPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2OffersThreadsThreadIdOptInPatch(requestParameters.threadId, requestParameters.xPlatformKey, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2OffersThreadsGet operation in OfferThreadsApi.
 */
export interface OfferThreadsApiV2OffersThreadsGetRequest {
    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for v2OffersThreadsThreadIdGet operation in OfferThreadsApi.
 */
export interface OfferThreadsApiV2OffersThreadsThreadIdGetRequest {
    readonly threadId: string

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for v2OffersThreadsThreadIdMinimumResalePricePatch operation in OfferThreadsApi.
 */
export interface OfferThreadsApiV2OffersThreadsThreadIdMinimumResalePricePatchRequest {
    readonly threadId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly setMinimumResalePriceRequest: SetMinimumResalePriceRequest
}

/**
 * Request parameters for v2OffersThreadsThreadIdOptInPatch operation in OfferThreadsApi.
 */
export interface OfferThreadsApiV2OffersThreadsThreadIdOptInPatchRequest {
    readonly threadId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly body: boolean
}

/**
 * OfferThreadsApi - object-oriented interface
 */
export class OfferThreadsApi extends BaseAPI {
    /**
     * 
     * @param {OfferThreadsApiV2OffersThreadsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2OffersThreadsGet(requestParameters: OfferThreadsApiV2OffersThreadsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return OfferThreadsApiFp(this.configuration).v2OffersThreadsGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OfferThreadsApiV2OffersThreadsThreadIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2OffersThreadsThreadIdGet(requestParameters: OfferThreadsApiV2OffersThreadsThreadIdGetRequest, options?: RawAxiosRequestConfig) {
        return OfferThreadsApiFp(this.configuration).v2OffersThreadsThreadIdGet(requestParameters.threadId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OfferThreadsApiV2OffersThreadsThreadIdMinimumResalePricePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2OffersThreadsThreadIdMinimumResalePricePatch(requestParameters: OfferThreadsApiV2OffersThreadsThreadIdMinimumResalePricePatchRequest, options?: RawAxiosRequestConfig) {
        return OfferThreadsApiFp(this.configuration).v2OffersThreadsThreadIdMinimumResalePricePatch(requestParameters.threadId, requestParameters.xPlatformKey, requestParameters.setMinimumResalePriceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OfferThreadsApiV2OffersThreadsThreadIdOptInPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2OffersThreadsThreadIdOptInPatch(requestParameters: OfferThreadsApiV2OffersThreadsThreadIdOptInPatchRequest, options?: RawAxiosRequestConfig) {
        return OfferThreadsApiFp(this.configuration).v2OffersThreadsThreadIdOptInPatch(requestParameters.threadId, requestParameters.xPlatformKey, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OffersApi - axios parameter creator
 */
export const OffersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} offerId 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [productId] 
         * @param {string} [sellerAddressId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersOfferIdAcceptPost: async (offerId: string, xPlatformKey: string, productId?: string, sellerAddressId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('v2OffersOfferIdAcceptPost', 'offerId', offerId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OffersOfferIdAcceptPost', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/offers/{offerId}/accept`
                .replace('{offerId}', encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productId !== undefined) {
                localVarQueryParameter['product_id'] = productId;
            }

            if (sellerAddressId !== undefined) {
                localVarQueryParameter['seller_address_id'] = sellerAddressId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} offerId 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersOfferIdDeclinePost: async (offerId: string, xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('v2OffersOfferIdDeclinePost', 'offerId', offerId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OffersOfferIdDeclinePost', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/offers/{offerId}/decline`
                .replace('{offerId}', encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} offerId 
         * @param {string} tokenId 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersOfferIdPaymentTokenTokenIdPatch: async (offerId: string, tokenId: string, xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('v2OffersOfferIdPaymentTokenTokenIdPatch', 'offerId', offerId)
            // verify required parameter 'tokenId' is not null or undefined
            assertParamExists('v2OffersOfferIdPaymentTokenTokenIdPatch', 'tokenId', tokenId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OffersOfferIdPaymentTokenTokenIdPatch', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/offers/{offerId}/payment-token/{tokenId}`
                .replace('{offerId}', encodeURIComponent(String(offerId)))
                .replace('{tokenId}', encodeURIComponent(String(tokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} offerId 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [sellerAddressId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersOfferIdPayoutBreakdownGet: async (offerId: string, xPlatformKey: string, sellerAddressId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('v2OffersOfferIdPayoutBreakdownGet', 'offerId', offerId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OffersOfferIdPayoutBreakdownGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/offers/{offerId}/payout-breakdown`
                .replace('{offerId}', encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sellerAddressId !== undefined) {
                localVarQueryParameter['seller_address_id'] = sellerAddressId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OffersApi - functional programming interface
 */
export const OffersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OffersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} offerId 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [productId] 
         * @param {string} [sellerAddressId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2OffersOfferIdAcceptPost(offerId: string, xPlatformKey: string, productId?: string, sellerAddressId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2OffersOfferIdAcceptPost(offerId, xPlatformKey, productId, sellerAddressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OffersApi.v2OffersOfferIdAcceptPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} offerId 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2OffersOfferIdDeclinePost(offerId: string, xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2OffersOfferIdDeclinePost(offerId, xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OffersApi.v2OffersOfferIdDeclinePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} offerId 
         * @param {string} tokenId 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2OffersOfferIdPaymentTokenTokenIdPatch(offerId: string, tokenId: string, xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2OffersOfferIdPaymentTokenTokenIdPatch(offerId, tokenId, xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OffersApi.v2OffersOfferIdPaymentTokenTokenIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} offerId 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [sellerAddressId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2OffersOfferIdPayoutBreakdownGet(offerId: string, xPlatformKey: string, sellerAddressId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferPayoutBreakdown>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2OffersOfferIdPayoutBreakdownGet(offerId, xPlatformKey, sellerAddressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OffersApi.v2OffersOfferIdPayoutBreakdownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OffersApi - factory interface
 */
export const OffersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OffersApiFp(configuration)
    return {
        /**
         * 
         * @param {OffersApiV2OffersOfferIdAcceptPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersOfferIdAcceptPost(requestParameters: OffersApiV2OffersOfferIdAcceptPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2OffersOfferIdAcceptPost(requestParameters.offerId, requestParameters.xPlatformKey, requestParameters.productId, requestParameters.sellerAddressId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OffersApiV2OffersOfferIdDeclinePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersOfferIdDeclinePost(requestParameters: OffersApiV2OffersOfferIdDeclinePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2OffersOfferIdDeclinePost(requestParameters.offerId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OffersApiV2OffersOfferIdPaymentTokenTokenIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersOfferIdPaymentTokenTokenIdPatch(requestParameters: OffersApiV2OffersOfferIdPaymentTokenTokenIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2OffersOfferIdPaymentTokenTokenIdPatch(requestParameters.offerId, requestParameters.tokenId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OffersApiV2OffersOfferIdPayoutBreakdownGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OffersOfferIdPayoutBreakdownGet(requestParameters: OffersApiV2OffersOfferIdPayoutBreakdownGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OfferPayoutBreakdown> {
            return localVarFp.v2OffersOfferIdPayoutBreakdownGet(requestParameters.offerId, requestParameters.xPlatformKey, requestParameters.sellerAddressId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2OffersOfferIdAcceptPost operation in OffersApi.
 */
export interface OffersApiV2OffersOfferIdAcceptPostRequest {
    readonly offerId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly productId?: string

    readonly sellerAddressId?: string
}

/**
 * Request parameters for v2OffersOfferIdDeclinePost operation in OffersApi.
 */
export interface OffersApiV2OffersOfferIdDeclinePostRequest {
    readonly offerId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for v2OffersOfferIdPaymentTokenTokenIdPatch operation in OffersApi.
 */
export interface OffersApiV2OffersOfferIdPaymentTokenTokenIdPatchRequest {
    readonly offerId: string

    readonly tokenId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for v2OffersOfferIdPayoutBreakdownGet operation in OffersApi.
 */
export interface OffersApiV2OffersOfferIdPayoutBreakdownGetRequest {
    readonly offerId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly sellerAddressId?: string
}

/**
 * OffersApi - object-oriented interface
 */
export class OffersApi extends BaseAPI {
    /**
     * 
     * @param {OffersApiV2OffersOfferIdAcceptPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2OffersOfferIdAcceptPost(requestParameters: OffersApiV2OffersOfferIdAcceptPostRequest, options?: RawAxiosRequestConfig) {
        return OffersApiFp(this.configuration).v2OffersOfferIdAcceptPost(requestParameters.offerId, requestParameters.xPlatformKey, requestParameters.productId, requestParameters.sellerAddressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OffersApiV2OffersOfferIdDeclinePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2OffersOfferIdDeclinePost(requestParameters: OffersApiV2OffersOfferIdDeclinePostRequest, options?: RawAxiosRequestConfig) {
        return OffersApiFp(this.configuration).v2OffersOfferIdDeclinePost(requestParameters.offerId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OffersApiV2OffersOfferIdPaymentTokenTokenIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2OffersOfferIdPaymentTokenTokenIdPatch(requestParameters: OffersApiV2OffersOfferIdPaymentTokenTokenIdPatchRequest, options?: RawAxiosRequestConfig) {
        return OffersApiFp(this.configuration).v2OffersOfferIdPaymentTokenTokenIdPatch(requestParameters.offerId, requestParameters.tokenId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OffersApiV2OffersOfferIdPayoutBreakdownGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2OffersOfferIdPayoutBreakdownGet(requestParameters: OffersApiV2OffersOfferIdPayoutBreakdownGetRequest, options?: RawAxiosRequestConfig) {
        return OffersApiFp(this.configuration).v2OffersOfferIdPayoutBreakdownGet(requestParameters.offerId, requestParameters.xPlatformKey, requestParameters.sellerAddressId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductBidsApi - axios parameter creator
 */
export const ProductBidsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get bids placed on a product.
         * @param {string} productId Uniquely identify product by Id
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdBidsGet: async (productId: string, xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2ProductsProductIdBidsGet', 'productId', productId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsProductIdBidsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/products/{productId}/bids`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductBidsApi - functional programming interface
 */
export const ProductBidsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductBidsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get bids placed on a product.
         * @param {string} productId Uniquely identify product by Id
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductsProductIdBidsGet(productId: string, xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Bid>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductsProductIdBidsGet(productId, xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductBidsApi.v2ProductsProductIdBidsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductBidsApi - factory interface
 */
export const ProductBidsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductBidsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get bids placed on a product.
         * @param {ProductBidsApiV2ProductsProductIdBidsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdBidsGet(requestParameters: ProductBidsApiV2ProductsProductIdBidsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Bid>> {
            return localVarFp.v2ProductsProductIdBidsGet(requestParameters.productId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2ProductsProductIdBidsGet operation in ProductBidsApi.
 */
export interface ProductBidsApiV2ProductsProductIdBidsGetRequest {
    /**
     * Uniquely identify product by Id
     */
    readonly productId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * ProductBidsApi - object-oriented interface
 */
export class ProductBidsApi extends BaseAPI {
    /**
     * 
     * @summary Get bids placed on a product.
     * @param {ProductBidsApiV2ProductsProductIdBidsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductsProductIdBidsGet(requestParameters: ProductBidsApiV2ProductsProductIdBidsGetRequest, options?: RawAxiosRequestConfig) {
        return ProductBidsApiFp(this.configuration).v2ProductsProductIdBidsGet(requestParameters.productId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductListingFavouritesApi - axios parameter creator
 */
export const ProductListingFavouritesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ProductListingFavouritesSortingField} [sortField] 
         * @param {SortDirection} [direction] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {string} [categoryIds] 
         * @param {BiddingStatus} [biddingStatus] 
         * @param {boolean} [endsInHour] 
         * @param {number | null} [endsInMinutes] 
         * @param {string} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsFavouritesGet: async (sortField?: ProductListingFavouritesSortingField, direction?: SortDirection, offset?: number, pageSize?: number, categoryIds?: string, biddingStatus?: BiddingStatus, endsInHour?: boolean, endsInMinutes?: number | null, currency?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/product-listings/favourites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (categoryIds !== undefined) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }

            if (biddingStatus !== undefined) {
                localVarQueryParameter['bidding_status'] = biddingStatus;
            }

            if (endsInHour !== undefined) {
                localVarQueryParameter['ends_in_hour'] = endsInHour;
            }

            if (endsInMinutes !== undefined) {
                localVarQueryParameter['ends_in_minutes'] = endsInMinutes;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductListingFavouritesApi - functional programming interface
 */
export const ProductListingFavouritesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductListingFavouritesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ProductListingFavouritesSortingField} [sortField] 
         * @param {SortDirection} [direction] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {string} [categoryIds] 
         * @param {BiddingStatus} [biddingStatus] 
         * @param {boolean} [endsInHour] 
         * @param {number | null} [endsInMinutes] 
         * @param {string} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductListingsFavouritesGet(sortField?: ProductListingFavouritesSortingField, direction?: SortDirection, offset?: number, pageSize?: number, categoryIds?: string, biddingStatus?: BiddingStatus, endsInHour?: boolean, endsInMinutes?: number | null, currency?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductListingFavouritesList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductListingsFavouritesGet(sortField, direction, offset, pageSize, categoryIds, biddingStatus, endsInHour, endsInMinutes, currency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductListingFavouritesApi.v2ProductListingsFavouritesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductListingFavouritesApi - factory interface
 */
export const ProductListingFavouritesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductListingFavouritesApiFp(configuration)
    return {
        /**
         * 
         * @param {ProductListingFavouritesApiV2ProductListingsFavouritesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsFavouritesGet(requestParameters: ProductListingFavouritesApiV2ProductListingsFavouritesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ProductListingFavouritesList> {
            return localVarFp.v2ProductListingsFavouritesGet(requestParameters.sortField, requestParameters.direction, requestParameters.offset, requestParameters.pageSize, requestParameters.categoryIds, requestParameters.biddingStatus, requestParameters.endsInHour, requestParameters.endsInMinutes, requestParameters.currency, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2ProductListingsFavouritesGet operation in ProductListingFavouritesApi.
 */
export interface ProductListingFavouritesApiV2ProductListingsFavouritesGetRequest {
    readonly sortField?: ProductListingFavouritesSortingField

    readonly direction?: SortDirection

    readonly offset?: number

    readonly pageSize?: number

    readonly categoryIds?: string

    readonly biddingStatus?: BiddingStatus

    readonly endsInHour?: boolean

    readonly endsInMinutes?: number | null

    readonly currency?: string
}

/**
 * ProductListingFavouritesApi - object-oriented interface
 */
export class ProductListingFavouritesApi extends BaseAPI {
    /**
     * 
     * @param {ProductListingFavouritesApiV2ProductListingsFavouritesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductListingsFavouritesGet(requestParameters: ProductListingFavouritesApiV2ProductListingsFavouritesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductListingFavouritesApiFp(this.configuration).v2ProductListingsFavouritesGet(requestParameters.sortField, requestParameters.direction, requestParameters.offset, requestParameters.pageSize, requestParameters.categoryIds, requestParameters.biddingStatus, requestParameters.endsInHour, requestParameters.endsInMinutes, requestParameters.currency, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductListingResellApi - axios parameter creator
 */
export const ProductListingResellApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} listingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offerPrice] 
         * @param {string} [currency] 
         * @param {string} [estimatedCountryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsListingIdOfferCostsGet: async (listingId: string, xPlatformKey: string, offerPrice?: number, currency?: string, estimatedCountryCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('v2ProductListingsListingIdOfferCostsGet', 'listingId', listingId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductListingsListingIdOfferCostsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/product-listings/{listingId}/offer-costs`
                .replace('{listingId}', encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offerPrice !== undefined) {
                localVarQueryParameter['offer_price'] = offerPrice;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (estimatedCountryCode !== undefined) {
                localVarQueryParameter['estimated_country_code'] = estimatedCountryCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} listingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offerPrice] 
         * @param {string} [currency] 
         * @param {string} [estimatedCountryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsListingIdOfferPost: async (listingId: string, xPlatformKey: string, offerPrice?: number, currency?: string, estimatedCountryCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('v2ProductListingsListingIdOfferPost', 'listingId', listingId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductListingsListingIdOfferPost', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/product-listings/{listingId}/offer`
                .replace('{listingId}', encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offerPrice !== undefined) {
                localVarQueryParameter['offer_price'] = offerPrice;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (estimatedCountryCode !== undefined) {
                localVarQueryParameter['estimated_country_code'] = estimatedCountryCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} listingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsListingIdResaleBadConditionPatch: async (listingId: string, xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('v2ProductListingsListingIdResaleBadConditionPatch', 'listingId', listingId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductListingsListingIdResaleBadConditionPatch', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/product-listings/{listingId}/resale/bad-condition`
                .replace('{listingId}', encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} listingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsListingIdResaleNotAvailablePatch: async (listingId: string, xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('v2ProductListingsListingIdResaleNotAvailablePatch', 'listingId', listingId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductListingsListingIdResaleNotAvailablePatch', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/product-listings/{listingId}/resale/not-available`
                .replace('{listingId}', encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} listingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [estimatedCountryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsListingIdResellEligibilityGet: async (listingId: string, xPlatformKey: string, estimatedCountryCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('v2ProductListingsListingIdResellEligibilityGet', 'listingId', listingId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductListingsListingIdResellEligibilityGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/product-listings/{listingId}/resell-eligibility`
                .replace('{listingId}', encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (estimatedCountryCode !== undefined) {
                localVarQueryParameter['estimated_country_code'] = estimatedCountryCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductListingResellApi - functional programming interface
 */
export const ProductListingResellApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductListingResellApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} listingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offerPrice] 
         * @param {string} [currency] 
         * @param {string} [estimatedCountryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductListingsListingIdOfferCostsGet(listingId: string, xPlatformKey: string, offerPrice?: number, currency?: string, estimatedCountryCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferCosts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductListingsListingIdOfferCostsGet(listingId, xPlatformKey, offerPrice, currency, estimatedCountryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductListingResellApi.v2ProductListingsListingIdOfferCostsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} listingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offerPrice] 
         * @param {string} [currency] 
         * @param {string} [estimatedCountryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductListingsListingIdOfferPost(listingId: string, xPlatformKey: string, offerPrice?: number, currency?: string, estimatedCountryCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOffer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductListingsListingIdOfferPost(listingId, xPlatformKey, offerPrice, currency, estimatedCountryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductListingResellApi.v2ProductListingsListingIdOfferPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} listingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductListingsListingIdResaleBadConditionPatch(listingId: string, xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductListingsListingIdResaleBadConditionPatch(listingId, xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductListingResellApi.v2ProductListingsListingIdResaleBadConditionPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} listingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductListingsListingIdResaleNotAvailablePatch(listingId: string, xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductListingsListingIdResaleNotAvailablePatch(listingId, xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductListingResellApi.v2ProductListingsListingIdResaleNotAvailablePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} listingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [estimatedCountryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductListingsListingIdResellEligibilityGet(listingId: string, xPlatformKey: string, estimatedCountryCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResellEligibility>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductListingsListingIdResellEligibilityGet(listingId, xPlatformKey, estimatedCountryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductListingResellApi.v2ProductListingsListingIdResellEligibilityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductListingResellApi - factory interface
 */
export const ProductListingResellApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductListingResellApiFp(configuration)
    return {
        /**
         * 
         * @param {ProductListingResellApiV2ProductListingsListingIdOfferCostsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsListingIdOfferCostsGet(requestParameters: ProductListingResellApiV2ProductListingsListingIdOfferCostsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OfferCosts> {
            return localVarFp.v2ProductListingsListingIdOfferCostsGet(requestParameters.listingId, requestParameters.xPlatformKey, requestParameters.offerPrice, requestParameters.currency, requestParameters.estimatedCountryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductListingResellApiV2ProductListingsListingIdOfferPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsListingIdOfferPost(requestParameters: ProductListingResellApiV2ProductListingsListingIdOfferPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOffer> {
            return localVarFp.v2ProductListingsListingIdOfferPost(requestParameters.listingId, requestParameters.xPlatformKey, requestParameters.offerPrice, requestParameters.currency, requestParameters.estimatedCountryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductListingResellApiV2ProductListingsListingIdResaleBadConditionPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsListingIdResaleBadConditionPatch(requestParameters: ProductListingResellApiV2ProductListingsListingIdResaleBadConditionPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2ProductListingsListingIdResaleBadConditionPatch(requestParameters.listingId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductListingResellApiV2ProductListingsListingIdResaleNotAvailablePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsListingIdResaleNotAvailablePatch(requestParameters: ProductListingResellApiV2ProductListingsListingIdResaleNotAvailablePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2ProductListingsListingIdResaleNotAvailablePatch(requestParameters.listingId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductListingResellApiV2ProductListingsListingIdResellEligibilityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsListingIdResellEligibilityGet(requestParameters: ProductListingResellApiV2ProductListingsListingIdResellEligibilityGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResellEligibility> {
            return localVarFp.v2ProductListingsListingIdResellEligibilityGet(requestParameters.listingId, requestParameters.xPlatformKey, requestParameters.estimatedCountryCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2ProductListingsListingIdOfferCostsGet operation in ProductListingResellApi.
 */
export interface ProductListingResellApiV2ProductListingsListingIdOfferCostsGetRequest {
    readonly listingId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly offerPrice?: number

    readonly currency?: string

    readonly estimatedCountryCode?: string
}

/**
 * Request parameters for v2ProductListingsListingIdOfferPost operation in ProductListingResellApi.
 */
export interface ProductListingResellApiV2ProductListingsListingIdOfferPostRequest {
    readonly listingId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly offerPrice?: number

    readonly currency?: string

    readonly estimatedCountryCode?: string
}

/**
 * Request parameters for v2ProductListingsListingIdResaleBadConditionPatch operation in ProductListingResellApi.
 */
export interface ProductListingResellApiV2ProductListingsListingIdResaleBadConditionPatchRequest {
    readonly listingId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for v2ProductListingsListingIdResaleNotAvailablePatch operation in ProductListingResellApi.
 */
export interface ProductListingResellApiV2ProductListingsListingIdResaleNotAvailablePatchRequest {
    readonly listingId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for v2ProductListingsListingIdResellEligibilityGet operation in ProductListingResellApi.
 */
export interface ProductListingResellApiV2ProductListingsListingIdResellEligibilityGetRequest {
    readonly listingId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly estimatedCountryCode?: string
}

/**
 * ProductListingResellApi - object-oriented interface
 */
export class ProductListingResellApi extends BaseAPI {
    /**
     * 
     * @param {ProductListingResellApiV2ProductListingsListingIdOfferCostsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductListingsListingIdOfferCostsGet(requestParameters: ProductListingResellApiV2ProductListingsListingIdOfferCostsGetRequest, options?: RawAxiosRequestConfig) {
        return ProductListingResellApiFp(this.configuration).v2ProductListingsListingIdOfferCostsGet(requestParameters.listingId, requestParameters.xPlatformKey, requestParameters.offerPrice, requestParameters.currency, requestParameters.estimatedCountryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductListingResellApiV2ProductListingsListingIdOfferPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductListingsListingIdOfferPost(requestParameters: ProductListingResellApiV2ProductListingsListingIdOfferPostRequest, options?: RawAxiosRequestConfig) {
        return ProductListingResellApiFp(this.configuration).v2ProductListingsListingIdOfferPost(requestParameters.listingId, requestParameters.xPlatformKey, requestParameters.offerPrice, requestParameters.currency, requestParameters.estimatedCountryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductListingResellApiV2ProductListingsListingIdResaleBadConditionPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductListingsListingIdResaleBadConditionPatch(requestParameters: ProductListingResellApiV2ProductListingsListingIdResaleBadConditionPatchRequest, options?: RawAxiosRequestConfig) {
        return ProductListingResellApiFp(this.configuration).v2ProductListingsListingIdResaleBadConditionPatch(requestParameters.listingId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductListingResellApiV2ProductListingsListingIdResaleNotAvailablePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductListingsListingIdResaleNotAvailablePatch(requestParameters: ProductListingResellApiV2ProductListingsListingIdResaleNotAvailablePatchRequest, options?: RawAxiosRequestConfig) {
        return ProductListingResellApiFp(this.configuration).v2ProductListingsListingIdResaleNotAvailablePatch(requestParameters.listingId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductListingResellApiV2ProductListingsListingIdResellEligibilityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductListingsListingIdResellEligibilityGet(requestParameters: ProductListingResellApiV2ProductListingsListingIdResellEligibilityGetRequest, options?: RawAxiosRequestConfig) {
        return ProductListingResellApiFp(this.configuration).v2ProductListingsListingIdResellEligibilityGet(requestParameters.listingId, requestParameters.xPlatformKey, requestParameters.estimatedCountryCode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductListingsApi - axios parameter creator
 */
export const ProductListingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get live product listings filtered by category. When categorySlug is provided, only listings that have the slug on the product\'s categories - but whose event does not have that category - are returned.
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [categorySlug] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsGet: async (xPlatformKey: string, categorySlug?: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductListingsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/product-listings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categorySlug !== undefined) {
                localVarQueryParameter['category_slug'] = categorySlug;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deliberately not edge-cached: every answer is specific to one Dynamic Yield user. The no-store directive says so out loud, because a cache rule written for the sibling listing endpoints would otherwise be free to treat this as heuristically cacheable and hand one shopper\'s row to the next.
         * @summary Get other live listings recommended alongside this one, in the order Dynamic Yield ranked them. Each item carries the slot id to report back when a shopper clicks it.
         * @param {string} listingId The listing whose page is being viewed.
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [numRecommendations] How many recommendations to return at most, from 1 to 20; a count outside that range is brought into it. Fewer come back when Dynamic Yield ranked fewer, or when what it ranked is no longer something a shopper can buy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsListingIdRecommendationsGet: async (listingId: string, xPlatformKey: string, numRecommendations?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('v2ProductListingsListingIdRecommendationsGet', 'listingId', listingId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductListingsListingIdRecommendationsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/product-listings/{listingId}/recommendations`
                .replace('{listingId}', encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (numRecommendations !== undefined) {
                localVarQueryParameter['num_recommendations'] = numRecommendations;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductListingsApi - functional programming interface
 */
export const ProductListingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductListingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get live product listings filtered by category. When categorySlug is provided, only listings that have the slug on the product\'s categories - but whose event does not have that category - are returned.
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [categorySlug] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductListingsGet(xPlatformKey: string, categorySlug?: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductListItemList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductListingsGet(xPlatformKey, categorySlug, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductListingsApi.v2ProductListingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deliberately not edge-cached: every answer is specific to one Dynamic Yield user. The no-store directive says so out loud, because a cache rule written for the sibling listing endpoints would otherwise be free to treat this as heuristically cacheable and hand one shopper\'s row to the next.
         * @summary Get other live listings recommended alongside this one, in the order Dynamic Yield ranked them. Each item carries the slot id to report back when a shopper clicks it.
         * @param {string} listingId The listing whose page is being viewed.
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [numRecommendations] How many recommendations to return at most, from 1 to 20; a count outside that range is brought into it. Fewer come back when Dynamic Yield ranked fewer, or when what it ranked is no longer something a shopper can buy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductListingsListingIdRecommendationsGet(listingId: string, xPlatformKey: string, numRecommendations?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductRecommendations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductListingsListingIdRecommendationsGet(listingId, xPlatformKey, numRecommendations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductListingsApi.v2ProductListingsListingIdRecommendationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductListingsApi - factory interface
 */
export const ProductListingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductListingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get live product listings filtered by category. When categorySlug is provided, only listings that have the slug on the product\'s categories - but whose event does not have that category - are returned.
         * @param {ProductListingsApiV2ProductListingsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsGet(requestParameters: ProductListingsApiV2ProductListingsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductListItemList> {
            return localVarFp.v2ProductListingsGet(requestParameters.xPlatformKey, requestParameters.categorySlug, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Deliberately not edge-cached: every answer is specific to one Dynamic Yield user. The no-store directive says so out loud, because a cache rule written for the sibling listing endpoints would otherwise be free to treat this as heuristically cacheable and hand one shopper\'s row to the next.
         * @summary Get other live listings recommended alongside this one, in the order Dynamic Yield ranked them. Each item carries the slot id to report back when a shopper clicks it.
         * @param {ProductListingsApiV2ProductListingsListingIdRecommendationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsListingIdRecommendationsGet(requestParameters: ProductListingsApiV2ProductListingsListingIdRecommendationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductRecommendations> {
            return localVarFp.v2ProductListingsListingIdRecommendationsGet(requestParameters.listingId, requestParameters.xPlatformKey, requestParameters.numRecommendations, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2ProductListingsGet operation in ProductListingsApi.
 */
export interface ProductListingsApiV2ProductListingsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly categorySlug?: string

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for v2ProductListingsListingIdRecommendationsGet operation in ProductListingsApi.
 */
export interface ProductListingsApiV2ProductListingsListingIdRecommendationsGetRequest {
    /**
     * The listing whose page is being viewed.
     */
    readonly listingId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * How many recommendations to return at most, from 1 to 20; a count outside that range is brought into it. Fewer come back when Dynamic Yield ranked fewer, or when what it ranked is no longer something a shopper can buy.
     */
    readonly numRecommendations?: number
}

/**
 * ProductListingsApi - object-oriented interface
 */
export class ProductListingsApi extends BaseAPI {
    /**
     * 
     * @summary Get live product listings filtered by category. When categorySlug is provided, only listings that have the slug on the product\'s categories - but whose event does not have that category - are returned.
     * @param {ProductListingsApiV2ProductListingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductListingsGet(requestParameters: ProductListingsApiV2ProductListingsGetRequest, options?: RawAxiosRequestConfig) {
        return ProductListingsApiFp(this.configuration).v2ProductListingsGet(requestParameters.xPlatformKey, requestParameters.categorySlug, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deliberately not edge-cached: every answer is specific to one Dynamic Yield user. The no-store directive says so out loud, because a cache rule written for the sibling listing endpoints would otherwise be free to treat this as heuristically cacheable and hand one shopper\'s row to the next.
     * @summary Get other live listings recommended alongside this one, in the order Dynamic Yield ranked them. Each item carries the slot id to report back when a shopper clicks it.
     * @param {ProductListingsApiV2ProductListingsListingIdRecommendationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductListingsListingIdRecommendationsGet(requestParameters: ProductListingsApiV2ProductListingsListingIdRecommendationsGetRequest, options?: RawAxiosRequestConfig) {
        return ProductListingsApiFp(this.configuration).v2ProductListingsListingIdRecommendationsGet(requestParameters.listingId, requestParameters.xPlatformKey, requestParameters.numRecommendations, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductListingsBidsApi - axios parameter creator
 */
export const ProductListingsBidsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get an active max bid by product listing and user id.
         * @param {string} productListingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsProductListingIdBidsMaxGet: async (productListingId: string, xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productListingId' is not null or undefined
            assertParamExists('v2ProductListingsProductListingIdBidsMaxGet', 'productListingId', productListingId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductListingsProductListingIdBidsMaxGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/product-listings/{productListingId}/bids/max`
                .replace('{productListingId}', encodeURIComponent(String(productListingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Place a max bid on a product.
         * @param {string} productListingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {PlaceMaxBidRequest} placeMaxBidRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsProductListingIdBidsMaxPost: async (productListingId: string, xPlatformKey: string, placeMaxBidRequest: PlaceMaxBidRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productListingId' is not null or undefined
            assertParamExists('v2ProductListingsProductListingIdBidsMaxPost', 'productListingId', productListingId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductListingsProductListingIdBidsMaxPost', 'xPlatformKey', xPlatformKey)
            // verify required parameter 'placeMaxBidRequest' is not null or undefined
            assertParamExists('v2ProductListingsProductListingIdBidsMaxPost', 'placeMaxBidRequest', placeMaxBidRequest)
            const localVarPath = `/v2/product-listings/{productListingId}/bids/max`
                .replace('{productListingId}', encodeURIComponent(String(productListingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = placeMaxBidRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductListingsBidsApi - functional programming interface
 */
export const ProductListingsBidsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductListingsBidsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get an active max bid by product listing and user id.
         * @param {string} productListingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductListingsProductListingIdBidsMaxGet(productListingId: string, xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaxBid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductListingsProductListingIdBidsMaxGet(productListingId, xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductListingsBidsApi.v2ProductListingsProductListingIdBidsMaxGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Place a max bid on a product.
         * @param {string} productListingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {PlaceMaxBidRequest} placeMaxBidRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductListingsProductListingIdBidsMaxPost(productListingId: string, xPlatformKey: string, placeMaxBidRequest: PlaceMaxBidRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaxBidPlaced>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductListingsProductListingIdBidsMaxPost(productListingId, xPlatformKey, placeMaxBidRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductListingsBidsApi.v2ProductListingsProductListingIdBidsMaxPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductListingsBidsApi - factory interface
 */
export const ProductListingsBidsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductListingsBidsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get an active max bid by product listing and user id.
         * @param {ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsProductListingIdBidsMaxGet(requestParameters: ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<MaxBid> {
            return localVarFp.v2ProductListingsProductListingIdBidsMaxGet(requestParameters.productListingId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Place a max bid on a product.
         * @param {ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsProductListingIdBidsMaxPost(requestParameters: ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<MaxBidPlaced> {
            return localVarFp.v2ProductListingsProductListingIdBidsMaxPost(requestParameters.productListingId, requestParameters.xPlatformKey, requestParameters.placeMaxBidRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2ProductListingsProductListingIdBidsMaxGet operation in ProductListingsBidsApi.
 */
export interface ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxGetRequest {
    readonly productListingId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for v2ProductListingsProductListingIdBidsMaxPost operation in ProductListingsBidsApi.
 */
export interface ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxPostRequest {
    readonly productListingId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly placeMaxBidRequest: PlaceMaxBidRequest
}

/**
 * ProductListingsBidsApi - object-oriented interface
 */
export class ProductListingsBidsApi extends BaseAPI {
    /**
     * 
     * @summary Get an active max bid by product listing and user id.
     * @param {ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductListingsProductListingIdBidsMaxGet(requestParameters: ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxGetRequest, options?: RawAxiosRequestConfig) {
        return ProductListingsBidsApiFp(this.configuration).v2ProductListingsProductListingIdBidsMaxGet(requestParameters.productListingId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Place a max bid on a product.
     * @param {ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductListingsProductListingIdBidsMaxPost(requestParameters: ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxPostRequest, options?: RawAxiosRequestConfig) {
        return ProductListingsBidsApiFp(this.configuration).v2ProductListingsProductListingIdBidsMaxPost(requestParameters.productListingId, requestParameters.xPlatformKey, requestParameters.placeMaxBidRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductOrdersApi - axios parameter creator
 */
export const ProductOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} listingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {CreateProductOrderRequest} createProductOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsListingIdOrdersPost: async (listingId: string, xPlatformKey: string, createProductOrderRequest: CreateProductOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('v2ProductsListingIdOrdersPost', 'listingId', listingId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsListingIdOrdersPost', 'xPlatformKey', xPlatformKey)
            // verify required parameter 'createProductOrderRequest' is not null or undefined
            assertParamExists('v2ProductsListingIdOrdersPost', 'createProductOrderRequest', createProductOrderRequest)
            const localVarPath = `/v2/products/{listingId}/orders`
                .replace('{listingId}', encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = createProductOrderRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductOrdersApi - functional programming interface
 */
export const ProductOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} listingId 
         * @param {string} xPlatformKey Select the platform.
         * @param {CreateProductOrderRequest} createProductOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductsListingIdOrdersPost(listingId: string, xPlatformKey: string, createProductOrderRequest: CreateProductOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateProductOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductsListingIdOrdersPost(listingId, xPlatformKey, createProductOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductOrdersApi.v2ProductsListingIdOrdersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductOrdersApi - factory interface
 */
export const ProductOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductOrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {ProductOrdersApiV2ProductsListingIdOrdersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsListingIdOrdersPost(requestParameters: ProductOrdersApiV2ProductsListingIdOrdersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateProductOrder> {
            return localVarFp.v2ProductsListingIdOrdersPost(requestParameters.listingId, requestParameters.xPlatformKey, requestParameters.createProductOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2ProductsListingIdOrdersPost operation in ProductOrdersApi.
 */
export interface ProductOrdersApiV2ProductsListingIdOrdersPostRequest {
    readonly listingId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly createProductOrderRequest: CreateProductOrderRequest
}

/**
 * ProductOrdersApi - object-oriented interface
 */
export class ProductOrdersApi extends BaseAPI {
    /**
     * 
     * @param {ProductOrdersApiV2ProductsListingIdOrdersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductsListingIdOrdersPost(requestParameters: ProductOrdersApiV2ProductsListingIdOrdersPostRequest, options?: RawAxiosRequestConfig) {
        return ProductOrdersApiFp(this.configuration).v2ProductsListingIdOrdersPost(requestParameters.listingId, requestParameters.xPlatformKey, requestParameters.createProductOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductsApi - axios parameter creator
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get product by certificate number
         * @param {string} certificateNumber 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsCertificateCertificateNumberGet: async (certificateNumber: string, xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificateNumber' is not null or undefined
            assertParamExists('v2ProductsCertificateCertificateNumberGet', 'certificateNumber', certificateNumber)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsCertificateCertificateNumberGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/products/certificate/{certificateNumber}`
                .replace('{certificateNumber}', encodeURIComponent(String(certificateNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get products for a given published event. If no Id is provided then returns products for all published events. This endpoint will be deprecated at 2024-02-04
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId] Uniquely identify the event by Guid or Slug
         * @param {string} [categorySlug] Filter the products by category
         * @param {SalesMethod} [salesMethod] Filter the products by sales method
         * @param {boolean} [onlyReturnNotEnded] show only products that end date\&#39;s not past
         * @param {boolean} [returnNotStarted] Also return products that have not started yet
         * @param {boolean} [sortByCreateDate] After priority score, should we sort it by date of creation
         * @param {ProductSorting} [sortProductsBy] 
         * @param {number | null} [minimumPrice] 
         * @param {number | null} [maximumPrice] 
         * @param {string} [currencyCode] 
         * @param {ProductStatus} [productStatus] 
         * @param {string} [categoryIds] 
         * @param {string} [productTypeIds] 
         * @param {string} [productIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsGet: async (xPlatformKey: string, eventId?: string, categorySlug?: string, salesMethod?: SalesMethod, onlyReturnNotEnded?: boolean, returnNotStarted?: boolean, sortByCreateDate?: boolean, sortProductsBy?: ProductSorting, minimumPrice?: number | null, maximumPrice?: number | null, currencyCode?: string, productStatus?: ProductStatus, categoryIds?: string, productTypeIds?: string, productIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventId !== undefined) {
                localVarQueryParameter['event_id'] = eventId;
            }

            if (categorySlug !== undefined) {
                localVarQueryParameter['category_slug'] = categorySlug;
            }

            if (salesMethod !== undefined) {
                localVarQueryParameter['sales_method'] = salesMethod;
            }

            if (onlyReturnNotEnded !== undefined) {
                localVarQueryParameter['only_return_not_ended'] = onlyReturnNotEnded;
            }

            if (returnNotStarted !== undefined) {
                localVarQueryParameter['return_not_started'] = returnNotStarted;
            }

            if (sortByCreateDate !== undefined) {
                localVarQueryParameter['sort_by_create_date'] = sortByCreateDate;
            }

            if (sortProductsBy !== undefined) {
                localVarQueryParameter['sort_products_by'] = sortProductsBy;
            }

            if (minimumPrice !== undefined) {
                localVarQueryParameter['minimum_price'] = minimumPrice;
            }

            if (maximumPrice !== undefined) {
                localVarQueryParameter['maximum_price'] = maximumPrice;
            }

            if (currencyCode !== undefined) {
                localVarQueryParameter['currency_code'] = currencyCode;
            }

            if (productStatus !== undefined) {
                localVarQueryParameter['product_status'] = productStatus;
            }

            if (categoryIds !== undefined) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }

            if (productTypeIds !== undefined) {
                localVarQueryParameter['product_type_ids'] = productTypeIds;
            }

            if (productIds !== undefined) {
                localVarQueryParameter['product_ids'] = productIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get match scored ball products for a category
         * @param {string} categoryId 
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [numberOfProducts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsMatchScoredBallsCategoryCategoryIdGet: async (categoryId: string, xPlatformKey: string, numberOfProducts?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('v2ProductsMatchScoredBallsCategoryCategoryIdGet', 'categoryId', categoryId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsMatchScoredBallsCategoryCategoryIdGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/products/match-scored-balls/category/{categoryId}`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (numberOfProducts !== undefined) {
                localVarQueryParameter['number_of_products'] = numberOfProducts;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get products for a given published event. If no Id is provided then returns products for all published events.
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId] Uniquely identify the event by Guid or Slug
         * @param {string} [categorySlug] Filter the products by sales category
         * @param {SalesMethod} [salesMethod] Filter the products by sales method
         * @param {boolean} [onlyReturnNotEnded] show only products that end date\&#39;s not past
         * @param {boolean} [returnNotStarted] Also return products that have not started yet
         * @param {boolean} [sortByCreateDate] After priority score, should we sort it by date of creation
         * @param {ProductSorting} [sortProductsBy] 
         * @param {number | null} [minimumPrice] 
         * @param {number | null} [maximumPrice] 
         * @param {string} [currencyCode] 
         * @param {ProductStatus} [productStatus] 
         * @param {string} [categoryIds] 
         * @param {string} [productTypeIds] 
         * @param {string} [productIds] 
         * @param {string} [productSlugs] Comma separated list of product slugs to filter the products by
         * @param {boolean} [onlyWithBids] If true, only return listings that have at least one bid placed
         * @param {boolean} [excludeEventCategorySlug] If true, use categorySlug to exclude products whose event belongs to that category, instead of including products in that category
         * @param {number} [offset] The amount of items to skip in the results
         * @param {number} [pageSize] Size of the requested page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsPaginatedGet: async (xPlatformKey: string, eventId?: string, categorySlug?: string, salesMethod?: SalesMethod, onlyReturnNotEnded?: boolean, returnNotStarted?: boolean, sortByCreateDate?: boolean, sortProductsBy?: ProductSorting, minimumPrice?: number | null, maximumPrice?: number | null, currencyCode?: string, productStatus?: ProductStatus, categoryIds?: string, productTypeIds?: string, productIds?: string, productSlugs?: string, onlyWithBids?: boolean, excludeEventCategorySlug?: boolean, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsPaginatedGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/products/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventId !== undefined) {
                localVarQueryParameter['event_id'] = eventId;
            }

            if (categorySlug !== undefined) {
                localVarQueryParameter['category_slug'] = categorySlug;
            }

            if (salesMethod !== undefined) {
                localVarQueryParameter['sales_method'] = salesMethod;
            }

            if (onlyReturnNotEnded !== undefined) {
                localVarQueryParameter['only_return_not_ended'] = onlyReturnNotEnded;
            }

            if (returnNotStarted !== undefined) {
                localVarQueryParameter['return_not_started'] = returnNotStarted;
            }

            if (sortByCreateDate !== undefined) {
                localVarQueryParameter['sort_by_create_date'] = sortByCreateDate;
            }

            if (sortProductsBy !== undefined) {
                localVarQueryParameter['sort_products_by'] = sortProductsBy;
            }

            if (minimumPrice !== undefined) {
                localVarQueryParameter['minimum_price'] = minimumPrice;
            }

            if (maximumPrice !== undefined) {
                localVarQueryParameter['maximum_price'] = maximumPrice;
            }

            if (currencyCode !== undefined) {
                localVarQueryParameter['currency_code'] = currencyCode;
            }

            if (productStatus !== undefined) {
                localVarQueryParameter['product_status'] = productStatus;
            }

            if (categoryIds !== undefined) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }

            if (productTypeIds !== undefined) {
                localVarQueryParameter['product_type_ids'] = productTypeIds;
            }

            if (productIds !== undefined) {
                localVarQueryParameter['product_ids'] = productIds;
            }

            if (productSlugs !== undefined) {
                localVarQueryParameter['product_slugs'] = productSlugs;
            }

            if (onlyWithBids !== undefined) {
                localVarQueryParameter['only_with_bids'] = onlyWithBids;
            }

            if (excludeEventCategorySlug !== undefined) {
                localVarQueryParameter['exclude_event_category_slug'] = excludeEventCategorySlug;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a product with its event and sibling products, tailored for AMP emails sent from CustomerIO.
         * @param {string} productIdentifier Uniquely identify the product by Guid or Slug
         * @param {string} [currencyCode] When set, prices are narrowed to this currency at every level of the response
         * @param {number | null} [maxExtraProducts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdentifierAmpGet: async (productIdentifier: string, currencyCode?: string, maxExtraProducts?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productIdentifier' is not null or undefined
            assertParamExists('v2ProductsProductIdentifierAmpGet', 'productIdentifier', productIdentifier)
            const localVarPath = `/v2/products/{productIdentifier}/amp`
                .replace('{productIdentifier}', encodeURIComponent(String(productIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currencyCode !== undefined) {
                localVarQueryParameter['currency_code'] = currencyCode;
            }

            if (maxExtraProducts !== undefined) {
                localVarQueryParameter['max_extra_products'] = maxExtraProducts;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productIdentifier 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [currency] 
         * @param {string} [countryCode] 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdentifierCostEstimateGet: async (productIdentifier: string, xPlatformKey: string, currency?: string, countryCode?: string, stateCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productIdentifier' is not null or undefined
            assertParamExists('v2ProductsProductIdentifierCostEstimateGet', 'productIdentifier', productIdentifier)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsProductIdentifierCostEstimateGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/products/{productIdentifier}/cost-estimate`
                .replace('{productIdentifier}', encodeURIComponent(String(productIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (countryCode !== undefined) {
                localVarQueryParameter['country_code'] = countryCode;
            }

            if (stateCode !== undefined) {
                localVarQueryParameter['state_code'] = stateCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get product details.
         * @param {string} productIdentifier Uniquely identify the product by Guid or Slug
         * @param {string} xPlatformKey Select the platform.
         * @param {boolean} [includeEvent] Also return the event fields the product page shows, or null when the event is not published on the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdentifierGet: async (productIdentifier: string, xPlatformKey: string, includeEvent?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productIdentifier' is not null or undefined
            assertParamExists('v2ProductsProductIdentifierGet', 'productIdentifier', productIdentifier)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsProductIdentifierGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/products/{productIdentifier}`
                .replace('{productIdentifier}', encodeURIComponent(String(productIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeEvent !== undefined) {
                localVarQueryParameter['include_event'] = includeEvent;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get product by certificate number
         * @param {string} certificateNumber 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductsCertificateCertificateNumberGet(certificateNumber: string, xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductsCertificateCertificateNumberGet(certificateNumber, xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.v2ProductsCertificateCertificateNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get products for a given published event. If no Id is provided then returns products for all published events. This endpoint will be deprecated at 2024-02-04
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId] Uniquely identify the event by Guid or Slug
         * @param {string} [categorySlug] Filter the products by category
         * @param {SalesMethod} [salesMethod] Filter the products by sales method
         * @param {boolean} [onlyReturnNotEnded] show only products that end date\&#39;s not past
         * @param {boolean} [returnNotStarted] Also return products that have not started yet
         * @param {boolean} [sortByCreateDate] After priority score, should we sort it by date of creation
         * @param {ProductSorting} [sortProductsBy] 
         * @param {number | null} [minimumPrice] 
         * @param {number | null} [maximumPrice] 
         * @param {string} [currencyCode] 
         * @param {ProductStatus} [productStatus] 
         * @param {string} [categoryIds] 
         * @param {string} [productTypeIds] 
         * @param {string} [productIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductsGet(xPlatformKey: string, eventId?: string, categorySlug?: string, salesMethod?: SalesMethod, onlyReturnNotEnded?: boolean, returnNotStarted?: boolean, sortByCreateDate?: boolean, sortProductsBy?: ProductSorting, minimumPrice?: number | null, maximumPrice?: number | null, currencyCode?: string, productStatus?: ProductStatus, categoryIds?: string, productTypeIds?: string, productIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Product>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductsGet(xPlatformKey, eventId, categorySlug, salesMethod, onlyReturnNotEnded, returnNotStarted, sortByCreateDate, sortProductsBy, minimumPrice, maximumPrice, currencyCode, productStatus, categoryIds, productTypeIds, productIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.v2ProductsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get match scored ball products for a category
         * @param {string} categoryId 
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [numberOfProducts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductsMatchScoredBallsCategoryCategoryIdGet(categoryId: string, xPlatformKey: string, numberOfProducts?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchScoredBallsByCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductsMatchScoredBallsCategoryCategoryIdGet(categoryId, xPlatformKey, numberOfProducts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.v2ProductsMatchScoredBallsCategoryCategoryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get products for a given published event. If no Id is provided then returns products for all published events.
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId] Uniquely identify the event by Guid or Slug
         * @param {string} [categorySlug] Filter the products by sales category
         * @param {SalesMethod} [salesMethod] Filter the products by sales method
         * @param {boolean} [onlyReturnNotEnded] show only products that end date\&#39;s not past
         * @param {boolean} [returnNotStarted] Also return products that have not started yet
         * @param {boolean} [sortByCreateDate] After priority score, should we sort it by date of creation
         * @param {ProductSorting} [sortProductsBy] 
         * @param {number | null} [minimumPrice] 
         * @param {number | null} [maximumPrice] 
         * @param {string} [currencyCode] 
         * @param {ProductStatus} [productStatus] 
         * @param {string} [categoryIds] 
         * @param {string} [productTypeIds] 
         * @param {string} [productIds] 
         * @param {string} [productSlugs] Comma separated list of product slugs to filter the products by
         * @param {boolean} [onlyWithBids] If true, only return listings that have at least one bid placed
         * @param {boolean} [excludeEventCategorySlug] If true, use categorySlug to exclude products whose event belongs to that category, instead of including products in that category
         * @param {number} [offset] The amount of items to skip in the results
         * @param {number} [pageSize] Size of the requested page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductsPaginatedGet(xPlatformKey: string, eventId?: string, categorySlug?: string, salesMethod?: SalesMethod, onlyReturnNotEnded?: boolean, returnNotStarted?: boolean, sortByCreateDate?: boolean, sortProductsBy?: ProductSorting, minimumPrice?: number | null, maximumPrice?: number | null, currencyCode?: string, productStatus?: ProductStatus, categoryIds?: string, productTypeIds?: string, productIds?: string, productSlugs?: string, onlyWithBids?: boolean, excludeEventCategorySlug?: boolean, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductListItemList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductsPaginatedGet(xPlatformKey, eventId, categorySlug, salesMethod, onlyReturnNotEnded, returnNotStarted, sortByCreateDate, sortProductsBy, minimumPrice, maximumPrice, currencyCode, productStatus, categoryIds, productTypeIds, productIds, productSlugs, onlyWithBids, excludeEventCategorySlug, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.v2ProductsPaginatedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a product with its event and sibling products, tailored for AMP emails sent from CustomerIO.
         * @param {string} productIdentifier Uniquely identify the product by Guid or Slug
         * @param {string} [currencyCode] When set, prices are narrowed to this currency at every level of the response
         * @param {number | null} [maxExtraProducts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductsProductIdentifierAmpGet(productIdentifier: string, currencyCode?: string, maxExtraProducts?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AmpProductDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductsProductIdentifierAmpGet(productIdentifier, currencyCode, maxExtraProducts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.v2ProductsProductIdentifierAmpGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productIdentifier 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [currency] 
         * @param {string} [countryCode] 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductsProductIdentifierCostEstimateGet(productIdentifier: string, xPlatformKey: string, currency?: string, countryCode?: string, stateCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCostEstimate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductsProductIdentifierCostEstimateGet(productIdentifier, xPlatformKey, currency, countryCode, stateCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.v2ProductsProductIdentifierCostEstimateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get product details.
         * @param {string} productIdentifier Uniquely identify the product by Guid or Slug
         * @param {string} xPlatformKey Select the platform.
         * @param {boolean} [includeEvent] Also return the event fields the product page shows, or null when the event is not published on the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ProductsProductIdentifierGet(productIdentifier: string, xPlatformKey: string, includeEvent?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ProductsProductIdentifierGet(productIdentifier, xPlatformKey, includeEvent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.v2ProductsProductIdentifierGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductsApi - factory interface
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get product by certificate number
         * @param {ProductsApiV2ProductsCertificateCertificateNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsCertificateCertificateNumberGet(requestParameters: ProductsApiV2ProductsCertificateCertificateNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductDetails> {
            return localVarFp.v2ProductsCertificateCertificateNumberGet(requestParameters.certificateNumber, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get products for a given published event. If no Id is provided then returns products for all published events. This endpoint will be deprecated at 2024-02-04
         * @param {ProductsApiV2ProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsGet(requestParameters: ProductsApiV2ProductsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Product>> {
            return localVarFp.v2ProductsGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.categorySlug, requestParameters.salesMethod, requestParameters.onlyReturnNotEnded, requestParameters.returnNotStarted, requestParameters.sortByCreateDate, requestParameters.sortProductsBy, requestParameters.minimumPrice, requestParameters.maximumPrice, requestParameters.currencyCode, requestParameters.productStatus, requestParameters.categoryIds, requestParameters.productTypeIds, requestParameters.productIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get match scored ball products for a category
         * @param {ProductsApiV2ProductsMatchScoredBallsCategoryCategoryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsMatchScoredBallsCategoryCategoryIdGet(requestParameters: ProductsApiV2ProductsMatchScoredBallsCategoryCategoryIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<MatchScoredBallsByCategory> {
            return localVarFp.v2ProductsMatchScoredBallsCategoryCategoryIdGet(requestParameters.categoryId, requestParameters.xPlatformKey, requestParameters.numberOfProducts, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get products for a given published event. If no Id is provided then returns products for all published events.
         * @param {ProductsApiV2ProductsPaginatedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsPaginatedGet(requestParameters: ProductsApiV2ProductsPaginatedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductListItemList> {
            return localVarFp.v2ProductsPaginatedGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.categorySlug, requestParameters.salesMethod, requestParameters.onlyReturnNotEnded, requestParameters.returnNotStarted, requestParameters.sortByCreateDate, requestParameters.sortProductsBy, requestParameters.minimumPrice, requestParameters.maximumPrice, requestParameters.currencyCode, requestParameters.productStatus, requestParameters.categoryIds, requestParameters.productTypeIds, requestParameters.productIds, requestParameters.productSlugs, requestParameters.onlyWithBids, requestParameters.excludeEventCategorySlug, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a product with its event and sibling products, tailored for AMP emails sent from CustomerIO.
         * @param {ProductsApiV2ProductsProductIdentifierAmpGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdentifierAmpGet(requestParameters: ProductsApiV2ProductsProductIdentifierAmpGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AmpProductDetails> {
            return localVarFp.v2ProductsProductIdentifierAmpGet(requestParameters.productIdentifier, requestParameters.currencyCode, requestParameters.maxExtraProducts, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductsApiV2ProductsProductIdentifierCostEstimateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdentifierCostEstimateGet(requestParameters: ProductsApiV2ProductsProductIdentifierCostEstimateGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductCostEstimate> {
            return localVarFp.v2ProductsProductIdentifierCostEstimateGet(requestParameters.productIdentifier, requestParameters.xPlatformKey, requestParameters.currency, requestParameters.countryCode, requestParameters.stateCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get product details.
         * @param {ProductsApiV2ProductsProductIdentifierGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdentifierGet(requestParameters: ProductsApiV2ProductsProductIdentifierGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductDetails> {
            return localVarFp.v2ProductsProductIdentifierGet(requestParameters.productIdentifier, requestParameters.xPlatformKey, requestParameters.includeEvent, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2ProductsCertificateCertificateNumberGet operation in ProductsApi.
 */
export interface ProductsApiV2ProductsCertificateCertificateNumberGetRequest {
    readonly certificateNumber: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for v2ProductsGet operation in ProductsApi.
 */
export interface ProductsApiV2ProductsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * Uniquely identify the event by Guid or Slug
     */
    readonly eventId?: string

    /**
     * Filter the products by category
     */
    readonly categorySlug?: string

    /**
     * Filter the products by sales method
     */
    readonly salesMethod?: SalesMethod

    /**
     * show only products that end date\&#39;s not past
     */
    readonly onlyReturnNotEnded?: boolean

    /**
     * Also return products that have not started yet
     */
    readonly returnNotStarted?: boolean

    /**
     * After priority score, should we sort it by date of creation
     */
    readonly sortByCreateDate?: boolean

    readonly sortProductsBy?: ProductSorting

    readonly minimumPrice?: number | null

    readonly maximumPrice?: number | null

    readonly currencyCode?: string

    readonly productStatus?: ProductStatus

    readonly categoryIds?: string

    readonly productTypeIds?: string

    readonly productIds?: string
}

/**
 * Request parameters for v2ProductsMatchScoredBallsCategoryCategoryIdGet operation in ProductsApi.
 */
export interface ProductsApiV2ProductsMatchScoredBallsCategoryCategoryIdGetRequest {
    readonly categoryId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly numberOfProducts?: number
}

/**
 * Request parameters for v2ProductsPaginatedGet operation in ProductsApi.
 */
export interface ProductsApiV2ProductsPaginatedGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * Uniquely identify the event by Guid or Slug
     */
    readonly eventId?: string

    /**
     * Filter the products by sales category
     */
    readonly categorySlug?: string

    /**
     * Filter the products by sales method
     */
    readonly salesMethod?: SalesMethod

    /**
     * show only products that end date\&#39;s not past
     */
    readonly onlyReturnNotEnded?: boolean

    /**
     * Also return products that have not started yet
     */
    readonly returnNotStarted?: boolean

    /**
     * After priority score, should we sort it by date of creation
     */
    readonly sortByCreateDate?: boolean

    readonly sortProductsBy?: ProductSorting

    readonly minimumPrice?: number | null

    readonly maximumPrice?: number | null

    readonly currencyCode?: string

    readonly productStatus?: ProductStatus

    readonly categoryIds?: string

    readonly productTypeIds?: string

    readonly productIds?: string

    /**
     * Comma separated list of product slugs to filter the products by
     */
    readonly productSlugs?: string

    /**
     * If true, only return listings that have at least one bid placed
     */
    readonly onlyWithBids?: boolean

    /**
     * If true, use categorySlug to exclude products whose event belongs to that category, instead of including products in that category
     */
    readonly excludeEventCategorySlug?: boolean

    /**
     * The amount of items to skip in the results
     */
    readonly offset?: number

    /**
     * Size of the requested page
     */
    readonly pageSize?: number
}

/**
 * Request parameters for v2ProductsProductIdentifierAmpGet operation in ProductsApi.
 */
export interface ProductsApiV2ProductsProductIdentifierAmpGetRequest {
    /**
     * Uniquely identify the product by Guid or Slug
     */
    readonly productIdentifier: string

    /**
     * When set, prices are narrowed to this currency at every level of the response
     */
    readonly currencyCode?: string

    readonly maxExtraProducts?: number | null
}

/**
 * Request parameters for v2ProductsProductIdentifierCostEstimateGet operation in ProductsApi.
 */
export interface ProductsApiV2ProductsProductIdentifierCostEstimateGetRequest {
    readonly productIdentifier: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly currency?: string

    readonly countryCode?: string

    readonly stateCode?: string
}

/**
 * Request parameters for v2ProductsProductIdentifierGet operation in ProductsApi.
 */
export interface ProductsApiV2ProductsProductIdentifierGetRequest {
    /**
     * Uniquely identify the product by Guid or Slug
     */
    readonly productIdentifier: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * Also return the event fields the product page shows, or null when the event is not published on the platform
     */
    readonly includeEvent?: boolean
}

/**
 * ProductsApi - object-oriented interface
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @summary Get product by certificate number
     * @param {ProductsApiV2ProductsCertificateCertificateNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductsCertificateCertificateNumberGet(requestParameters: ProductsApiV2ProductsCertificateCertificateNumberGetRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).v2ProductsCertificateCertificateNumberGet(requestParameters.certificateNumber, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get products for a given published event. If no Id is provided then returns products for all published events. This endpoint will be deprecated at 2024-02-04
     * @param {ProductsApiV2ProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductsGet(requestParameters: ProductsApiV2ProductsGetRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).v2ProductsGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.categorySlug, requestParameters.salesMethod, requestParameters.onlyReturnNotEnded, requestParameters.returnNotStarted, requestParameters.sortByCreateDate, requestParameters.sortProductsBy, requestParameters.minimumPrice, requestParameters.maximumPrice, requestParameters.currencyCode, requestParameters.productStatus, requestParameters.categoryIds, requestParameters.productTypeIds, requestParameters.productIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get match scored ball products for a category
     * @param {ProductsApiV2ProductsMatchScoredBallsCategoryCategoryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductsMatchScoredBallsCategoryCategoryIdGet(requestParameters: ProductsApiV2ProductsMatchScoredBallsCategoryCategoryIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).v2ProductsMatchScoredBallsCategoryCategoryIdGet(requestParameters.categoryId, requestParameters.xPlatformKey, requestParameters.numberOfProducts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get products for a given published event. If no Id is provided then returns products for all published events.
     * @param {ProductsApiV2ProductsPaginatedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductsPaginatedGet(requestParameters: ProductsApiV2ProductsPaginatedGetRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).v2ProductsPaginatedGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.categorySlug, requestParameters.salesMethod, requestParameters.onlyReturnNotEnded, requestParameters.returnNotStarted, requestParameters.sortByCreateDate, requestParameters.sortProductsBy, requestParameters.minimumPrice, requestParameters.maximumPrice, requestParameters.currencyCode, requestParameters.productStatus, requestParameters.categoryIds, requestParameters.productTypeIds, requestParameters.productIds, requestParameters.productSlugs, requestParameters.onlyWithBids, requestParameters.excludeEventCategorySlug, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a product with its event and sibling products, tailored for AMP emails sent from CustomerIO.
     * @param {ProductsApiV2ProductsProductIdentifierAmpGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductsProductIdentifierAmpGet(requestParameters: ProductsApiV2ProductsProductIdentifierAmpGetRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).v2ProductsProductIdentifierAmpGet(requestParameters.productIdentifier, requestParameters.currencyCode, requestParameters.maxExtraProducts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductsApiV2ProductsProductIdentifierCostEstimateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductsProductIdentifierCostEstimateGet(requestParameters: ProductsApiV2ProductsProductIdentifierCostEstimateGetRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).v2ProductsProductIdentifierCostEstimateGet(requestParameters.productIdentifier, requestParameters.xPlatformKey, requestParameters.currency, requestParameters.countryCode, requestParameters.stateCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get product details.
     * @param {ProductsApiV2ProductsProductIdentifierGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2ProductsProductIdentifierGet(requestParameters: ProductsApiV2ProductsProductIdentifierGetRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).v2ProductsProductIdentifierGet(requestParameters.productIdentifier, requestParameters.xPlatformKey, requestParameters.includeEvent, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RecommendationsApi - axios parameter creator
 */
export const RecommendationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deliberately not edge-cached: every answer is specific to one Dynamic Yield user. The no-store directive says so out loud, because a cache rule written for the sibling catalog endpoints would otherwise be free to treat this as heuristically cacheable and hand one shopper\'s recommendations to the next.
         * @summary Get the live listings Dynamic Yield campaigns recommend for a page, per campaign in the order asked for, each in the order Dynamic Yield ranked it. The caller picks the campaigns and describes the page; the page url, the visitor\'s identity and consent, and the Dynamic Yield options are decided here.
         * @param {string} xPlatformKey Select the platform.
         * @param {Array<string>} [selector] The campaigns\&#39; API selector names, passed to Dynamic Yield as-is, with recommendations per selector. Repeat it to ask for several campaigns in one call, at most 5. A selector no campaign answers to comes back with no recommendations.
         * @param {RecommendationPageType} [pageType] The type of page the recommendations sit on.
         * @param {Array<string>} [pageData] Passed to Dynamic Yield as-is: the listing id for a product page, the category slug for a category page, left out for the homepage.
         * @param {number} [numRecommendations] How many recommendations to return at most, from 1 to 20; a count outside that range is brought into it. Fewer come back when Dynamic Yield ranked fewer, or when what it ranked is no longer something a shopper can buy.
         * @param {string} [excludeListingId] A listing to leave out of the recommendations, such as the product page\&#39;s own.
         * @param {Array<string>} [previewIds] Dynamic Yield preview tokens, as the Experience OS console puts them in the &#x60;dyApiPreview&#x60; page url. Repeat it for several, at most 5. Lets Dynamic Yield also answer from the draft experiences they unlock, so a campaign\&#39;s variation can be checked without live traffic. Dynamic Yield answers a token it does not accept, such as an expired one, with a warning, which is logged here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2RecommendationsGet: async (xPlatformKey: string, selector?: Array<string>, pageType?: RecommendationPageType, pageData?: Array<string>, numRecommendations?: number, excludeListingId?: string, previewIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2RecommendationsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/recommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (selector) {
                localVarQueryParameter['selector'] = selector;
            }

            if (pageType !== undefined) {
                localVarQueryParameter['page_type'] = pageType;
            }

            if (pageData) {
                localVarQueryParameter['page_data'] = pageData;
            }

            if (numRecommendations !== undefined) {
                localVarQueryParameter['num_recommendations'] = numRecommendations;
            }

            if (excludeListingId !== undefined) {
                localVarQueryParameter['exclude_listing_id'] = excludeListingId;
            }

            if (previewIds) {
                localVarQueryParameter['preview_ids'] = previewIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecommendationsApi - functional programming interface
 */
export const RecommendationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecommendationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Deliberately not edge-cached: every answer is specific to one Dynamic Yield user. The no-store directive says so out loud, because a cache rule written for the sibling catalog endpoints would otherwise be free to treat this as heuristically cacheable and hand one shopper\'s recommendations to the next.
         * @summary Get the live listings Dynamic Yield campaigns recommend for a page, per campaign in the order asked for, each in the order Dynamic Yield ranked it. The caller picks the campaigns and describes the page; the page url, the visitor\'s identity and consent, and the Dynamic Yield options are decided here.
         * @param {string} xPlatformKey Select the platform.
         * @param {Array<string>} [selector] The campaigns\&#39; API selector names, passed to Dynamic Yield as-is, with recommendations per selector. Repeat it to ask for several campaigns in one call, at most 5. A selector no campaign answers to comes back with no recommendations.
         * @param {RecommendationPageType} [pageType] The type of page the recommendations sit on.
         * @param {Array<string>} [pageData] Passed to Dynamic Yield as-is: the listing id for a product page, the category slug for a category page, left out for the homepage.
         * @param {number} [numRecommendations] How many recommendations to return at most, from 1 to 20; a count outside that range is brought into it. Fewer come back when Dynamic Yield ranked fewer, or when what it ranked is no longer something a shopper can buy.
         * @param {string} [excludeListingId] A listing to leave out of the recommendations, such as the product page\&#39;s own.
         * @param {Array<string>} [previewIds] Dynamic Yield preview tokens, as the Experience OS console puts them in the &#x60;dyApiPreview&#x60; page url. Repeat it for several, at most 5. Lets Dynamic Yield also answer from the draft experiences they unlock, so a campaign\&#39;s variation can be checked without live traffic. Dynamic Yield answers a token it does not accept, such as an expired one, with a warning, which is logged here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2RecommendationsGet(xPlatformKey: string, selector?: Array<string>, pageType?: RecommendationPageType, pageData?: Array<string>, numRecommendations?: number, excludeListingId?: string, previewIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Recommendations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2RecommendationsGet(xPlatformKey, selector, pageType, pageData, numRecommendations, excludeListingId, previewIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.v2RecommendationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RecommendationsApi - factory interface
 */
export const RecommendationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecommendationsApiFp(configuration)
    return {
        /**
         * Deliberately not edge-cached: every answer is specific to one Dynamic Yield user. The no-store directive says so out loud, because a cache rule written for the sibling catalog endpoints would otherwise be free to treat this as heuristically cacheable and hand one shopper\'s recommendations to the next.
         * @summary Get the live listings Dynamic Yield campaigns recommend for a page, per campaign in the order asked for, each in the order Dynamic Yield ranked it. The caller picks the campaigns and describes the page; the page url, the visitor\'s identity and consent, and the Dynamic Yield options are decided here.
         * @param {RecommendationsApiV2RecommendationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2RecommendationsGet(requestParameters: RecommendationsApiV2RecommendationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Recommendations> {
            return localVarFp.v2RecommendationsGet(requestParameters.xPlatformKey, requestParameters.selector, requestParameters.pageType, requestParameters.pageData, requestParameters.numRecommendations, requestParameters.excludeListingId, requestParameters.previewIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2RecommendationsGet operation in RecommendationsApi.
 */
export interface RecommendationsApiV2RecommendationsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * The campaigns\&#39; API selector names, passed to Dynamic Yield as-is, with recommendations per selector. Repeat it to ask for several campaigns in one call, at most 5. A selector no campaign answers to comes back with no recommendations.
     */
    readonly selector?: Array<string>

    /**
     * The type of page the recommendations sit on.
     */
    readonly pageType?: RecommendationPageType

    /**
     * Passed to Dynamic Yield as-is: the listing id for a product page, the category slug for a category page, left out for the homepage.
     */
    readonly pageData?: Array<string>

    /**
     * How many recommendations to return at most, from 1 to 20; a count outside that range is brought into it. Fewer come back when Dynamic Yield ranked fewer, or when what it ranked is no longer something a shopper can buy.
     */
    readonly numRecommendations?: number

    /**
     * A listing to leave out of the recommendations, such as the product page\&#39;s own.
     */
    readonly excludeListingId?: string

    /**
     * Dynamic Yield preview tokens, as the Experience OS console puts them in the &#x60;dyApiPreview&#x60; page url. Repeat it for several, at most 5. Lets Dynamic Yield also answer from the draft experiences they unlock, so a campaign\&#39;s variation can be checked without live traffic. Dynamic Yield answers a token it does not accept, such as an expired one, with a warning, which is logged here.
     */
    readonly previewIds?: Array<string>
}

/**
 * RecommendationsApi - object-oriented interface
 */
export class RecommendationsApi extends BaseAPI {
    /**
     * Deliberately not edge-cached: every answer is specific to one Dynamic Yield user. The no-store directive says so out loud, because a cache rule written for the sibling catalog endpoints would otherwise be free to treat this as heuristically cacheable and hand one shopper\'s recommendations to the next.
     * @summary Get the live listings Dynamic Yield campaigns recommend for a page, per campaign in the order asked for, each in the order Dynamic Yield ranked it. The caller picks the campaigns and describes the page; the page url, the visitor\'s identity and consent, and the Dynamic Yield options are decided here.
     * @param {RecommendationsApiV2RecommendationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2RecommendationsGet(requestParameters: RecommendationsApiV2RecommendationsGetRequest, options?: RawAxiosRequestConfig) {
        return RecommendationsApiFp(this.configuration).v2RecommendationsGet(requestParameters.xPlatformKey, requestParameters.selector, requestParameters.pageType, requestParameters.pageData, requestParameters.numRecommendations, requestParameters.excludeListingId, requestParameters.previewIds, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SearchApi - axios parameter creator
 */
export const SearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary New endpoint for searching categories
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {CategoriesSearchType} [categorySearchType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchCategoriesGet: async (xPlatformKey: string, searchTerm?: string, offset?: number, pageSize?: number, categorySearchType?: CategoriesSearchType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2SearchCategoriesGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/search/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (categorySearchType !== undefined) {
                localVarQueryParameter['category_search_type'] = categorySearchType;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search events, products and categories
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm] 
         * @param {Array<SearchTypeFilter>} [types] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchGet: async (xPlatformKey: string, searchTerm?: string, types?: Array<SearchTypeFilter>, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2SearchGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (types) {
                localVarQueryParameter['types'] = types;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchApi - functional programming interface
 */
export const SearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary New endpoint for searching categories
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {CategoriesSearchType} [categorySearchType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2SearchCategoriesGet(xPlatformKey: string, searchTerm?: string, offset?: number, pageSize?: number, categorySearchType?: CategoriesSearchType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2SearchCategoriesGet(xPlatformKey, searchTerm, offset, pageSize, categorySearchType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.v2SearchCategoriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search events, products and categories
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm] 
         * @param {Array<SearchTypeFilter>} [types] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2SearchGet(xPlatformKey: string, searchTerm?: string, types?: Array<SearchTypeFilter>, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Search>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2SearchGet(xPlatformKey, searchTerm, types, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.v2SearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SearchApi - factory interface
 */
export const SearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchApiFp(configuration)
    return {
        /**
         * 
         * @summary New endpoint for searching categories
         * @param {SearchApiV2SearchCategoriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchCategoriesGet(requestParameters: SearchApiV2SearchCategoriesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryList> {
            return localVarFp.v2SearchCategoriesGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, requestParameters.categorySearchType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search events, products and categories
         * @param {SearchApiV2SearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchGet(requestParameters: SearchApiV2SearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Search> {
            return localVarFp.v2SearchGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.types, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2SearchCategoriesGet operation in SearchApi.
 */
export interface SearchApiV2SearchCategoriesGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly searchTerm?: string

    readonly offset?: number

    readonly pageSize?: number

    readonly categorySearchType?: CategoriesSearchType
}

/**
 * Request parameters for v2SearchGet operation in SearchApi.
 */
export interface SearchApiV2SearchGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly searchTerm?: string

    readonly types?: Array<SearchTypeFilter>

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * SearchApi - object-oriented interface
 */
export class SearchApi extends BaseAPI {
    /**
     * 
     * @summary New endpoint for searching categories
     * @param {SearchApiV2SearchCategoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2SearchCategoriesGet(requestParameters: SearchApiV2SearchCategoriesGetRequest, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).v2SearchCategoriesGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, requestParameters.categorySearchType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search events, products and categories
     * @param {SearchApiV2SearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2SearchGet(requestParameters: SearchApiV2SearchGetRequest, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).v2SearchGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.types, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SitemapApi - axios parameter creator
 */
export const SitemapApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SitemapsCategoriesGet: async (xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2SitemapsCategoriesGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/sitemaps/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SitemapsEventsGet: async (xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2SitemapsEventsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/sitemaps/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SitemapsEventsHistoricalGet: async (xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2SitemapsEventsHistoricalGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/sitemaps/events/historical`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SitemapsProductsCuratedHistoricalGet: async (xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2SitemapsProductsCuratedHistoricalGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/sitemaps/products/curated/historical`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SitemapsProductsGet: async (xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2SitemapsProductsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/v2/sitemaps/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SitemapApi - functional programming interface
 */
export const SitemapApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SitemapApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2SitemapsCategoriesGet(xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sitemap>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2SitemapsCategoriesGet(xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitemapApi.v2SitemapsCategoriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2SitemapsEventsGet(xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sitemap>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2SitemapsEventsGet(xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitemapApi.v2SitemapsEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2SitemapsEventsHistoricalGet(xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sitemap>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2SitemapsEventsHistoricalGet(xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitemapApi.v2SitemapsEventsHistoricalGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2SitemapsProductsCuratedHistoricalGet(xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sitemap>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2SitemapsProductsCuratedHistoricalGet(xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitemapApi.v2SitemapsProductsCuratedHistoricalGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2SitemapsProductsGet(xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sitemap>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2SitemapsProductsGet(xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitemapApi.v2SitemapsProductsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SitemapApi - factory interface
 */
export const SitemapApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SitemapApiFp(configuration)
    return {
        /**
         * 
         * @param {SitemapApiV2SitemapsCategoriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SitemapsCategoriesGet(requestParameters: SitemapApiV2SitemapsCategoriesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Sitemap>> {
            return localVarFp.v2SitemapsCategoriesGet(requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SitemapApiV2SitemapsEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SitemapsEventsGet(requestParameters: SitemapApiV2SitemapsEventsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Sitemap>> {
            return localVarFp.v2SitemapsEventsGet(requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SitemapApiV2SitemapsEventsHistoricalGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SitemapsEventsHistoricalGet(requestParameters: SitemapApiV2SitemapsEventsHistoricalGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Sitemap>> {
            return localVarFp.v2SitemapsEventsHistoricalGet(requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SitemapApiV2SitemapsProductsCuratedHistoricalGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SitemapsProductsCuratedHistoricalGet(requestParameters: SitemapApiV2SitemapsProductsCuratedHistoricalGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Sitemap>> {
            return localVarFp.v2SitemapsProductsCuratedHistoricalGet(requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SitemapApiV2SitemapsProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SitemapsProductsGet(requestParameters: SitemapApiV2SitemapsProductsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Sitemap>> {
            return localVarFp.v2SitemapsProductsGet(requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2SitemapsCategoriesGet operation in SitemapApi.
 */
export interface SitemapApiV2SitemapsCategoriesGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for v2SitemapsEventsGet operation in SitemapApi.
 */
export interface SitemapApiV2SitemapsEventsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for v2SitemapsEventsHistoricalGet operation in SitemapApi.
 */
export interface SitemapApiV2SitemapsEventsHistoricalGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for v2SitemapsProductsCuratedHistoricalGet operation in SitemapApi.
 */
export interface SitemapApiV2SitemapsProductsCuratedHistoricalGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for v2SitemapsProductsGet operation in SitemapApi.
 */
export interface SitemapApiV2SitemapsProductsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * SitemapApi - object-oriented interface
 */
export class SitemapApi extends BaseAPI {
    /**
     * 
     * @param {SitemapApiV2SitemapsCategoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2SitemapsCategoriesGet(requestParameters: SitemapApiV2SitemapsCategoriesGetRequest, options?: RawAxiosRequestConfig) {
        return SitemapApiFp(this.configuration).v2SitemapsCategoriesGet(requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SitemapApiV2SitemapsEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2SitemapsEventsGet(requestParameters: SitemapApiV2SitemapsEventsGetRequest, options?: RawAxiosRequestConfig) {
        return SitemapApiFp(this.configuration).v2SitemapsEventsGet(requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SitemapApiV2SitemapsEventsHistoricalGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2SitemapsEventsHistoricalGet(requestParameters: SitemapApiV2SitemapsEventsHistoricalGetRequest, options?: RawAxiosRequestConfig) {
        return SitemapApiFp(this.configuration).v2SitemapsEventsHistoricalGet(requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SitemapApiV2SitemapsProductsCuratedHistoricalGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2SitemapsProductsCuratedHistoricalGet(requestParameters: SitemapApiV2SitemapsProductsCuratedHistoricalGetRequest, options?: RawAxiosRequestConfig) {
        return SitemapApiFp(this.configuration).v2SitemapsProductsCuratedHistoricalGet(requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SitemapApiV2SitemapsProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2SitemapsProductsGet(requestParameters: SitemapApiV2SitemapsProductsGetRequest, options?: RawAxiosRequestConfig) {
        return SitemapApiFp(this.configuration).v2SitemapsProductsGet(requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
}



